import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { TextField, Button, Box, Paper } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './index.styles';
import Boxlayout from './box-layout';
import LabelTemplate from './labelTemplate';
import randomized from 'randomatic';
import assignmentstatus from './assignment-status';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DialogContentText from '@mui/material/DialogContentText';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { toast } from 'react-toastify';
import FormHelperText from '@mui/material/FormHelperText';
import PlayArrow from '@mui/icons-material/PlayArrow';
import PrintTemplate from 'react-print';
import EVENT_TYPES from '../common/event-type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EventLogHandler from '../common/event-log-handler';
import DemoData from '../common/demo-data';
import CONNECTION_TYPE from '../common/connection-type';
import { navigate } from '@reach/router';
import spinner from './images/spinner.gif';
import checked from './images/checked.png';
import cl from './images/cl.gif';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import OtherIcon from '@mui/icons-material/DevicesOther';
import LOCATION_TYPE from '../enum/location_type';
import DEVICE_TYPE from '../enum/device_type';
import Manualconsultation from './Manual-consultation';
import InputAdornment from '@mui/material/InputAdornment';
import MagnifyIcon from '@mui/icons-material/Search';
import curbsideIcon from '../iLocal-Delivery-Icons/Curbside.svg';
import counterIcon from '../iLocal-Delivery-Icons/Counter.svg';
import inpatientIcon from '../iLocal-Delivery-Icons/Bedside.svg';
import courierIcon from '../iLocal-Delivery-Icons/Courier.svg';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import NumberFormat from 'react-number-format';
import BOX_TYPE from '../enum/box_type';
import io from 'socket.io-client';
import TablePagination from '@mui/material/TablePagination';
import PatientManulOverride from '../common/patient_manual_override';
import './index.css';
import { withTranslation } from 'react-i18next';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import CloseIcon from '@mui/icons-material/Close';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PhoneInput from '../common/PhoneInput';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import userroles from '../common/userroles';
const rxData = require('./assets/rxData').default;

const localeTheme = createTheme(
  {},
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR
);

let searchedRxItems = [];
let searchedRxNumbers = [];
let nums = Array.from(Array(5).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C', 'D', 'E'];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
let rxMaxLength = null;
function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix='$'
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={'.'}
      fixedDecimalScale={true}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props &&
      this.props.onRequestSort &&
      this.props.onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      isVisibleForPause,
      className,
      t,
    } = this.props;
    const rows = [
      {
        id: 'rxNo',
        numeric: false,
        disablePadding: true,
        label: t('Assign.PrescriptionID'),
      },
      {
        id: 'fillNumber',
        numeric: false,
        disablePadding: true,
        label: t('Assign.FillID'),
      },
      {
        id: 'PrescriptionNumber',
        numeric: false,
        disablePadding: true,
        label: t('Assign.PrescriptionNumber'),
      },
      {
        id: 'OrderId',
        numeric: false,
        disablePadding: true,
        label: t('Assign.OrderID'),
      },
      {
        id: 'TranactionId',
        numeric: false,
        disablePadding: true,
        label: sessionStorage.getItem('accountConnectionId') === CONNECTION_TYPE.QS1 ? t('Assign.SequnceNo') : t('Assign.TransactionID'),
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: true,
        label: t('Assign.DrugName'),
      },
      {
        id: 'ndcCode',
        numeric: false,
        disablePadding: true,
        label: t('Assign.NDCCode'),
      },
      {
        id: 'qty',
        numeric: false,
        disablePadding: true,
        label: t('Assign.Qty'),
      },
      {
        id: 'AmountDue',
        numeric: false,
        disablePadding: true,
        label: t('Assign.AmountDue'),
      },
      {
        id: 'consultrequire',
        numeric: false,
        disablePadding: true,
        label: t('Assign.ConsultRequired'),
      },
      {
        id: 'isreturnable',
        numeric: false,
        disablePadding: true,
        label: t('Assign.IsReturnable'),
      },
    ];

    return (
      <TableHead>
        <TableRow style={{ height: '56px' }}>
          {!isVisibleForPause && (
            <TableCell padding={'none'}>
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
                style={{ color: '#4fc3f7' }}
              />
            </TableCell>
          )}
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === row.id ? order : false}
                className={className}
                style={{
                  ...(row.label === 'Amount Due'
                    ? { width: '300px' }
                    : { width: '150px' }),
                }}
              >
                <Tooltip
                  title={t('Global.Label.Filter.Sort')}
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  className: PropTypes.object.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    backgroundColor: theme.palette.secondary.main,
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#4ff7c1',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
  deletePrimaryButton: {
    background: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    /* add,  deleteUsers, editUser, viewUser, */ confirmDelete,
    t,
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color='inherit' variant='subheading'>
            {numSelected} {t('Assign.SelectedRow')}
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected === 1 && (
          <div>
            <Tooltip key='single-delete' title={t('Assign.DeleteTooltip')}>
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                className={classes.deletePrimaryButton}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
        {numSelected > 1 && (
          <Tooltip key='multi-delete' title={t('Assign.DeleteTooltip')}>
            <IconButton
              aria-label='Delete'
              onClick={confirmDelete}
              className={classes.deletePrimaryButton}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const legend = [
  { color: "linear-gradient(155deg, rgb(212,209,0) 0%, rgb(255,255,189) 90%)", label: "Assigned" },
  { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(4, 144, 243) 90%)", label: "Hold" },
  { color: "linear-gradient(155deg, rgb(23,166,0) 0%, rgb(196,255,189) 90%)", label: "Stocked" },
  { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)", label: "Deactivate" },
];
export class AssignPrescriptions extends Component {
  constructor(props) {
    super(props);
    this.ClearFields();
    this.state = {
      rxDetails: rxData,
      selectedBinId: '',
      openMessage: false,
      disableFeild: false,
      stockCode: '',
      pickupCode: '',
      searchedRxNo: [],
      prescriptionMasterData: {},
      rxNumber: '',
      selected: [],
      box: [],
      hasError: false,
      box_id: localStorage.getItem('selectedLocation'),
      pharmacyDetails: {},
      accountDetails: {},
      BinStatus: [],
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      loader: false,
      expansionUnits: [],
      box_expansions_id: '',
      isLoadingTrans: false,
      isADACompatible: false,
      ConsultRequire: false,
      is_returnable: false,
      isAmountPaid: false,
      locationtype_id: localStorage.getItem('selectedLocationTypeId'),
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      EmailID: '',
      phone: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      AccountConnections: [],
      location: '',
      isUnplugged: false,
      accountConnectionsLoginId: '',
      boxDetails: [],
      globalAccountConnection: {},
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      storage_location: '',
      location_notes: '',
      searchedItems: [],
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      orderIds: [],
      prescriptionIds: [],
      isEdit: false,
      indexNo: null,
      binid: null,
      pmid: null,
      page: 0,
      rowsPerPage: 10,
      isManualOverrideOpen: false,
      printDialogOpen: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedAccountIdForPrescriptionCheck: null,
      doesPrescriptionScanned: false,
      selectedPMSType: "",
      confirmPMSDialogOpen: false,
      scannedRxScript: "",
      originalScannedScript: "",
      boxTypeId: '',
      allow_multi_bins_pickup: false,
      FutureRelease: false,
      showDatePopup: false,
      FutureReleaseDate: null,
      selectedBox: '',
      patientNotes: '',
      readOnly: true,
      isBinDeactivated: false,
      alternateAgents: [],
      makeFastlaneAPICall: false,
      is_controlled_substance: false,
      servePresFetchCount: 0,
      servePresRetryCount: 3, // Max 3 times retrieval
      doesBinClicked: false,
      confirmPhantomRemoval: false,
      isManualOverridePermissionEnabled: true,
      prescriptionUnAssign: true,
      prescriptionAssign: true,
      prescriptionView: true,
      prescriptionDirectPickup: true,
      prescriptionRemind: true,
      prescriptionConsult: true,
      prescriptionHoldResume: true,
      prescriptionAcDc: true,
    };
    this.textInput = React.createRef();
  }

  initSocket = async (authToken) => {
    if (!this.socket && this.user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(
        `${process.env.REACT_APP_VIDEO_SOCKET_BASEURL}/console-socket`,
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          },
          secure: true,
        }
      );

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
          if (
            error.message === 'TokenExpiredError' ||
            error.message === 'JsonWebTokenError' ||
            error.message === 'NoTokenFound'
          ) {
            console.log('Token issue!');
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });
    }
  };

  componentWillUnmount() {
    this.socket && this.socket.disconnect();
    this.socket = false;
  }

  async componentDidMount() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    !this.socket && (await this.initSocket());
    this.handleFocus();
    this.setPermission();
  }

  getAllBoxes = (id) => {
    fetch(process.env.REACT_APP_BASEURL + "getBoxesById/" + id, {
      method: "get",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data && data.length > 0) {
          let tmp = data.map((val) => {
            return {
              id: val.id,
              value: val.name,
              brandName: val.brandName,
              brandPhone: val.brandPhone,
              ...val,
            };
          });
          let AddressLine1 = "",
            AddressLine2 = "",
            City = "",
            State = "",
            Zip = "",
            Country = "";
          let locationTypeDetails = data.filter((x) => x.location_type_id === id);
          let locationDetails = locationTypeDetails.filter((x) => x.id === (x.location_type_id === LOCATION_TYPE.Kiosk ? localStorage.getItem("selectedLocation") : data && data[0].id))[0];
          if (
            ![undefined, "undefined", null, "null", ""].includes(
              locationDetails
            )
          ) {
            AddressLine1 = locationDetails.address_line_1 || "";
            AddressLine2 = locationDetails.address_line_2 || "";
            City = locationDetails.city || "";
            State = locationDetails.state || "";
            Zip = locationDetails.zip || "";
            Country = locationDetails.country || "";
          }
          this.setState((prevState) => ({ 
            boxDetails: tmp,
            boxTypeId: data && data[0].type_id,
            assignedPrescription:
              (data && data[0].location_type_id) === LOCATION_TYPE.Kiosk
                ? data[0]
                : [],
            box_id: id === LOCATION_TYPE.Kiosk ? localStorage.getItem("selectedLocation") : data && data[0].id,
            selectedBox: data && data[0],
            searchedItems: {
              ...prevState.searchedItems,
              AddressLine1: AddressLine1,
              AddressLine2: AddressLine2,
              City: City,
              State: State,
              Zip: Zip,
              Country: Country,
            },
          }));
          this.getBoxes();
        }
      }).catch((error) => {
        this.getAllBoxes(id);
        this.setState({ loader: false });
      });
  };

  getBoxes(value) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          const boxesResponse = response.json();
          return boxesResponse;
        } catch (error) {
          return null;
        }
      })
      .then((boxtypes) => {
        if (boxtypes) {
          this.setState({ boxdata: boxtypes });
          const boxTypes = boxtypes.map((type) => {
            return {
              id: type.id,
              label: type.name,
              accountId: type.parent_account_id,
            };
          });
          if (boxtypes.length > 0) {
            if (value === 0) {
              const defaultSelectedBoxId = boxTypes[0].id;
              if (this.state.box_id === null) {
                this.setState({ box_id: boxTypes[0].id });
              }
              this.getAssignedBins(defaultSelectedBoxId);
              this.getPharmacyDetails(defaultSelectedBoxId);
              this.getExpansionBins(defaultSelectedBoxId);
            } else {
              this.getAssignedBins(this.state && this.state.box_id);
              this.getPharmacyDetails(this.state && this.state.box_id);
              this.getExpansionBins(this.state && this.state.box_id);
            }
          }
          this.setState({ boxTypes, printDialogOpen: false, loader: false });
        } else {
          this.setState({ loader: false });
        }
      }).catch((error) => {
        this.setState({ loader: false });
        this.getBoxes(value);
      });
  }

  getLocationTypes = () => {
    fetch(process.env.REACT_APP_BASEURL + 'locationtypes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((locationtypes) => {
        if (locationtypes) {
          const locationtypesdata = [];
          let newLocationtypes = [
            ...new Set(locationtypes && locationtypes.map((obj) => obj.name)),
          ].map((name) => {
            return (
              locationtypes && locationtypes.find((obj) => obj.name === name)
            );
          });
          for (let i = 0; i < newLocationtypes.length; i++) {
            if (
              newLocationtypes[i].id !==
              '5e94cb81-ab9b-4e82-8b98-721a2d1794df' &&
              newLocationtypes[i].id !==
              'fd7c6330-8b9a-45e2-a1f6-f791db65f5d0' &&
              newLocationtypes[i].id !== 'ee98b36c-a0e9-4cc4-a411-6c925ad442b6'
            ) {
              let tmp = {};
              tmp = {
                id: newLocationtypes[i].id,
                label: this.props.t(newLocationtypes[i].name_es),
                ...newLocationtypes[i],
              };
              locationtypesdata.push(tmp);
            }
          }
          this.setState({ 
            locationtype: locationtypesdata,
            locationtype_id: localStorage.getItem('selectedLocationTypeId')
          }, () => {
            this.getAllBoxes(this.state.locationtype_id)
          });
        }
      }).catch(() => {
        this.getLocationTypes();
        this.setState({ loader: false });
      });
  };

  componentWillMount() {
    searchedRxItems = [];
  }

  GetAcccountConnectionId = () => {
    this.setState({ loader: true });
    fetch(`${process.env.REACT_APP_BASEURL}getConnection`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accountConnectionsId) => {
        this.setState({ loader: false });
        if (accountConnectionsId) {
          this.setState({ globalAccountConnection: accountConnectionsId });
          if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id ===
            CONNECTION_TYPE.UNPLUGGED
          ) {
            navigate('/home/prescription/unpluggedassign');
          }
          else if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id === CONNECTION_TYPE.QS1
          ) {
            rxMaxLength = 12;
          } else if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id ===
            CONNECTION_TYPE.ILOCALBOX_PHARMACY
          ) {
            rxMaxLength = 6 || 7;
          }
          if (
            accountConnectionsId &&
            accountConnectionsId.account_connections_id &&
            accountConnectionsId.account_connections_id !==
            CONNECTION_TYPE.UNPLUGGED
          ) {
            setTimeout(() => {
              this.textInput &&
                this.textInput.current &&
                this.textInput.current.focus &&
                this.handleFocus();
            }, 3000);
          }
        } else {
          rxMaxLength = 6 || 7;
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  generateCodes() {
    const _stockCode = JSON.parse(localStorage.getItem("openpath")) || JSON.parse(localStorage.getItem("isNumericCode"))
      ? randomized("0", 4)
      : randomized("A0", 6, { exclude: "0oOiIlL1&zZ" });
    const _pickupCode = JSON.parse(localStorage.getItem("openpath")) || JSON.parse(localStorage.getItem("isNumericCode"))
      ? randomized("0", 4)
      : randomized("A0", 6, { exclude: "0oOiIlL1&zZ" });
    setTimeout(() => {
      this.checkIfCodesExists({
        stockCode: _stockCode,
        pickupCode: _pickupCode,
      });
    }, 100);
  }

  isValidRx(rxno) {
    let customer = this.state.rxDetails.filter((element) =>
      element.orders.some((order) =>
        order.items.some((item) => {
          const trulyValue =
            item.rxNo.toString().toLowerCase() ===
            rxno.toString().toLowerCase();
          if (!trulyValue) {
            return false;
          }
          return trulyValue;
        })
      )
    );
    return customer.length;
  }

  fetchTransactions = (requestParams) => {
    this.setState({ isLoadingTrans: true });
    let tran = {};
    if (requestParams) {
      fetch(process.env.REACT_APP_BASEURL + 'qs/rxTransactions', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(requestParams),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          this.setState({ isLoadingTrans: false });
          tran = JSON.parse(res);
          let rxDetails = tran.rxdetails;
          searchedRxItems.map((i, index) => {
            /*-----Start Modification----- */
            /*
              Modified By: Belani Jaimin
              Modified Date: 01/22/2020
              Description: Check weather Zero is Exist or not as first character. If yes then do not add padded Zero as prefix else add Zero for QS1
            */
            // let _firstCharZero = this.state && this.state.rxNumber.charAt(0); //
            let RxNumber = rxDetails.RxNumber;
            
            // if (_firstCharZero === 0 || _firstCharZero === '0') {
            //   if (this.state && this.state.rxNumber.length === 12) {
            //     RxNumber =
            //       this.state &&
            //       this.state.rxNumber.slice(
            //         0,
            //         this.state && this.state.rxNumber.length - 4
            //       );
            //   } else {
            //     RxNumber = this.state.rxNumber;
            //   }
            // } else {
            //   RxNumber = '0' + this.state.rxNumber;
            // }

            /*-----End Modification----- */
            // Removed By : Belani Jaimin
            // Date: 01/22/2020
            // Description: Removed because It was appending 2 zeros before Rx Number.
            // let RxNumber = '0' + this.state.rxNumber
            if (RxNumber.length > 8) {
              RxNumber = RxNumber.substr(4, RxNumber.length - 8);
            }
            if (i.rxNo === RxNumber) {
              searchedRxItems[index].ndcCode =
                (rxDetails && rxDetails.NDC) || '';
              searchedRxItems[index].CoPayAmount = (rxDetails && rxDetails.isPlanAvailable) === true ? (rxDetails && rxDetails.PrimaryPriceAmount) : (rxDetails && rxDetails.CopayAmount);
              searchedRxItems[index].qty =
                (rxDetails && rxDetails.QuantityDispensed) || 0;
              searchedRxItems[index].isLoadingTrans = false;
              searchedRxItems[index].SeqNumber =
                (rxDetails && rxDetails.SeqNumber) || 0;
              searchedRxItems[index].fillNumber =
                (rxDetails && rxDetails.FillNumber) || 0;  
            }
            return true;
          });
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
          this.forceUpdate();
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  onChange = (event) => {
    const patientId =
      this.state &&
      this.state.searchedItems &&
      this.state.searchedItems.PatientID;
    const searchedString = event.target.value;
    this.setState({
      isEdit: false,
      doesPrescriptionScanned: true,
      rxNumber: searchedString && searchedString,
    });
    if (
      searchedString.toString().toUpperCase().length > 0 &&
      searchedString.toString().toUpperCase().length >= rxMaxLength
    ) {
      let isValid = this.isValidRx(searchedString);
      if (isValid > 0) {
        fetch(
          process.env.REACT_APP_BASEURL + 'checkrxexistornot/' + searchedString,
          {
            method: 'GET',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
            },
          }
        )
          .then((response) => response.json())
          .then((boxes) => {
            if (boxes && !boxes.Rx_Is_Exist) {
              const data = this.state.rxDetails;
              if (this.state.searchedRxNo.length === 0) {
                this.state.rxDetails.filter((element) =>
                  element.orders.some((order) =>
                    order.items.some((items) => {
                      const trulyValue =
                        items.rxNo.toString().toUpperCase() ===
                        searchedString.toString().toUpperCase();
                      if (trulyValue) {
                        searchedRxItems.push(items);
                        this.setState({
                          searchedItems: element,
                          EmailID: element.EmailID,
                        });
                        this.checkADACompatible(
                          element.PatientID,
                          this.state && this.state.EmailID
                        );
                        if (searchedString.toString().length === rxMaxLength) {
                          this.setState({
                            searchedRxNo: [
                              ...this.state.searchedRxNo,
                              searchedString.toString().length ===
                              rxMaxLength && searchedString,
                            ],
                          });
                        }
                        this.setState({
                          rxNumber: '',
                        });
                        this.handleFocus();
                      }
                      return trulyValue;
                    })
                  )
                );
              } else {
                this.state.searchedRxNo.forEach((item) => {
                  // current rxNo
                  const rxno = this.state.rxNumber.toString().toUpperCase();
                  let currentRxObj = [];
                  data.filter((element) =>
                    element.orders.filter((order) =>
                      order.items.some((items) => {
                        if (items.rxNo.toString().toUpperCase() === rxno) {
                          currentRxObj = element;
                          this.setState({ EmailID: element.EmailID });
                          this.checkADACompatible(
                            element.PatientID,
                            this.state && this.state.EmailID
                          );
                        }
                        return true;
                      })
                    )
                  );

                  if (
                    this.state.searchedItems.PatientID !==
                    currentRxObj.PatientID &&
                    currentRxObj.PatientID !== undefined
                  ) {
                    toast.error(this.props.t('Toast.Error.WrongPatient'));
                    this.setState({
                      rxNumber: '',
                    });
                    this.handleFocus();
                  } else {
                    if (searchedString !== item) {
                      data.filter((element) =>
                        element.orders.some((order) =>
                          order.items.some((items) => {
                            const trulyValue =
                              items.rxNo.toString().toUpperCase() ===
                              searchedString.toString().toUpperCase() &&
                              patientId === element.PatientID;
                            if (trulyValue) {
                              var test = false;
                              for (var i = 0; i < searchedRxItems.length; i++) {
                                if (
                                  searchedRxItems[i].rxNo
                                    .toString()
                                    .toUpperCase() ===
                                  searchedString.toString().toUpperCase()
                                ) {
                                  test = true;
                                }
                              }
                              if (!test) {
                                searchedRxItems.push(items);
                                this.setState({ searchedItems: element });
                                this.setState({ EmailID: element.EmailID });
                                this.checkADACompatible(
                                  element.PatientID,
                                  this.state && this.state.EmailID
                                );
                                if (
                                  searchedString.toString().length ===
                                  rxMaxLength
                                ) {
                                  this.setState({
                                    searchedRxNo: [
                                      ...this.state.searchedRxNo,
                                      searchedString.toString().length ===
                                      rxMaxLength && searchedString,
                                    ],
                                  });
                                }
                              }
                              this.setState({
                                rxNumber: '',
                              });
                              this.handleFocus();
                            }
                            return trulyValue;
                          })
                        )
                      );
                    }
                  }
                });
              }
              this.setState({ readOnly: false });
            } else {
              this.setState({
                rxNumber: '',
              });
              this.handleFocus();
              toast.error(this.props.t('Toast.Error.RxAssigned'));
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A11' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        //Assign single Rx for Patient
        if (this.state.searchedRxNo.length === 0) {
          var patient = DemoData.randomPatient();
          patient.EmailID =
            (this.state.accountDetails &&
              this.state.accountDetails.demo_email) ||
            this.state.EmailID;
          patient.MobileNo =
            (this.state.accountDetails &&
              this.state.accountDetails.demo_phone) ||
            this.state.phone;
          var items = DemoData.randomRx();
          items.rxNo = searchedString;
          items.patientId = patient.PatientID;
          searchedRxItems.push(items);
          this.checkADACompatible(patient.PatientID, patient.EmailID);
          this.getcustomerLocation(patient, items, 'A11');
          this.setState({
            EmailID: patient.EmailID,
            phone: patient.MobileNo,
            alternateAgents: patient.alternateAgents,
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            rxNumber: '',
            readOnly: false,
          });
          this.handleFocus();
        } else if (this.state.searchedRxNo[0] === searchedString) {
          //Do nothing.
          this.setState({ readOnly: false })
        } else {
          toast.error(this.props.t('Toast.Error.WrongPatient'));
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      } else if (
        searchedString.substring(0, 3).toUpperCase() === 'A22' &&
        this.state.accountDetails.connection &&
        this.state.accountDetails.connection.id ===
        CONNECTION_TYPE.ILOCALBOX_PHARMACY
      ) {
        //Assign multi Rx for Patient
        const res3 = searchedRxItems.some((elm) => {
          if (
            elm.rxNo &&
            elm.rxNo.toUpperCase() === searchedString.toUpperCase()
          ) {
            return true;
          } else {
            return false;
          }
        });

        if (res3) {
          return;
        }
        if (this.state.searchedRxNo.length === 0) {
          var patient1 = DemoData.randomPatient();
          patient1.EmailID =
            this.state.accountDetails && this.state.accountDetails.demo_email;
          patient1.MobileNo =
            this.state.accountDetails && this.state.accountDetails.demo_phone;
          this.setState({
            EmailID: patient1.EmailID,
            phone: patient1.MobileNo,
            alternateAgents: patient1.alternateAgents,
          });
          var items1 = DemoData.randomRx();
          items1.rxNo = searchedString;
          items1.patientId = patient1.PatientID;
          items1.name =
            items1.name +
            ' ' +
            Math.floor(Math.random() * 100 + 1) +
            randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
          searchedRxItems.push(items1);
          this.checkADACompatible(patient1.PatientID, patient1.EmailID);
          this.getcustomerLocation(patient1, items1, 'A22');
          this.setState({
            searchedRxNo: [
              ...this.state.searchedRxNo,
              searchedString.toString().length === rxMaxLength &&
              searchedString,
            ],
            readOnly: false,
          });
          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        } else {
          var patient2 = this.state.searchedItems;
          const res = this.state.rxDetails.some((element) => {
            if (element.PatientID === patient2.PatientID) {
              return true;
            } else {
              return false;
            }
          });

          const res2 = searchedRxItems.some((elm) => {
            if (elm.rxNo.substring(0, 3).toUpperCase() === 'A11') {
              return true;
            } else {
              return false;
            }
          });

          if (!res && !res2) {
            var orderItems = this.state.searchedItems.orders[0];
            var items2 = DemoData.randomRx();
            items2.patientId = patient2.PatientID;
            items2.rxNo = searchedString;
            items2.name =
              items2.name +
              ' ' +
              Math.floor(Math.random() * 100 + 1) +
              +randomized(' ', 1, { exclude: '0oOiIlL1&zZ' });
            items2.ndcCode =
              Math.floor(Math.random() * 100000 + 1) +
              '-' +
              Math.floor(Math.random() * 1000 + 1);
            searchedRxItems.push(items2);
            orderItems && orderItems.items && orderItems.items.push && orderItems.items.push(items2);
            patient2.orders[0] = orderItems;

            this.setState({ searchedItems: patient2 });
            this.setState({ EmailID: patient2.EmailID, alternateAgents: (patient && patient.alternateAgents) || (patient2 && patient2.alternateAgents) });
            this.checkADACompatible(
              patient2.PatientID,
              this.state && this.state.EmailID
            );
            if (searchedString.toString().length === rxMaxLength) {
              this.setState({
                searchedRxNo: [
                  ...this.state.searchedRxNo,
                  searchedString.toString().length === rxMaxLength &&
                  searchedString,
                ],
                readOnly: false,
              });
            }
          } else {
            toast.error(this.props.t('Toast.Error.WrongPatient'));
          }

          this.setState({
            rxNumber: '',
          });
          this.handleFocus();
        }
      }
    }
    let unique = [...new Set(searchedRxItems)];
    searchedRxItems = [];
    searchedRxItems = unique;
  };

  checkADACompatible = (PatientID, EmailID) => {
    this.setState({ loader: true });
    let patientObj = {
      PatientID: PatientID,
      EmailID: EmailID,
    };
    fetch(process.env.REACT_APP_BASEURL + 'getADACompatiblePatients', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(patientObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((Pdata) => {
        if (Pdata && Pdata.ADAcustomers && Pdata.ADAcustomers.length > 0) {
          this.setState({
            ADAData: Pdata.ADAcustomers,
            isADACompatible: true,
            loader: false
          });
        } else {
          this.setState({ ADAData: [], isADACompatible: false, loader: false });
        }
      })
      .catch((error) => {
        toast.error(JSON.stringify(error));
        this.setState({ loader: false });
      });
  };
  getSelectedBin = (binId, position, flag) => {
    const { deactivatedBins } = this.state;
    if (deactivatedBins.includes(binId)) {
      this.setState({
        isBinDeactivated: true,
        selectedBinId: binId,
        box_position: position,
        isSelectedFlag: flag,
      });
    } else {
      this.setState({
        isBinDeactivated: false,
        selectedBinId: binId,
        box_position: position,
        isSelectedFlag: flag,
      });
    }
  };

  /*
      Added By : Belani Jaimin
      Added Date : 02/11/2019
      Description : Get Bin Status
    */
  getAssignedBins = (box_id) => {
    this.setState({ loader: true });
    let _binStatus = [];
    if (box_id) {
      fetch(process.env.REACT_APP_BASEURL + 'binsbybox/' + box_id, {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((bins) => {
          this.setState({ loader: false });
          let deactivatedBins;
          _binStatus = JSON.parse(bins);
          if (_binStatus && _binStatus[0] && _binStatus[0].disabled_bins) {
            deactivatedBins = _binStatus[0].disabled_bins.toString().split(',');
            this.setState({ deactivatedBins: deactivatedBins });
          } else {
            this.setState({ deactivatedBins: [] });
          }
          this.setState({ BinStatus: _binStatus });
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  getBoxesByID = (id) => {
    fetch(`${process.env.REACT_APP_BASEURL}boxes/${id}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        if (boxes.length > 0) {
          this.setState(
            {
              courier_type:
                boxes[0].courier_type && boxes[0].courier_type.length > 0
                  ? boxes[0].courier_type.map((val) => {
                    return val.courier_type;
                  })
                  : [],
              selectedBox: boxes && boxes[0]
            },
            () => {
              if (this.state.courier_type.length > 0) {
                this.setState({
                  default_courier_selected:
                    boxes[0].courier_type[0].default_courier_type,
                });
              }
            }
          );
          let search = this.state.searchedItems;
          if (search) {
            search.location_notes = '';
            search.location_notes = boxes[0].location_notes;
            this.setState({ searchedItems: search });
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleChange = async (event) => {
    const  { 
      boxDetails
    } = this.state;
    this.setState({ box_id: event.target.value })
    this.getExpansionBins(event.target.value);
    this.getAssignedBins(event.target.value);
    let AddressLine1 = '', 
    AddressLine2 = '', 
    City = '', 
    State = '', 
    Zip = '', 
    Country = '';
    let locationDetails = boxDetails.filter((x) => x.id === event.target.value)[0];
    if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
      AddressLine1 = locationDetails.address_line_1 || "";
      AddressLine2 = locationDetails.address_line_2 || "";
      City = locationDetails.city || "";
      State = locationDetails.state || "";
      Zip = locationDetails.zip || "";
      Country = locationDetails.country || "";
    }
    this.setState(prevState => ({
      searchedItems: {
        ...prevState.searchedItems,
        AddressLine1: AddressLine1,
        AddressLine2: AddressLine2,
        City: City,
        State: State,
        Zip: Zip,
        Country: Country
      }
    }));
  };

  handletypeChange = async (event) => {
    this.setState({
      locationtype_id: event.target.value,
    });
    this.getAllBoxes(event.target.value);
  };
  handleFutureChange = async (event) => {
    if (event.preventDefault) event.preventDefault();
    this.setState({
      FutureRelease: event.target.value
    })
    if (event.target.value) {
      this.setState({
        showDatePopup: true
      })
    }
  }
  handleFutureDateChange = async (event) => {
    if (event.start > new Date()) {
      this.setState({ FutureReleaseDate: event.start, showDatePopup: false });
    }
  }

  getPharmacyDetails(boxId) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((phrmacydetail) => {
        this.setState({ loader: false });
        this.setState({ pharmacyDetails: phrmacydetail && phrmacydetail[0], allow_multi_bins_pickup: (phrmacydetail && phrmacydetail[0] && phrmacydetail[0].allow_multi_bins_pickup) });
        const accountId = phrmacydetail && phrmacydetail[0].parent_account_id;
        this.getAccountDetails(accountId);
      })
      .catch((error) => {
        this.getPharmacyDetails(boxId);
        this.setState({ loader: false });
      });
  }

  //Added by Naresh | DI-329 | Date:27-05-2019
  getExpansionBins(boxId) {
    fetch(process.env.REACT_APP_BASEURL + 'box-expansions/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((expansionDetails) => {
        let order = 0;
        let UnitLayout = [];
        let UnitIndex = 0;
        if (expansionDetails && expansionDetails.length > 0) {
          //Add Left side Unit
          UnitLayout = [];
          if (expansionDetails.findIndex((x) => x.direction === 1) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 1) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = Math.abs(unit.box_position);
                  boxlist.pos = 'L';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                return true;
              });
          }
          if (UnitLayout.length > 0) {
            UnitLayout.reverse();
          }
          order = order + 1;
          UnitIndex = UnitIndex + 1;
          const boxesExpansions =
            expansionDetails &&
            expansionDetails.find((x) => x.box.id === boxId);
          if (boxesExpansions && boxesExpansions !== undefined) {
            if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M22
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M22',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M24
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M24',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.FASTLANE
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANE',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            }
          }
          //Add Right side Unit
          if (expansionDetails.findIndex((x) => x.direction === 2) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 2) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = unit.box_position;
                  boxlist.pos = 'R';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                return true;
              });
          }
        } else {
          order = order + 1;
          const boxes =
            this.state &&
            this.state.boxdata &&
            this.state.boxdata.length &&
            this.state.boxdata.length > 0 &&
            this.state.boxdata.find((x) => x.id === boxId);
          if (boxes && boxes !== undefined) {
            if (
              boxes &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M22
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M22',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M24
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M24',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.FASTLANE
            ) {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'FASTLANE',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            } else {
              UnitLayout.push({
                id: -1,
                order: order,
                pos: 'M',
                selectedUnitIndex: 0,
                box_position: 0,
              });
            }
          }
        }
        this.setState({ expansionUnits: UnitLayout });
      })
      .catch((error) => {
        console.error(error)
        this.getExpansionBins(boxId)
        this.setState({ loader: false });
      })
  }
  //End DI-329

  getAccountDetails(accountId) {
    this.setState({ loader: true });
    fetch(
      process.env.REACT_APP_BASEURL + 'account/' + accountId,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      },
      accountId
    )
      .then((response) => response.json())
      .then((accountdetail) => {
        this.setState({ loader: false });
        this.setState({ accountDetails: accountdetail && accountdetail[0] });
      }).catch(() => {
        this.getAccountDetails(accountId)
        this.setState({ loader: false });
      });
  }

  EventLogHanlder = (uData) => {
    let tofor_id = '';
    let descriptions = '';
    tofor_id =
      uData && uData.prescriptions_master && uData.prescriptions_master.id;
    descriptions =
      'Prescription is Assigned with stock code ' +
      this.state.stockCode +
      ' and pick up code ' +
      this.state.pickupCode +
      ' with Rx No ' +
      this.state.rxNumber;

    const event_params = {
      event_name: EVENT_CRUD_TYPES.INSERT,
      event_type_name: EVENT_TYPES.ASSIGNED,
      description: descriptions,
      object_id: assignmentstatus.ASSIGNED,
      tofor_id: tofor_id,
      box_id: this.state.box_id,
    };
    new EventLogHandler().handleEventLog(event_params);
  };

  courierTrackingHandler = (evt) => {
    this.setState({ courier_tracking: evt.target.value });
  };

  checkBoxHandler = (value) => {
    this.setState({ default_courier_selected: value });
  };

  getCartRxNumbers = () => {
    const { accountDetails } = this.state;
    searchedRxNumbers = [];
    searchedRxItems.map((item) => {
      if (item) {
        if (
          accountDetails &&
          accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS
        ) {
          searchedRxNumbers.push(item.prescriptionnumber);
        } else {
          searchedRxNumbers.push(item.rxNo || item.rx_no);
        }
      }
      return true;
    });
  };

  openAllBin() {
    let Ids = [];
    nums1.forEach((n1) => {
      nums.forEach((n) => {
        if ((elem[n] === 'B' || elem[n] === 'C') && n1 >= 0 && n1 <= 6) {
        } else {
          if (elem[n] === 'A') {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else if (elem[n] === 'B' && n1 >= 7 && n1 <= 11) {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else if (elem[n] === 'C' && n1 >= 7 && n1 <= 11) {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else {
            Ids.push(elem[n] + '' + (n1 + 1));
          }
        }
      });
    });

    const filteredArray = this.sortArray(Ids);
    for (let index = 0; index < filteredArray.length; index++) {
      const element = filteredArray[index];
      var items = document.getElementById(element);
      items.style.background =
        'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)';
      items.style.color = '#000';
    }
  }

  sortArray(Ids) {
    var reA = /[^a-zA-Z]/g;
    var reN = /[^0-9]/g;

    function sortAlphaNum(a, b) {
      var aA = a.replace(reA, '');
      var bA = b.replace(reA, '');
      if (aA === bA) {
        var aN = parseInt(a.replace(reN, ''), 10);
        var bN = parseInt(b.replace(reN, ''), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    }
    return Ids.sort(sortAlphaNum);
  }

  handleClose = () => {
    this.setState({ openMessage: false });
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({
        selected: searchedRxItems.map((n) => n.rxNo),
      }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: searchedRxItems.filter(
          (x) => x.itemId === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: searchedRxItems.filter(
          (x) => this.state.selected.indexOf(x.rxNo) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteItems();
    }
    this.setState({ deleteDialogOpen: false });
  };

  deleteItems = (event) => {
    const rowIdToDelete = this.state.forDeletion;
    if (rowIdToDelete.length === searchedRxItems.length) {
      searchedRxItems = [];
      this.setState({
        searchedRxNo: [],
        searchedItems: [],
        rxNumber: '',
        selected: [],
      });
      searchedRxItems = [];
      this.openAllBin();
    } else {
      for (var i = 0; i < rowIdToDelete.length; i++) {
        searchedRxItems = searchedRxItems.filter(
          // eslint-disable-next-line no-loop-func
          (x) => x.rxNo !== rowIdToDelete[i].rxNo
        );
      }
      this.setState({
        rxNumber: '',
        selected: [],
      });
      this.handleFocus();
    }
  };

  getPrescriptionDetails = (BinId, pm_id) => {
    if (![undefined, 'undefined', null, 'null', ''].includes(BinId)) {
      const { accountDetails, deactivatedBins } = this.state;
      if (deactivatedBins.includes(BinId)) {
        this.setState({ isEdit: true, binid: BinId, pmid: pm_id, indexNo: '' });
      } else {
        this.setState({ isEdit: true, binid: BinId, pmid: pm_id, indexNo: '', isBinDeactivated: false });
      }
      if (
        searchedRxItems &&
        searchedRxItems.length > 0 &&
        this.state &&
        this.state.doesPrescriptionScanned
      ) {
        let obj = {
          bin_id: BinId,
          box_id: this.state && this.state.box_id,
          account_id: accountDetails && accountDetails.id,
        };
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          },
          body: JSON.stringify(obj),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((res) => {
            if (res && res.statusCode === 409) {
              this.setState({
                isVerifyingBin: true,
                isVerifyingBinMessage:
                  'This bin is currently unavailable, please select another bin.',
                loader: false,
              });
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      } else {
        let isMScript = false;
        if (
          accountDetails &&
          accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS
        ) {
          isMScript = true;
        }
        if (BinId === null) {
          searchedRxItems = [];
          this.setState({
            searchedRxNo: [],
            searchedItems: [],
            rxNumber: '',
            selected: [],
          });
          this.handleFocus();
          searchedRxItems = [];
        } else {
          const boxId = this.state.box_id;
          this.getPharmacyDetails(boxId);
          const bin_info = {
            id: boxId,
            bin_id: BinId,
            pm_id: pm_id,
          };
          this.setState({ loader: true, reminderData: [] });
          fetch(process.env.REACT_APP_BASEURL + 'rxbybin', {
            method: 'POST',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(bin_info),
          })
            .then((response) => {
              try {
                return response.json();
              } catch (error) {
                return null;
              }
            })
            .then((data) => {
              this.setState({ loader: false, doesBinClicked: true });
              if (data) {
                searchedRxItems = [];
                this.setState({
                  reminderData: { bin_info: bin_info, data: data },
                });
                let permissions = JSON.parse(
                  sessionStorage.getItem("permissions")
                );
                let _checkUserRole = JSON.parse(
                  sessionStorage.getItem("permissionUser")
                );
                if (_checkUserRole === userroles.SUPERADMIN) {
                  this.setState({ isVisibleForPause: true });
                } else {
                  const assignPrescriptions = permissions.filter((item) => {
                    return (
                      item.permission_entity_type === "Assign Prescription"
                    );
                  });
                  if (assignPrescriptions.length > 0) {
                    const _isHoRu = assignPrescriptions.filter(
                      (x) =>
                        x.name.trim() === "Hold/Resume" && x.is_allowed === 1
                    );
                    // Hold/Resume
                    if (_isHoRu.length > 0) {
                      this.setState({ isVisibleForPause: true });
                    } else {
                      this.setState({ isVisibleForPause: false });
                    }
                  } else {
                    this.setState({ isVisibleForPause: false });
                  }
                }
                const details = data.response.box;
                if (details && details.customers.length > 0) {
                  const basicDetails = details && details.customers[0];
                  const orders = details && details.customers[0].orders[0];
                  const typeId = orders.type_id;
                  const stockcode = orders.stock_code;
                  const pickupcode = orders.pucode;
                  const rxItems = orders.items;
                  const orderId = details && details.customers[0].orders[0].id;
                  const rxNo =
                    details && details.customers[0].orders[0].items[0].rx_no;
                  const bindId = details && details.customers[0].orders[0].bin_id;
                  const contactDetails =
                    details && details.customers[0].contacts[0];
                  const locationDetails = orders && orders.customerLocations;
                  let codes = {
                    stockCode: orders.stock_code,
                    pickupCode: orders.pucode,
                  };
                  localStorage.setItem('label-codes', JSON.stringify(codes));
                  this.setState({
                    locationDetails: locationDetails,
                    basicDetails: basicDetails,
                    contactDetails: contactDetails,
                    PrintisCoolItem: orders['is_cool_item'],
                    FutureRelease: orders['is_future_release'],
                    FutureReleaseDate: new Date(orders['future_release_date']),
                    selectedBox: data && data.response && data.response.box,
                    alternateAgents: basicDetails.alternetAgents,
                  });
                  this.setState({
                    EmailID: isMScript ? 'N/A' : contactDetails.email,
                    phone: isMScript ? 'N/A' : contactDetails.phone,
                  });
                  let address1;
                  let address2;
                  let city;
                  let state;
                  let zip;
                  let country;
                  if (locationDetails.length > 0) {
                    const locationtypesdata = locationDetails.map((type) => {
                      if (type.locationtype_id === LOCATION_TYPE.Kiosk) {
                        return {
                          id: type.locationtype_id,
                          label: this.props.t('Assign.Kiosk'),
                        };
                      }
                      if (type.locationtype_id === LOCATION_TYPE.Home) {
                        return { id: type.locationtype_id, label: 'Home' };
                      }
                      if (type.locationtype_id === LOCATION_TYPE.Work) {
                        return { id: type.locationtype_id, label: 'Work' };
                      }
                      if (type.locationtype_id === LOCATION_TYPE.Courier) {
                        return { id: type.locationtype_id, label: 'Courier' };
                      }
                      if (type.locationtype_id === LOCATION_TYPE.Curbside) {
                        return { id: type.locationtype_id, label: 'Curb side' };
                      }
                      if (type.locationtype_id === LOCATION_TYPE.Counter) {
                        return { id: type.locationtype_id, label: 'Counter' };
                      }
                      if (type.locationtype_id === LOCATION_TYPE.Bedside) {
                        return { id: type.locationtype_id, label: 'Bedside' };
                      }
                      if (type.locationtype_id === LOCATION_TYPE.Other) {
                        return { id: type.locationtype_id, label: 'Other' };
                      }
                      return type;
                    });
                    this.setState({ locationtype: locationtypesdata });
                    if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                      const boxData = this.state.boxdata;
                      boxData.forEach((item) => {
                        if (this.state.box_id === item.id) {
                          address1 = item.address.address_line_1;
                          address2 = item.address.address_line_2;
                          city = item.address.city;
                          state = item.address.state;
                          zip = item.address.zip;
                          country = item.address.country;
                        }
                      });
                    } else {
                      locationDetails.forEach((type) => {
                        if (this.state.locationtype_id === type.locationtype_id) {
                          address1 = type.addressline1;
                          address2 = type.addressline2;
                          city = type.city;
                          state = type.state;
                          zip = type.zip;
                          country = type.country;
                        }
                      });
                    }
                  } else {
                    if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                      const locationtypesdata = [
                        {
                          id: this.state.locationtype_id,
                          label: this.props.t('Assign.Kiosk'),
                        },
                      ];
                      this.setState({ locationtype: locationtypesdata });
                      const boxData = this.state.boxdata;
                      boxData.forEach((item) => {
                        if (this.state.box_id === item.id) {
                          address1 = item.address.address_line_1;
                          address2 = item.address.address_line_2;
                          city = item.address.city;
                          state = item.address.state;
                          zip = item.address.zip;
                          country = item.address.country;
                        }
                      });
                    }
                  }
                  if (typeId === DEVICE_TYPE.Hold) {
                    this.setState({ isAlreadyOnHold: true });
                  } else {
                    this.setState({ isAlreadyOnHold: false });
                  }
                  if (typeId === DEVICE_TYPE.Assigned) {
                    this.setState({ isAlreadyAssigned: true });
                  } else {
                    this.setState({ isAlreadyAssigned: false });
                  }
                  if (typeId === DEVICE_TYPE.Stocked) {
                    this.setState({ is_stocked: true });
                  } else {
                    this.setState({ is_stocked: false });
                  }
                  this.setState({
                    searchedItems: {
                      FirstName: basicDetails.first_name,
                      LastName: basicDetails.last_name,
                      DateOfBirth: basicDetails.dob_str,
                      MobileNo: isMScript
                        ? 'N/A'
                        : this.state && this.state.phone,
                      EmailID: isMScript
                        ? 'N/A'
                        : this.state && this.state.EmailID,
                      AddressLine1: address1,
                      AddressLine2: address2,
                      City: city,
                      State: state,
                      Zip: zip,
                      Country: country,
                      isCoolItem: orders && orders.is_cool_item,
                      notes: basicDetails.notes
                    },
                    rxNumber: rxNo,
                    selectedBinId: bindId,
                    stockCode: stockcode,
                    pickupCode: pickupcode,
                    orderId: orderId,
                    patientNotes: basicDetails.notes,
                    readOnly: true,
                  });
                  searchedRxItems = rxItems;
                  this.getPaymentDetails(orderId, basicDetails.id);
                }
                this.getCartRxNumbers();
                this.setState({ assignedPrescription: data.response.box, disableFeild: true });
                this.forceUpdate();
              }
            }).catch(() => {
              this.setState({ loader: false });
            });
        }
      }
    }
  };

  GetFormattedDate(dob) {
    var tempDate = new Date(dob);
    var formattedDate = ('0' + tempDate.getUTCDate()).slice(-2);
    var formattedMonth = ('0' + (tempDate.getUTCMonth() + 1)).slice(-2);
    var formattedYears = tempDate.getUTCFullYear();
    var dateString =
      formattedMonth + '/' + formattedDate + '/' + formattedYears;
    return dateString;
  }
  sendOrederStatusEmail(reqDetails) {
    fetch(process.env.REACT_APP_BASEURL + 'emailHoldStatus', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    })
    .then((data) => { console.log(JSON.stringify(data, null, 2)) })
    .catch(() => {
      this.setState({ loader: false });
    });
  }
  changeOrderStatus(status) {
    this.setState({ loader: true });
    let bin_info;
    let reqDetails = {};
    if (status === 'pause') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Hold,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: true,
      };
      this.sendOrederStatusEmail(reqDetails);
    } else if (status === 'play') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Stocked,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: false,
      };
      this.sendOrederStatusEmail(reqDetails);
    } else if (status === 'remove') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.RemoveRx,
      };
    }

    fetch(process.env.REACT_APP_BASEURL + 'updateStatusOfRx', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bin_info),
    })
      .then((response) => {
        try {
          if (
            bin_info.type_id === assignmentstatus.REMOVE_RX &&
            response.status === 200
          ) {
            const event_params = {
              event_name: EVENT_CRUD_TYPES.UPDATE,
              event_type_name: EVENT_TYPES.REMOVE_RX,
              description:
                'Prescription is Remove with stock code ' +
                this.state.stockCode,
              object_id: assignmentstatus.REMOVE_RX,
              tofor_id: this.state.orderId,
              box_id: this.state.box_id,
            };
            new EventLogHandler().handleEventLog(event_params);
          }
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        this.setState({ loader: false });
        const { t } = this.props;
        if (status === 'pause') {
          toast.success(t('Prescriptions.Messages.OnHold'));
        } else if (status === 'play') {
          toast.success(t('Prescriptions.Messages.NotOnHold'));
        } else if (status === 'remove') {
          toast.success(t('Prescriptions.Messages.RemovedRx'));
        }
        if (status !== 'play') {
          searchedRxItems = [];
          this.setState({
            selectedBinId: '',
            searchedItems: [],
            rxNumber: '',
            // box_id: "",
            isVisibleForPause: false,
            EmailID: '',
            phone: '',
            makeFastlaneAPICall: true,
            stockCode: '',
            pickupCode: ''
          });
          searchedRxNumbers = [];
        }
        this.setState({ isAlreadyOnHold: false });
        this.handleFocus();
        this.getBoxes();
        this.setState({ makeFastlaneAPICall: false })
      }).catch(() => {
        this.setState({ loader: false });
      });
  }

  getSelectedUnitName = (index) => {
    if (index === 1) {
      this.setState({ selectedUnitName: 'L60 (Locker Addon with 60 bins)' });
    } else if (index === 2) {
      this.setState({ selectedUnitName: 'HD36 (Locker Addon with 36 bins)' });
    } else if (index === 3) {
      this.setState({ selectedUnitName: 'Cool (Temp Controlled with 8 bins)' });
    }  else if (index === 4) {
      this.setState({ selectedUnitName: 'C30 (C30 with 30 bins)' });
    } else {
      this.setState({ selectedUnitName: 'Locker (Main Unit with 46 bins)' });
    }
  };

  getFormattedExpiryDate(expirydate) {
    let parsedDate;
    if (
      expirydate !== '' &&
      expirydate !== 'null' &&
      expirydate !== null &&
      expirydate !== undefined &&
      expirydate !== 'undefined'
    ) {
      let ExpiryDateyear = expirydate.substr(0, 4);
      let ExpiryDatemonth = expirydate.substr(5, 2);
      let ExpiryDateday = expirydate.substr(8, 2);
      parsedDate = ExpiryDatemonth + '/' + ExpiryDateday + '/' + ExpiryDateyear;
    } else {
      parsedDate = '';
    }
    return parsedDate;
  }

  handleConsultrequire = (index) => {
    if (searchedRxItems && searchedRxItems.length > 0) {
      searchedRxItems[index].ConsultRequire = !searchedRxItems[index]
        .ConsultRequire;
      // searchedRxItems[index].is_consultrequire = !searchedRxItems[index].is_consultrequire;
      this.forceUpdate();
    }
  };

  handleIsReturnable = (index) => {
    if (searchedRxItems && searchedRxItems.length > 0) {
      searchedRxItems[index].IsReturnable = !searchedRxItems[index].IsReturnable;
      this.forceUpdate();
    }
  }

  handleEpicChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  getActualRx = (rxNumber) => {
    if(rxNumber.startsWith("\\")) {
        rxNumber = rxNumber.substr(4, rxNumber.length - 1);
    } else if(rxNumber.startsWith("RX")){
        rxNumber = rxNumber.substr(3, rxNumber.length - 1);
    }
    return rxNumber;
  };

  parseCoreflexScript = (scannedQR) => {
    let parsedCoreFlexObject = {};
    let _removeIlb = scannedQR.split('?');
    let _findRxs = _removeIlb[1].split('&');
    let _s = _findRxs[3].split('=')[1];
    parsedCoreFlexObject.key = _findRxs[0].split('=')[1];
    parsedCoreFlexObject.v = _findRxs[1].split('=')[1];
    parsedCoreFlexObject.d = _findRxs[2].split('=')[1];
    parsedCoreFlexObject.s = _s.split('#').filter((el) => el);
    return parsedCoreFlexObject;
  };

  verifyScriptIsCoreflexOrNotAndSaveEntryForHistory = async (scannedQR) => {
    // LEON Medical Coreflex Sample Script
    // ilb://?key=client&v=1.0&d=04/04/2020&s=10-1217253#10-1217254#
    let _parsedResponse = {};
    let _parsedRx = this.parseCoreflexScript(scannedQR);
    _parsedResponse.pharmacyNCPDPId = '';
    _parsedResponse.fillId = '';
    _parsedResponse.prescriptionNumber = _parsedRx.s;
    return _parsedResponse;
  };

  parseScannedQrCode = async (scannedQR, account_id) => {
    let _scannedQRCode = scannedQR;
    let _parsedResponse = {};
    if (scannedQR.length > 40) {
      if (scannedQR.startsWith('ilb') || scannedQR.includes('key')) {
        _parsedResponse = await this.verifyScriptIsCoreflexOrNotAndSaveEntryForHistory(
          scannedQR
        );
      } else {
        let arrayOfRxNumber = [];
        let splitByCarrotSign = _scannedQRCode.split('^');
        let actualRxNumber = this.getActualRx(splitByCarrotSign[0]);
        arrayOfRxNumber.push(actualRxNumber);
        _parsedResponse.prescriptionNumber = arrayOfRxNumber;
        _parsedResponse.pharmacyNCPDPId = splitByCarrotSign[splitByCarrotSign.length - 8];
        _parsedResponse.fillId = splitByCarrotSign[5];
        _parsedResponse.is_coreFlex = false;      
      }
    } else {
      _parsedResponse = await this.verifyScriptIsCoreflexOrNotAndSaveEntryForHistory(
        scannedQR
      );
    }
    console.log(
      `Parsed Response for EPIC script : ${JSON.stringify(
        _parsedResponse,
        null,
        2
      )}`
    );
    return _parsedResponse;
  };

  checkIfRxExistOrNot = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'epic/checkpoint/epic/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkResponse) => {
        if (checkResponse) {
          let parsedJsonResponse = JSON.parse(checkResponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  checkIfRxExistorNotForEpicWithmTLS = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'kp/epic/mtls/checkpoint/epic/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkresponse) => {
        if (checkresponse) {
          let parsedJsonResponse = JSON.parse(checkresponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  isRxExistInCart = async (searchedString, patientDetails, items) => {
    const { globalAccountConnection } = this.state;
    let connectionType;
    switch (globalAccountConnection.account_connections_id) {
      case CONNECTION_TYPE.EPIC:
        connectionType = 'Epic';
        break;
      case CONNECTION_TYPE.EPIC_WITH_MTLS:
        connectionType = 'Epic With MTLS';
        break;
      default:
        break;
    }
    let _existingPrescriptionNumbers = [];
    let existingRxNo = await this.parseScannedQrCode(searchedString);
    if (
      existingRxNo &&
      existingRxNo.prescriptionNumber &&
      existingRxNo.prescriptionNumber.length > 0
    ) {
      let _existingRxItems = existingRxNo.prescriptionNumber;
      for (let exist = 0; exist < _existingRxItems.length; exist++) {
        for (let si = 0; si < searchedRxItems.length; si++) {
          if (
            _existingRxItems[exist].trim() ===
            searchedRxItems[si].prescriptionNumber && existingRxNo.fillId === searchedRxItems[si].fillNumber
          ) {
            _existingPrescriptionNumbers.push(_existingRxItems[exist].trim());
          }
        }
      }
    }
    if (_existingPrescriptionNumbers.length > 0) {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers.join(
          ','
        )} are already exist in the cart!`,
      });
      return true;
    } else {
      let itemsdetail;
      let validRxScripts = this.validateRxFills(items);
      if (
        validRxScripts &&
        validRxScripts.validRxItems &&
        validRxScripts.validRxItems.length > 0
      ) {
        itemsdetail = validRxScripts.validRxItems;
      } else {
        itemsdetail = validRxScripts.inValidRxItems;
      }
      for (let i = 0; i < itemsdetail.length; i++) {
        searchedRxItems.push(itemsdetail[i]);
      }
      this.checkADACompatible(
        patientDetails.MedicalRecordNumber,
        patientDetails.EmailAddress
      );
      this.getcustomerLocation(patientDetails, itemsdetail, connectionType);
      this.forceUpdate();
      this.setState({
        rxNumber: '',
        loader: false,
      });
    }
  };

  isSamePatient = (patientDetails) => {
    const { searchedItems } = this.state;
    if (searchedItems.PatientID === patientDetails.MedicalRecordNumber) {
      this.setState({
        EmailID: patientDetails.EmailAddress,
        phone: patientDetails.MobilePhone,
      });
      return true;
    } else {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The scanned or entered prescription has different patient details. Please assign this prescription to any bin first then scan or enter another prescription!`,
      });
      return false;
    }
  };

  handleEpicKeyDown = (event) => {
    // if (event.keyCode === 13) {
      this.setState({
        loader: true,
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
        isEdit: false,
      });
      const { originalScannedScript } = this.state;
      let searchedString = originalScannedScript;
      let validItems = [];
      let items = [];
      let obj = {
        PrescriptionId: searchedString,
        account_id: this.state.accountDetails.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'epic/GetPrescriptionInfoById', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then(async (res) => {
          let parsedJsonResponse = JSON.parse(res);
          let parsedJson;
          if (parsedJsonResponse && parsedJsonResponse.message) {
            this.setState({
              loader: false,
              rxNumber: '',
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
            });
            return;
          }
          parsedJson = parsedJsonResponse.response;
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.prescriptions;
          if (prescriptionDetails.length <= 0) {
            toast.error(this.props.t('Toast.Error.Prescription'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              let _existingPrescriptionNumbers = [];
              if (
                prescriptionDetails &&
                prescriptionDetails.length &&
                prescriptionDetails.length > 0
              ) {
                for (let i = 0; i < prescriptionDetails.length; i++) {
                  let preacriptionNumber = prescriptionDetails[i].PrescriptionNumber.trim();
                  for (let si = 0; si < searchedRxItems.length; si++) {
                    let fillNumber = prescriptionDetails[i].Fill[i].Id;
                    if (
                      preacriptionNumber ===
                      searchedRxItems[si].prescriptionNumber && fillNumber === searchedRxItems[si].fillNumber
                    ) {
                      _existingPrescriptionNumbers.push(preacriptionNumber);
                    }
                  }
                }
              }
              if (
                _existingPrescriptionNumbers &&
                _existingPrescriptionNumbers.length &&
                _existingPrescriptionNumbers.length > 0
              ) {
                this.setState({
                  loader: false,
                  rxNumber: '',
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
                });
                return true;
              }
            }
          }
          for (let j = 0; j < prescriptionDetails.length; j++) {
            let isconsultrequired = false;
            let isreturnable = false;
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsConsultRequired === true
            ) {
              isconsultrequired = prescriptionDetails[j].IsConsultRequired;
            } else {
              isconsultrequired = false;
            }
            //check for isreturnable feild in fetched prescriptions
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsReturnable === true
            ) {
              isreturnable = prescriptionDetails[j].IsReturnable;
            } else {
              isreturnable = false;
            }
            for (let i = 0; i < prescriptionDetails[j].Fill.length; i++) {
              let item = {
                ndcCode: prescriptionDetails[j].Fill[i].Ndc,
                itemId: '',
                binId: '',
                rxNo: prescriptionDetails[j].Fill[i].PrescriptionId,
                name: prescriptionDetails[j].Medication,
                description: prescriptionDetails[j].Sig,
                image: '',
                potency: '',
                qty: prescriptionDetails[j].Fill[i].Quantity,
                schedule: prescriptionDetails[j].Frequency,
                Amount: prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                taxPercentage: '',
                insuranceAmount: '',
                CoPayAmount:
                  prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                PaidAmount: '',
                DueAmount: '',
                paymentDueDate: '',
                stockedOn: '',
                stockedBy: '',
                deStockedOn: '',
                strength: '',
                route: '',
                doseage_form: '',
                non_proprietary_name: '',
                ExpirationDate: '',
                isLoadingTrans: false,
                fillNumber: prescriptionDetails[j].Fill[i].Id,
                prescriptionNumber:
                  prescriptionDetails[j].Fill[i].PrescriptionNumber,
                ConsultRequire: isconsultrequired,
                IsReturnable: isreturnable,
                status: prescriptionDetails[j].Fill[i].Status,
                is_controlled_substance: prescriptionDetails[j].isControlledSubstances
              };
              let rxTransactionNumber = `${prescriptionDetails[j].Fill[i].PrescriptionId}-${prescriptionDetails[j].Fill[i].Id}`;
              if (
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'verified' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'readytodispense' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'intransit' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'received'
              ) {
                const isRxTrasactionNumberExist = await this.checkIfRxExistOrNot(
                  rxTransactionNumber
                );
                if (
                  isRxTrasactionNumberExist &&
                  isRxTrasactionNumberExist.result === true
                ) {
                  toast.error(isRxTrasactionNumberExist.error);
                  this.setState({
                    rxNumber: '',
                    loader: false,
                    EmailID: '',
                    phone: '',
                    isEpicHasValidRx: true,
                    isEpicHasValidRxMessage: '',
                  });
                  return;
                } else {
                  items.push(item);
                  if (
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'verified' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'readytodispense' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'intransit' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'received'
                  ) {
                    validItems.push(prescriptionDetails[j].Fill[i]);
                  }
                  if (validItems.length > 0) {
                    prescriptionDetails[j].Fill[i] = validItems;
                  }
                }
              } else {
                items.push(item);
              }
            }
          }
          if (items && items.length === 0) {
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              this.isRxExistInCart(searchedString, patientDetails, items);
            }
          } else {
            this.setState({
              EmailID: patientDetails.EmailAddress,
              phone: patientDetails.MobilePhone,
            });
            let RxItems = this.validateRxFills(items);
            if (
              RxItems &&
              RxItems.validRxItems &&
              RxItems.validRxItems.length > 0
            ) {
              searchedRxItems = RxItems.validRxItems;
            } else {
              searchedRxItems = RxItems.inValidRxItems;
              let errorArray = [];
              if (searchedRxItems && searchedRxItems.length > 0) {
                for (
                  let invalid = 0;
                  invalid < searchedRxItems.length;
                  invalid++
                ) {
                  errorArray.push({ Status: searchedRxItems[invalid].status });
                }
                this.setState({
                  loader: false,
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The status of the prescription
                  should be Verified, ReadyToDispense, Received or InTransit but the ${errorArray && errorArray.length > 1
                      ? 'statuses are'
                      : 'status is'
                    } ${errorArray &&
                    errorArray.map((x) => x.Status).join(', ')}`,
                });
              }
            }
            this.checkADACompatible(
              patientDetails.MedicalRecordNumber,
              patientDetails.EmailAddress
            );
            this.getcustomerLocation(patientDetails, searchedRxItems, 'Epic');
            this.forceUpdate();
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            loader: false,
            rxNumber: '',
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
          });
          return;
        });
    // }
  };

  validateRxFills = (items) => {
    let _validRxItemArray = [];
    let _inValidRxItemArray = [];
    let validatedRxFills = {};
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        if (
          items[i].status.toLowerCase() === 'verified' ||
          items[i].status.toLowerCase() === 'readytodispense' ||
          items[i].status.toLowerCase() === 'received' ||
          items[i].status.toLowerCase() === 'intransit'
        ) {
          _validRxItemArray.push(items[i]);
        } else {
          _inValidRxItemArray.push(items[i]);
        }
      }
    }
    validatedRxFills.validRxItems = _validRxItemArray;
    validatedRxFills.inValidRxItems = _inValidRxItemArray;
    return validatedRxFills;
  };

  getDueAmount = () => {
    let orderAmount = 0;
    for (let i = 0; i < searchedRxItems.length; i++) {
      if (
        !isNaN(
          parseFloat(searchedRxItems[i].CoPayAmount) ||
          parseFloat(searchedRxItems[i].price)
        )
      ) {
        let amount =
          parseFloat(searchedRxItems[i].CoPayAmount) ||
          parseFloat(searchedRxItems[i].price);
        orderAmount = orderAmount + amount;
      }
    }
    return `$${orderAmount.toFixed(2)}`;
  };

  getPaymentDetails = (orderId, customerId) => {
    this.setState({ loader: true });
    fetch(
      `${process.env.REACT_APP_BASEURL}payments/validate-payment?order_id=${orderId}&customer_id=${customerId}`,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ isAmountPaid: data.res, loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };
  getcustomerLocation = (patient, items, type) => {
    const { 
      phone, 
      EmailID, 
      boxDetails 
    } = this.state;
    let parsedDob = '', 
    AddressLine1 = '', 
    AddressLine2 = '', 
    City = '', 
    State = '', 
    Zip = '', 
    Country = '', 
    phoneNumber = '', 
    emailAddress = '',
    boxId = this.state.box_id;
    this.generateCodes();
    let locationDetails = boxDetails.filter((x) => x.id === boxId)[0];
    if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
      AddressLine1 = locationDetails.address_line_1 || "";
      AddressLine2 = locationDetails.address_line_2 || "";
      City = locationDetails.city || "";
      State = locationDetails.state || "";
      Zip = locationDetails.zip || "";
      Country = locationDetails.country || "";
    }
    if (type === 'Epic' || type === 'Epic With MTLS') {
      parsedDob = patient.DateOfBirth.substr(5, 2) + '/' + patient.DateOfBirth.substr(8, 2) + '/' + patient.DateOfBirth.substr(0, 4);
      phoneNumber = phone;
      emailAddress = EmailID;
      if (patient.EmailAddress === '' || EmailID === '') {
        toast.error(this.props.t('Toast.Error.EnterEmail'));
        this.setState({ loader: false });
      }
      if (patient.MobilePhone === '' || phone === '') {
        toast.error(this.props.t('Toast.Error.EnterMobile'));
        this.setState({ loader: false });
      }
    } else if (type === 'Pioneer') {
      parsedDob = patient.dateOfBirth.substr(5, 2) + '/' + patient.dateOfBirth.substr(8, 2) + '/' + patient.dateOfBirth.substr(0, 4);
      phoneNumber = phone;
      emailAddress = EmailID;
    } else if (type === 'Medbank') {
      parsedDob = patient.dob_str || patient.dateOfBirth;
      phoneNumber = phone;
      emailAddress = EmailID;
    } else if (type === 'MScripts') {
      parsedDob = patient.dob_str || patient.dateOfBirth || patient.dob;
      phoneNumber = 'N/A';
      emailAddress = 'N/A'
    } else if (type === 'McKesson') {
      parsedDob = patient.DateOfBirth
      phoneNumber = patient.MobilePhoneWithoutAreaCode;
      emailAddress = patient.EmailAddress;
    } else if (type === 'LIBERTYSOFTWARE') {
      parsedDob = patient.dob_str;
      phoneNumber = patient.phone;
      emailAddress = patient.email;
    }  else if (type === 'HL7') {
      parsedDob = patient.dob_str || patient.dateOfBirth || patient.dob;
    } else if(type === 'DRX') {
      parsedDob = patient.dob.substr(5, 2) + '/' + patient.dob.substr(8, 2) + '/' + patient.dob.substr(0, 4);
      phoneNumber = patient.phone;
      emailAddress = patient.email;
    }else {
      parsedDob = patient.DateOfBirth;
      phoneNumber = phone;
      emailAddress = EmailID;
    }
    const basicDetails = {
      first_name: patient.FirstName,
      last_name: patient.LastName,
      dob_str: patient.DateOfBirth,
    };
    const contactDetails = {
      phone: phoneNumber,
      email: emailAddress,
    };
    this.setState({
      locationtype_id: localStorage.getItem('selectedLocationTypeId'),
      box_id: boxId,
      searchedItems: {
        PatientID: patient.PatientID || patient.MedicalRecordNumber || patient.patient_id || patient.patientID || patient.ExternalPatientID,
        FirstName: patient.FirstName || patient.first_name || patient.firstName,
        LastName: patient.LastName || patient.last_name || patient.lastName,
        MiddleName: patient.MiddleName || null,
        DateOfBirth: parsedDob,
        MobileNo: phoneNumber,
        EmailID: emailAddress,
        AddressLine1: AddressLine1,
        AddressLine2: AddressLine2,
        City: City,
        State: State,
        Zip: Zip,
        Country: Country,
        notes: (patient && patient.notes) || '',
        orders: [{ items: items }],
      },
      patientNotes: (patient && patient.notes),
      basicDetails: basicDetails,
      contactDetails: contactDetails
    });
  };

  reminderHandler = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'reminder/notification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.state.reminderData),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ searchedRxNo: [] });
          toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
        }
        try {
          return response.text();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((uData) => {
        this.setState({ loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  textInputHandler = (type, value) => {
    this.setState({ [type]: value });
  };

  ManualPickupNotification = (type) => {
    let reqDetails = {
      box_id: this.state.box_id,
      pucode: this.state.pickupCode,
      emailID:
        this.state.searchedItems.EmailID || (this.state && this.state.EmailID),
      firstName: this.state.searchedItems.FirstName,
      lastName: this.state.searchedItems.LastName,
      AccountName: this.state.accountDetails && this.state.accountDetails.name,
      AccountAddress:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.address_line_1 +
        ' ' +
        this.state.accountDetails.contact.address.address_line_2 +
        ' ',
      AccountAddress2:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.city +
        ', ' +
        this.state.accountDetails.contact.address.state +
        ' ' +
        this.state.accountDetails.contact.address.zip,
    };
    if (type === 1) {
      this.changeOrderStatus('remove');
    }
    if (type === 2) {
      this.changeOrderStatus('pause');
    }
    if (type === 3) {
      this.changeOrderStatus('play');
    }
    fetch(process.env.REACT_APP_BASEURL + 'emailPickupNotification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ searchedRxNo: [] });
          toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
        }
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.getBoxes();
        searchedRxItems = [];
        searchedRxNumbers = [];
        this.setState({
          selectedBinId: '',
          searchedItems: [],
          rxNumber: '',
        });
        this.handleFocus();
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  ClearFields = () => {
    searchedRxItems = [];
    searchedRxNumbers = [];
    this.setState({
      selectedBinId: '',
      openMessage: false,
      disableFeild: false,
      stockCode: '',
      pickupCode: '',
      searchedRxNo: [],
      prescriptionMasterData: {},
      rxNumber: '',
      selected: [],
      box: [],
      hasError: false,
      box_id: '',
      pharmacyDetails: {},
      accountDetails: {},
      BinStatus: [],
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      loader: false,
      expansionUnits: [],
      box_expansions_id: '',
      isLoadingTrans: false,
      isADACompatible: false,
      ConsultRequire: false,
      is_returnable: false,
      isAmountPaid: false,
      locationtype_id: '',
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      EmailID: '',
      phone: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      AccountConnections: [],
      location: '',
      isUnplugged: false,
      accountConnectionsLoginId: '',
      boxDetails: [],
      globalAccountConnection: {},
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      storage_location: '',
      location_notes: '',
      searchedItems: [],
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      basicDetails: undefined,
      isEdit: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedAccountIdForPrescriptionCheck: null,
      doesPrescriptionScanned: false,
      selectedPMSType: "",
      confirmPMSDialogOpen: false,
      scannedRxScript: "",
      originalScannedScript: "",
      boxTypeId: '',
      allow_multi_bins_pickup: false,
      FutureRelease: false,
      FutureReleaseDate: null,
      patientNotes: '',
      readOnly: true,
      isBinDeactivated: false,
      alternateAgents: [],
      doesBinClicked: false,
      confirmPhantomRemoval: false,
      isManualOverridePermissionEnabled: true,
      prescriptionUnAssign: true,
      prescriptionAssign: true,
      prescriptionView: true,
      prescriptionDirectPickup: true,
      prescriptionRemind: true,
      prescriptionConsult: true,
      prescriptionHoldResume: true,
      prescriptionAcDc: true,
    });
    this.GetAcccountConnectionId();
    this.getLocationTypes();
    this.setPermission();
  };

  onInputChange = (event) => {
    const { searchedItems } = this.state;
    searchedItems[event.target.name] = event.target.value;
    this.setState({ [event.target.name]: event.target.value, searchedItems });
  };
  handleConsultClick = () => {
    this.setState({ detailDialogOpen: true });
  };

  handleConsultClose = () => {
    this.setState({ detailDialogOpen: false });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  onSearchChange = (event) => {
    const searchString = event.target.value;
    this.setState({
      searchObj: { ...this.state.searchObj, searchTxt: searchString },
    });
    if (searchString.length > 2) {
      this.FetchSearchResult();
    } else {
      searchedRxItems = [];
      searchedRxNumbers = [];
      this.setState({
        selectedBinId: '',
        searchedItems: [],
        rxNumber: '',
        isVisibleForPause: false,
        EmailID: '',
        phone: '',
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
      });
    }
  };

  FetchSearchResult = () => {
    let FilterObj = {
      searchtext: this.state.searchObj.searchTxt,
      pageNo: this.state.searchObj.pageNo,
      pageSize: this.state.searchObj.pageSize,
      sortOrder: this.state.searchObj.sortOrder,
    };
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getPrescriptionSearchResult', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(FilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({
          totalSearchRecords: uData && uData['total'],
          loader: false,
          innerSearchLoader: false,
        });
        if (
          uData &&
          Array.isArray(uData['results']) &&
          uData['results']['length'] > 0
        ) {
          if (uData['results']['length'] === 1) {
            let BinId = uData['results'][0].bin_id;
            let pm_id = uData['results'][0].pm_id;
            this.getPrescriptionDetails(BinId, pm_id);
          } else
            this.setState({
              selectedObject: uData['results'],
              SearchResultDialogOpen: true,
            });
        } else {
          searchedRxItems = [];
          searchedRxNumbers = [];
          this.setState({
            selectedBinId: '',
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            EmailID: '',
            phone: '',
            isEpicHasValidRx: true,
            isEpicHasValidRxMessage: '',
            SearchResultDialogOpen: false,
            innerSearchLoader: false,
            searchObj: { pageNo: 0, pageSize: 10, sortOrder: 'desc' },
          });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleSearchClose = (event) => {
    event.preventDefault();
    this.setState({
      SearchResultDialogOpen: false,
      selectedObject: [],
      innerSearchLoader: false,
      searchObj: { searchTxt: '', pageNo: 0, pageSize: 10, sortOrder: 'desc' },
    });
  };

  handlePUcodeClick = (event, BinId, pm_id, boxid) => {
    event.preventDefault();
    this.getPharmacyDetails(boxid);
    this.getExpansionBins(boxid);
    this.getAssignedBins(boxid);
    this.setState({ box_id: boxid });
    setTimeout(() => {
      this.handleSearchClose(event);
      this.getPrescriptionDetails(BinId, pm_id);
    }, 100);
  };

  handleMedBankChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleMedBankKeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      let isRxExist = false;
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        rxNumber: searchedString,
      };
      fetch(`${process.env.REACT_APP_BASEURL}medbank/is-exist`, {
        method: 'post',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedResponse = JSON.parse(res);
          isRxExist = parsedResponse.Rx_Is_Exist;
          if (isRxExist === false || isRxExist === 'false') {
            let obj = {
              lookupValue: searchedString,
              account_id: globalAccountConnection.id,
            };
            fetch(
              process.env.REACT_APP_BASEURL +
              'medbank/GetPrescriptionByPrescriptionNumber',
              {
                crossDomain: true,
                method: 'post',
                headers: {
                  Authorization:
                    'Bearer ' +
                    JSON.parse(sessionStorage.getItem('user')).signInUserSession
                      .idToken.jwtToken,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(obj),
              }
            )
              .then((response) => {
                try {
                  return response.text();
                } catch (error) {
                  return null;
                }
              })
              .then((res) => {
                let parsedJson = JSON.parse(res);
                let patientDetails = parsedJson.patient;
                let prescriptionDetails = parsedJson.Rxs;
                if (prescriptionDetails && prescriptionDetails.length === 0) {
                  toast.error(this.props.t('Toast.Error.RxFound'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                  return;
                }
                let isreturnable = false
                for (let i = 0; i < prescriptionDetails.length; i++) {
                  if (
                    prescriptionDetails[i] &&
                    prescriptionDetails[i].IsReturnable === true
                  ) {
                    isreturnable = prescriptionDetails[i].IsReturnable;
                  } else {
                    isreturnable = false;
                  }
                  let item = {
                    ndcCode: prescriptionDetails[i].dispensedNDC,
                    itemId: '',
                    binId: '',
                    rxNo: prescriptionDetails[i].PrescriptionNumber,
                    name: prescriptionDetails[i].dispensedDrugName,
                    description: prescriptionDetails[i].dispensedDrugName,
                    image: '',
                    potency: '',
                    qty: prescriptionDetails[i].prescribedQuantity,
                    schedule: '',
                    Amount: prescriptionDetails[i].dispensedAmount,
                    taxPercentage: '',
                    insuranceAmount: '',
                    CoPayAmount: prescriptionDetails[i].dispensedAmount,
                    PaidAmount: '',
                    DueAmount: '',
                    paymentDueDate: '',
                    stockedOn: '',
                    stockedBy: '',
                    deStockedOn: '',
                    strength: '',
                    route: '',
                    doseage_form: '',
                    non_proprietary_name: '',
                    ExpirationDate: '',
                    isLoadingTrans: false,
                    fillNumber: prescriptionDetails[i].fillNumber,
                    prescriptionNumber:
                      prescriptionDetails[i].PrescriptionNumber,
                    ConsultRequire: prescriptionDetails[i].promptForCounseling,
                    IsReturnable: isreturnable,
                    status: '',
                  };
                  const existingItem = this.state.searchedItems;
                  const EmailAddress =
                    (patientDetails && patientDetails.email) ||
                    (patientDetails &&
                      patientDetails.contacts &&
                      patientDetails.contacts[0] &&
                      patientDetails.contacts[0].email);
                  const CellPhone =
                    (patientDetails && patientDetails.sms_phone) ||
                    (patientDetails &&
                      patientDetails.contacts &&
                      patientDetails.contacts[0] &&
                      patientDetails.contacts[0].phone);
                  this.setState({ EmailID: EmailAddress, phone: CellPhone });
                  if (
                    existingItem &&
                    searchedRxItems &&
                    searchedRxItems.length > 0
                  ) {
                    let isexist = searchedRxItems.findIndex(
                      (x) => x.rxNo === searchedString
                    );
                    if (existingItem.PatientID === patientDetails.patientID) {
                      if (isexist < 0) {
                        searchedRxItems.push(item);
                        if (
                          patientDetails &&
                          patientDetails.patientID &&
                          EmailAddress
                        ) {
                          this.checkADACompatible(
                            patientDetails.patientID,
                            EmailAddress
                          );
                        }
                        this.getcustomerLocation(
                          patientDetails,
                          searchedRxItems,
                          'Medbank'
                        );
                        this.setState({
                          rxNumber: '',
                        });
                        this.forceUpdate();
                      } else {
                        toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                      }
                    } else {
                      toast.error(this.props.t('Toast.Error.WrongPatient'));
                      this.setState({
                        rxNumber: '',
                        loader: false,
                      });
                    }
                  } else {
                    searchedRxItems.push(item);
                    if (
                      patientDetails &&
                      patientDetails.patientID &&
                      EmailAddress
                    ) {
                      this.checkADACompatible(
                        patientDetails.patientID,
                        EmailAddress
                      );
                    }
                    this.getcustomerLocation(
                      patientDetails,
                      searchedRxItems,
                      'Medbank'
                    );
                    this.forceUpdate();
                    this.setState({
                      rxNumber: '',
                      loader: false,
                    });
                  }
                }
              }).catch(() => {
                this.setState({ loader: false });
              });
          } else {
            toast.error(this.props.t('Toast.Error.RxExist'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handleMScriptsOnChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleMScriptsKeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      let isRxExist = false;
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        lookupValue: searchedString,
        account_id: globalAccountConnection.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'orders/lookup', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedJson = JSON.parse(res);
          if (
            parsedJson &&
            parsedJson.status &&
            parsedJson.status.toLowerCase() === 'failed'
          ) {
            toast.error(parsedJson.error_message);
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.order_details;
          let isreturnable = false
          if (
            prescriptionDetails &&
            prescriptionDetails.IsReturnable === true
          ) {
            isreturnable = prescriptionDetails.IsReturnable;
          } else {
            isreturnable = false;
          }
          if (!prescriptionDetails) {
            toast.error(this.props.t('Toast.Error.RxFound'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          } else {
            let item = {
              ndcCode: prescriptionDetails.ndc,
              itemId: '',
              binId: '',
              // rxNo: prescriptionDetails.rx_num,
              rxNo: '',
              name: prescriptionDetails.name,
              description: '',
              image: '',
              potency: '',
              qty: prescriptionDetails.dispensed_qty,
              schedule: '',
              Amount: prescriptionDetails.amount_due,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: prescriptionDetails.amount_due,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: prescriptionDetails.expiry_date,
              isLoadingTrans: false,
              fillNumber: prescriptionDetails.fill_number,
              prescriptionNumber: prescriptionDetails.rx_num,
              ConsultRequire:
                (prescriptionDetails &&
                  prescriptionDetails.fill_number === 0) ||
                  (prescriptionDetails && prescriptionDetails.fill_number === '0')
                  ? true
                  : false,
              IsReturnable: isreturnable,
              status: '',
              order_id: parsedJson.order_id,
              prescription_txn_id: prescriptionDetails.prescription_txn_id,
            };
            let objIsExist = {
              rxNumber: item.prescription_txn_id,
              account_id: globalAccountConnection.id,
            };
            fetch(`${process.env.REACT_APP_BASEURL}is-rx-exists`, {
              method: 'post',
              withCredentials: true,
              headers: {
                'Content-Type': 'application/json',
                Authorization:
                  'Bearer ' +
                  JSON.parse(sessionStorage.getItem('user')).signInUserSession
                    .idToken.jwtToken,
              },
              body: JSON.stringify(objIsExist),
            })
              .then((response) => {
                try {
                  return response.text();
                } catch (error) {
                  return null;
                }
              })
              .then((res) => {
                let parsedResponse = JSON.parse(res);
                isRxExist = parsedResponse.Rx_Is_Exist;
                if (isRxExist === false || isRxExist === 'false') {
                  const existingItem = this.state.searchedItems;
                  // this.setState({ EmailID: patientDetails.EmailAddress, phone: patientDetails.phone });
                  this.setState({ EmailID: 'N/A', phone: 'N/A' });
                  if (
                    existingItem &&
                    searchedRxItems &&
                    searchedRxItems.length > 0
                  ) {
                    let isexist = searchedRxItems.findIndex(
                      (x) => x.prescription_txn_id === searchedString
                    );
                    if (existingItem.PatientID === patientDetails.patient_id) {
                      if (isexist < 0) {
                        searchedRxItems.push(item);
                        if (
                          patientDetails &&
                          patientDetails.patient_id &&
                          patientDetails.EmailAddress
                        ) {
                          this.checkADACompatible(
                            patientDetails.patient_id,
                            patientDetails.EmailAddress
                          );
                        }
                        this.getcustomerLocation(
                          patientDetails,
                          searchedRxItems,
                          'MScripts'
                        );
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                        this.forceUpdate();
                      } else {
                        toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                        this.setState({
                          rxNumber: '',
                          loader: false,
                        });
                      }
                    } else {
                      toast.error(this.props.t('Toast.Error.WrongPatient'));
                      this.setState({
                        rxNumber: '',
                        loader: false,
                      });
                    }
                  } else {
                    searchedRxItems.push(item);
                    // if(patientDetails && patientDetails.patientID && EmailAddress) {
                    //   this.checkADACompatible(patientDetails.patientID, EmailAddress)
                    // }
                    this.getcustomerLocation(
                      patientDetails,
                      searchedRxItems,
                      'MScripts'
                    );
                    this.forceUpdate();
                    this.setState({
                      rxNumber: '',
                      loader: false,
                    });
                  }
                } else {
                  toast.error(this.props.t('Toast.Error.RxExist'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                }
              });
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handlePioneerKeyDown = () => {
    const { originalScannedScript } = this.state;
    let searchedString = originalScannedScript;
    this.setState({ loader: true, isEdit: false });
    let obj = {
      lookupValue: searchedString,
      vendor_key: this.state.accountDetails.connection_details
        .vendor_key,
      data_exchange_id: this.state.accountDetails.connection_details
        .data_exchange_id,
      contentType: 'application/json',
      returnType: 0,
      endPoint: this.state.accountDetails.connection_details.endpoint,
      account_id: this.state.accountDetails.id,
    };
    fetch(`${process.env.REACT_APP_BASEURL}pioneerRx/rxQuery`, {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        this.setState({ loader: false });
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (
          JSON.parse(res).status === 500 ||
          JSON.parse(res).status === '500'
        ) {
          toast.error(this.props.t("Assign.Pioneer.NoRxFound"));
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else if (
          (JSON.parse(res).status > 200 &&
            JSON.parse(res).status < 500) ||
          (JSON.parse(res).status > '200' &&
            JSON.parse(res).status < '500')
        ) {
          toast.error(this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else {
          if (res && res !== '') {
            let parsedResponse = JSON.parse(res);
            let patientDetails = parsedResponse.patient;
            let rxDetails = parsedResponse.rx;
            this.setState({ loader: false, confirmPMSDialogOpen: false });
            if (
              rxDetails !== undefined &&
              rxDetails !== 'undefined' &&
              rxDetails !== null &&
              rxDetails !== 'null' &&
              rxDetails !== ''
            ) {
              // if (rxDetails.readyToBeSold !== 1 && (rxDetails.statusTypeID !== 5 || rxDetails.statusTypeID !== 6)) {
              /*
              1 = Waiting for Data Entry
              2 = Waiting for Pre-check
              3 = Waiting for Fill
              4 = Waiting for Check
              10 = Completed
              16 = Cancelled
              17 = Waiting for Print
            */
              if (
                rxDetails.statusTypeID === 1 ||
                rxDetails.statusTypeID === 2 ||
                rxDetails.statusTypeID === 3 ||
                rxDetails.statusTypeID === 4 ||
                rxDetails.statusTypeID === 10 ||
                rxDetails.statusTypeID === 16 ||
                rxDetails.statusTypeID === 17
              ) {
                // toast.error(`The status of this Rx number is ${rxDetails.statusTypeText}`);
                this.setState({
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: this.props.t('Toast.Error.PioneerRx.Completed'),
                  rxNumber: '',
                });
                // return;
              }
            }
            if (rxDetails === undefined || rxDetails === 'undefined') {
              toast.error(this.props.t('Toast.Error.RxNotValid'));
              this.setState({
                rxNumber: '',
              });
              return;
            }
            let isConsultRequired = false;
            if (
              rxDetails.isControlled === 1 ||
              rxDetails.isControlled === '1' ||
              rxDetails.promptForCounseling === 1 ||
              rxDetails.promptForCounseling === '1'
            ) {
              isConsultRequired = true;
            }
            let isreturnable = false
            if (
              rxDetails &&
              rxDetails.IsReturnable === true
            ) {
              isreturnable = rxDetails.IsReturnable;
            } else {
              isreturnable = false;
            }
            let item = {
              ndcCode: rxDetails.prescribedNDC,
              itemId: '',
              binId: '',
              rxNo: rxDetails.rxNumber,
              name: rxDetails.prescribedDrugName,
              description: '',
              image: '',
              potency: '',
              qty: rxDetails.dispensedQuantity,
              schedule: rxDetails.drugSchedule,
              Amount: rxDetails.patientAmountOwed,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: rxDetails.patientAmountOwed,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: '',
              isLoadingTrans: false,
              fillNumber: rxDetails.fillNumber,
              ConsultRequire: isConsultRequired,
              IsReturnable: isreturnable,
              is_controlled_substance: [1, "1"].includes(rxDetails.isControlled) ? true : false
            };
            this.setState({
              EmailID: patientDetails.emailAddress,
              phone: patientDetails.primaryPhone,
              is_controlled_substance: [1, '1'].includes(rxDetails.isControlled) ? true : false
            });
            const existingItem = this.state.searchedItems;
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let rxNumbers = searchedString;
              if (rxNumbers[0].toLowerCase() === 'x') {
                rxNumbers = rxNumbers.split('X')[1];
              } else {
                rxNumbers = searchedString.split('-')[0];
              }
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === rxNumbers
              );
              if (existingItem.PatientID === patientDetails.patientID) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails.emailAddress !== '' &&
                    patientDetails.emailAddress !== undefined &&
                    patientDetails.emailAddress !== 'undefined' &&
                    patientDetails.emailAddress !== 'null' &&
                    patientDetails.emailAddress !== 'null'
                  ) {
                    this.checkADACompatible(
                      patientDetails.patientID,
                      patientDetails.emailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'Pioneer'
                  );
                  this.forceUpdate();
                  this.setState({
                    rxNumber: '',
                  });
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                });
              }
            } else {
              searchedRxItems.push(item);
              if (
                patientDetails.emailAddress !== null &&
                patientDetails.emailAddress !== 'null' &&
                patientDetails.emailAddress !== undefined &&
                patientDetails.emailAddress !== 'undefined' &&
                patientDetails.emailAddress !== ''
              ) {
                this.checkADACompatible(
                  patientDetails.patientID,
                  patientDetails.emailAddress
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'Pioneer'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
              });
            }
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });

  };

  handlePioneerChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleOpenDueAmountEditInput = (index) => {
    this.setState({ indexNo: index });
  };

  handleCloseDueAmountEditInput = (index, id) => {
    this.setState({ indexNo: Math.random() || index });
    const orderdueamount =
      searchedRxItems && searchedRxItems.find((item, i) => item.id === id);
    this.updateDueAmount(id, orderdueamount['price']);
  };

  updateDueAmount = (orderid, dueAmount) => {
    this.setState({ loader: true });
    const updateParams = {
      orderid: orderid,
      dueamount: dueAmount,
    };
    try {
      fetch(process.env.REACT_APP_BASEURL + 'updateorderdueamout', {
        method: 'PUT',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateParams),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          if (res) {
            this.setState({ loader: false });
            toast.success(
              res && res.UpdateDueAmount && res.UpdateDueAmount.message
            );
            //this.getPrescriptionDetails(this.state.binid, this.state.pmid);
          } else {
            this.setState({ loader: false });
            toast.error(res.error);
          }
        });
    } catch (error) {
      this.setState({ loader: false });
      console.log(error);
    }
  };

  onHandleChangeInputValue = (id, type, value, rxNumber) => {
    if (type === 'price') {
      const items =
        searchedRxItems &&
        searchedRxItems.map((item, i) => {
          if (((item.id || item.itemId) === id) && ((item.rxNo || item.rx_no) === rxNumber)) {
            return { ...item, price: parseFloat(value), CoPayAmount: parseFloat(value), Amount: parseFloat(value) };
          }
          return item;
        });
      searchedRxItems = items;
    } else if (type === 'seqNumber') {
      const items =
        searchedRxItems &&
        searchedRxItems.map((item, i) => {
          if (((item.id || item.itemId) === id) && ((item.rxNo || item.rx_no) === rxNumber)) {
            return { ...item, SeqNumber: value };
          }
          return item;
        });
      searchedRxItems = items;
    }
    this.forceUpdate();
  };

  handleMcKessonRxChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  parseMcKessonRxNumber = (prescriptionId, prescriptionConfig) => {
    /*
    "4" prefix
    "007" store number
    "600001394" Rx number + Fill Number + Partial Fill Number
    "00" Fill number
    "0" partial fill number
    */
    const AccountPrescriptionConfiguration = {
      prescriptionLength: prescriptionId.length,
      prefixLength: prescriptionConfig.prefix_length,
      storeNumberLength: prescriptionConfig.store_number_length,
      rxNumberLength: prescriptionId.length - prescriptionConfig.fill_number_length - prescriptionConfig.partial_fill_length,
      fillNumberLength: prescriptionConfig.fill_number_length,
      partialFillLength: prescriptionConfig.partial_fill_length
    }

    const skipLengthConfiguration = {
      prefixSkip: AccountPrescriptionConfiguration.prescriptionLength - AccountPrescriptionConfiguration.prescriptionLength,
      storeNumberSkip: AccountPrescriptionConfiguration.prefixLength,
      rxNumberSkip: AccountPrescriptionConfiguration.prefixLength + AccountPrescriptionConfiguration.storeNumberLength,
      fillNumberSkip: AccountPrescriptionConfiguration.prefixLength + AccountPrescriptionConfiguration.storeNumberLength + prescriptionConfig.rx_number_length,
      partialFillSkip: AccountPrescriptionConfiguration.prefixLength + AccountPrescriptionConfiguration.storeNumberLength + prescriptionConfig.rx_number_length + AccountPrescriptionConfiguration.fillNumberLength
    }

    let parsedRxNumber = {
      prefix: prescriptionId.substr(skipLengthConfiguration.prefixSkip, AccountPrescriptionConfiguration.prefixLength),
      storeNumber: prescriptionId.substr(skipLengthConfiguration.storeNumberSkip, AccountPrescriptionConfiguration.storeNumberLength),
      rxNumber: prescriptionId.substr(skipLengthConfiguration.rxNumberSkip, AccountPrescriptionConfiguration.rxNumberLength),
      rxNumberWithoutFill: prescriptionId.substr(skipLengthConfiguration.rxNumberSkip, prescriptionConfig.rx_number_length),
      fillNumber: prescriptionId.substr(skipLengthConfiguration.fillNumberSkip, AccountPrescriptionConfiguration.fillNumberLength),
      partialFillNumber: prescriptionId.substr(skipLengthConfiguration.partialFillSkip, AccountPrescriptionConfiguration.partialFillLength)
    }
    return parsedRxNumber;
  };

  handleMcKessonRxKeyDown = () => {
    const { globalAccountConnection, originalScannedScript } = this.state;
    this.setState({ loader: true, isEdit: false, confirmPMSDialogOpen: false });
    let searchedString = originalScannedScript;
    const rxToValidate = this.parseMcKessonRxNumber(searchedString, globalAccountConnection);
    let obj = {
      PrescriptionId: searchedString,
      account_id: this.state.accountDetails.id,
      isSafetyCheck: false,
    };
    fetch(
      process.env.REACT_APP_BASEURL +
      'api/mc-kession/GetPrescriptionDetailsById',
      {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession
              .idToken.jwtToken,
        },
        body: JSON.stringify(obj),
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (
          JSON.parse(res).status === 500 ||
          JSON.parse(res).status === '500'
        ) {
          toast.error(
            this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else if (
          (JSON.parse(res).status > 200 &&
            JSON.parse(res).status < 500) ||
          (JSON.parse(res).status > '200' &&
            JSON.parse(res).status < '500')
        ) {
          toast.error(
            this.props.t('Toast.Error.AdministratorContact')
          );
          console.error(JSON.parse(res).message);
          this.setState({
            rxNumber: '',
          });
          return;
        } else {
          let parsedResponse = JSON.parse(res) && JSON.parse(res).res;
          if (parsedResponse.patientInfo !== null) {
            let patientDetails = parsedResponse.patientInfo;
            let rxDetails = parsedResponse.prescriptionInfo;
            this.setState({ loader: false });
            if (rxDetails.WorkflowStatus !== 'Ready') {
              this.setState({
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The status of Rx: ${searchedString} is not ready. Please check your system and try again.`,
                rxNumber: '',
              });
            }
            if (
              (patientDetails && patientDetails.ExternalPatientID) ===
              undefined ||
              (patientDetails && patientDetails.ExternalPatientID) ===
              'undefined'
            ) {
              toast.error(this.props.t('Toast.Error.RxNotValid'));
              this.setState({
                rxNumber: '',
              });
              return;
            }
            let isConsultRequired = false;
            if (
              rxDetails.isControlledSubstance === true ||
              rxDetails.isControlledSubstance === 'true'
            ) {
              isConsultRequired = true;
            }
            let isreturnable = false
            if (
              rxDetails &&
              rxDetails.IsReturnable === true
            ) {
              isreturnable = rxDetails.IsReturnable;
            } else {
              isreturnable = false;
            }
            let item = {
              ndcCode: rxDetails.DispensedNDC,
              itemId: '',
              binId: '',
              rxNo: rxDetails.RxNumber,
              name: rxDetails.DrugName || rxDetails.ProductName,
              description: rxDetails.SigText,
              image: '',
              potency: '',
              qty: rxDetails.Quantity,
              schedule: rxDetails.SigText,
              Amount: rxDetails.Price,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: rxDetails.Price,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: rxDetails.ExpirationDate,
              isLoadingTrans: false,
              fillNumber: rxDetails.FillNumber,
              ConsultRequire: isConsultRequired,
              IsReturnable: isreturnable,
              partialfillseqnum: rxDetails.partialfillseqnum,
              is_controlled_substance: rxDetails.isControlledSubstance
            };
            this.setState({
              EmailID: patientDetails && patientDetails.EmailAddress,
              phone: patientDetails && patientDetails.MobilePhone,
            });
            const existingItem = this.state.searchedItems;
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === rxToValidate.rxNumber
              );
              if (
                existingItem.ExternalPatientID ===
                patientDetails.ExternalPatientID ||
                existingItem.PatientID === patientDetails.ExternalPatientID
              ) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails.EmailAddress !== '' &&
                    patientDetails.EmailAddress !== undefined &&
                    patientDetails.EmailAddress !== 'undefined' &&
                    patientDetails.EmailAddress !== 'null' &&
                    patientDetails.EmailAddress !== 'null'
                  ) {
                    this.checkADACompatible(
                      patientDetails.ExternalPatientID,
                      patientDetails.EmailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'McKesson'
                  );
                  this.forceUpdate();
                  this.setState({
                    rxNumber: '',
                  });
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                });
              }
            } else {
              searchedRxItems.push(item);
              if (
                patientDetails &&
                patientDetails.EmailAddress !== null &&
                patientDetails &&
                patientDetails.EmailAddress !== 'null' &&
                patientDetails &&
                patientDetails.EmailAddress !== undefined &&
                patientDetails &&
                patientDetails.EmailAddress !== 'undefined' &&
                patientDetails &&
                patientDetails.EmailAddress !== ''
              ) {
                this.checkADACompatible(
                  patientDetails.ExternalPatientID,
                  patientDetails.EmailAddress
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'McKesson'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
              });
            }
          } else {
            this.setState({
              loader: false,
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: parsedResponse.prescriptionInfo,
              rxNumber: ''
            });
          }
        }
        this.setState({ loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleEpicWithmTLSChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleEpicWithmTLSKeyDown = () => {
    // if (event.keyCode === 13) {
      this.setState({
        loader: true,
        isEpicHasValidRx: true,
        isEpicHasValidRxMessage: '',
        isEdit: false,
      });
      const { originalScannedScript } = this.state;
      let searchString = originalScannedScript;
      let validItems = [];
      let items = [];
      let obj = {
        PrescriptionId: searchString,
        account_id: this.state.accountDetails.id,
      };
      fetch(
        process.env.REACT_APP_BASEURL + 'kp/epic/mtls/GetPrescriptionInfoById',
        {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
          body: JSON.stringify(obj),
        }
      )
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then(async (res) => {
          let parsedJsonResponse = JSON.parse(res);
          let parsedJson;
          if (parsedJsonResponse && parsedJsonResponse.message) {
            this.setState({
              loader: false,
              rxNumber: '',
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
            });
            return;
          }
          parsedJson = parsedJsonResponse.response;
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.prescriptions;
          if (prescriptionDetails && prescriptionDetails.length <= 0) {
            toast.error(this.props.t('Toast.Error.Prescription'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              let _existingPrescriptionNumbers = [];
              if (
                prescriptionDetails &&
                prescriptionDetails.length &&
                prescriptionDetails.length > 0
              ) {
                for (
                  let exist = 0;
                  exist < prescriptionDetails.length;
                  exist++
                ) {
                  let preacriptionNumber = prescriptionDetails[
                    exist
                  ].PrescriptionNumber.trim();
                  for (let si = 0; si < searchedRxItems.length; si++) {
                    if (
                      preacriptionNumber ===
                      searchedRxItems[si].prescriptionNumber
                    ) {
                      _existingPrescriptionNumbers.push(preacriptionNumber);
                    }
                  }
                }
              }
              if (
                _existingPrescriptionNumbers &&
                _existingPrescriptionNumbers.length &&
                _existingPrescriptionNumbers.length > 0
              ) {
                this.setState({
                  loader: false,
                  rxNumber: '',
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
                });
                return true;
              }
            }
          }
          for (let j = 0; j < prescriptionDetails.length; j++) {
            let isconsultrequired = false;
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsConsultRequired === true
            ) {
              isconsultrequired = prescriptionDetails[j].IsConsultRequired;
            } else {
              isconsultrequired = false;
            }
            let isreturnable = false
            if (
              prescriptionDetails[j] &&
              prescriptionDetails[j].IsReturnable === true
            ) {
              isreturnable = prescriptionDetails[j].IsReturnable;
            } else {
              isreturnable = false;
            }
            for (let i = 0; i < prescriptionDetails[j].Fill.length; i++) {
              let item = {
                ndcCode: prescriptionDetails[j].Fill[i].Ndc,
                itemId: '',
                binId: '',
                rxNo: prescriptionDetails[j].Fill[i].PrescriptionId,
                name: prescriptionDetails[j].Medication,
                description: prescriptionDetails[j].Sig,
                image: '',
                potency: '',
                qty: prescriptionDetails[j].Fill[i].Quantity,
                schedule: prescriptionDetails[j].Frequency,
                Amount: prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                taxPercentage: '',
                insuranceAmount: '',
                CoPayAmount:
                  prescriptionDetails[j].Fill[i].PatientPayAmountDue,
                PaidAmount: '',
                DueAmount: '',
                paymentDueDate: '',
                stockedOn: '',
                stockedBy: '',
                deStockedOn: '',
                strength: '',
                route: '',
                doseage_form: '',
                non_proprietary_name: '',
                ExpirationDate: '',
                isLoadingTrans: false,
                fillNumber: prescriptionDetails[j].Fill[i].Id,
                prescriptionNumber:
                  prescriptionDetails[j].Fill[i].PrescriptionNumber,
                ConsultRequire: isconsultrequired,
                IsReturnable: isreturnable,
                status: prescriptionDetails[j].Fill[i].Status,
                is_controlled_substance: prescriptionDetails[j].isControlledSubstances
              };
              let rxTransactionNumber = `${prescriptionDetails[j].Fill[i].PrescriptionId}-${prescriptionDetails[j].Fill[i].Id}`;
              if (
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'verified' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'readytodispense' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'intransit' ||
                prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                'received'
              ) {
                const isRxTrasactionNumberExist = await this.checkIfRxExistorNotForEpicWithmTLS(
                  rxTransactionNumber
                );
                if (
                  isRxTrasactionNumberExist &&
                  isRxTrasactionNumberExist.result === true
                ) {
                  toast.error(isRxTrasactionNumberExist.error);
                  this.setState({
                    rxNumber: '',
                    loader: false,
                    EmailID: '',
                    phone: '',
                    isEpicHasValidRx: true,
                    isEpicHasValidRxMessage: '',
                  });
                  return;
                } else {
                  items.push(item);
                  if (
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'verified' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'readytodispense' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'intransit' ||
                    prescriptionDetails[j].Fill[i].Status.toLowerCase() ===
                    'received'
                  ) {
                    validItems.push(prescriptionDetails[j].Fill[i]);
                  }
                  if (validItems.length > 0) {
                    prescriptionDetails[j].Fill[i] = validItems;
                  }
                }
              } else {
                items.push(item);
              }
            }
          }
          if (items && items.length === 0) {
            return;
          }
          if (searchedRxItems && searchedRxItems.length > 0) {
            const _isSamePatient = this.isSamePatient(patientDetails);
            if (_isSamePatient === true) {
              this.isRxExistInCart(searchString, patientDetails, items);
            }
          } else {
            this.setState({
              EmailID: patientDetails.EmailAddress,
              phone: patientDetails.MobilePhone,
            });
            let RxItems = this.validateRxFills(items);
            if (
              RxItems &&
              RxItems.validRxItems &&
              RxItems.validRxItems.length > 0
            ) {
              searchedRxItems = RxItems.validRxItems;
            } else {
              searchedRxItems = RxItems.inValidRxItems;
              let errorArray = [];
              if (searchedRxItems && searchedRxItems.length > 0) {
                for (
                  let invalid = 0;
                  invalid < searchedRxItems.length;
                  invalid++
                ) {
                  errorArray.push({ Status: searchedRxItems[invalid].status });
                }
                this.setState({
                  loader: false,
                  isEpicHasValidRx: false,
                  isEpicHasValidRxMessage: `The status of the prescription
                  should be Verified, ReadyToDispense, Received or InTransit but the ${errorArray && errorArray.length > 1
                      ? 'statuses are'
                      : 'status is'
                    } ${errorArray &&
                    errorArray.map((x) => x.Status).join(', ')}`,
                });
              }
            }
            this.checkADACompatible(
              patientDetails.MedicalRecordNumber,
              patientDetails.EmailAddress
            );
            this.getcustomerLocation(
              patientDetails,
              searchedRxItems,
              'Epic With MTLS'
            );
            this.forceUpdate();
            this.setState({
              rxNumber: '',
              loader: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            loader: false,
            rxNumber: '',
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
          });
          return;
        });
    // }
  };

  renderScanRxBasedOnConnectionType = (classes) => {
    const { globalAccountConnection, prescriptionAssign } = this.state;
    const { t } = this.props;
    switch (globalAccountConnection.account_connections_id) {
      case CONNECTION_TYPE.EPIC:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'EPIC')}
            onChange={this.handleEpicChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MEDBANK:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={this.handleMedBankKeyDown}
            onChange={this.handleMedBankChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MSCRIPTS:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={this.handleMScriptsKeyDown}
            onChange={this.handleMScriptsOnChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.PIONEERRX:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'PIONEERRX')}
            onChange={this.handlePioneerChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.QS1:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'QS1')}
            onChange={this.handleQS1Change}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.MCKESSONERX:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'MCKESSONERX')}
            onChange={this.handleMcKessonRxChange}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.EPIC_WITH_MTLS:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'Epic With MTLS')}
            onChange={this.handleEpicWithmTLSChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.LIBERTY_SOFTWARE:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'LIBERTYSOFTWARE')}
            onChange={this.handleLibertySoftwareChange}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.THIRD_PARTY:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleThirdPartyRxCheck(e, 'THIRDPARTY')}
            onChange={this.handleThirdPartyChange}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.HL7:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={this.handleHL7KeyDown}
            onChange={this.handleHL7OnChange}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
      case CONNECTION_TYPE.DRX_INTEGRATION:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onKeyDown={(e) => this.handleRxCheck(e, 'DRX')}
            onChange={this.handleDRXChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        )
      default:
        return (
          <TextField
            id='outlined-bare'
            type='text'
            className={classes.scantextField}
            value={this.state.rxNumber}
            margin='normal'
            variant='standard'
            label={t('Assign.ScanRxNow')}
            autoFocus={true}
            onChange={this.onChange}
            inputRef={this.textInput}
            style={{ width: '100%' }}
            inputProps={{
              autocomplete: 'off',
              form: {
                autocomplete: 'off',
              },
            }}
            disabled={!prescriptionAssign}
          />
        );
    }
  };

  BindPatientId = () => {
    const { searchedItems, basicDetails } = this.state;
    if (
      searchedItems &&
      searchedItems.PatientID &&
      searchedItems.PatientID !== null &&
      searchedItems.PatientID !== 'null'
    ) {
      return searchedItems.PatientID;
    } else if (
      basicDetails &&
      basicDetails.patient_id &&
      basicDetails.patient_id !== null &&
      basicDetails.patient_id !== 'null'
    ) {
      return basicDetails.patient_id;
    } else {
      return '';
    }
  };

  handleQS1Change = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleQS1KeyDown = () => {
    const { accountDetails, boxDetails, originalScannedScript, scannedRxScript } = this.state;
    let searchedString = originalScannedScript || scannedRxScript;
    if (boxDetails && boxDetails.length === 0) {
      this.setState({
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage:
          'Please select at least one location or check the location is active or not.',
        loader: false,
        rxNumber: '',
      });
      this.handleFocus();
      return;
    }
    this.setState({ loader: true, confirmPMSDialogOpen: false });
    let obj = {
      pharmacyId:
        accountDetails &&
        accountDetails.connection_details &&
        accountDetails.connection_details.pharmacyid,
      rxNumber: searchedString,
      account_id: this.state.accountDetails.id,
    };
    fetch(process.env.REACT_APP_BASEURL + 'qs/rx', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        this.setState({ loader: false, confirmPMSDialogOpen: false });
        let parsedResponse = JSON.parse(res);
        let patientDetails = parsedResponse.patient;
        let rxDetails = parsedResponse.rx;
        let parsedExpirationDate = '';
        if (
          patientDetails === 404 &&
          (rxDetails[0].Status === 'N' || rxDetails[0].Status === 'n')
        ) {
          toast.error(this.props.t('Toast.Error.RxNotAvailableNumber'));
          this.handleFocus();
          this.setState({
            rxNumber: '',
          });
        } else {
          if (
            rxDetails &&
            rxDetails[0] &&
            rxDetails[0].ExpirationDate
          ) {
            let ExpirationDateyear = rxDetails[0].ExpirationDate.substring(
              0,
              4
            );
            let ExpirationDatemonth = rxDetails[0].ExpirationDate.substring(
              4,
              6
            );
            let ExpirationDateday = rxDetails[0].ExpirationDate.substring(
              6,
              8
            );
            parsedExpirationDate =
              ExpirationDatemonth +
              '/' +
              ExpirationDateday +
              '/' +
              ExpirationDateyear;
          }
          if(![undefined, 'undefined', null, 'null', ''].includes(rxDetails[0].DrugSchedule)) {
            if(["2", "3", "4", "5"].includes(rxDetails[0].DrugSchedule)) {
              this.setState({ is_controlled_substance: true });
            } else {
              this.setState({ is_controlled_substance: false });
            }
          } else {
            this.setState({ is_controlled_substance: false });
          }
          let item = {
            ndcCode: '',
            itemId: '',
            binId: '',
            rxNo: rxDetails && rxDetails[0] && rxDetails[0].RxNumber,
            name: rxDetails && rxDetails[0] && rxDetails[0].DrugName,
            description: '',
            image: '',
            potency: '',
            qty: '',
            schedule:
              rxDetails && rxDetails[0] && rxDetails[0].DrugSchedule,
            Amount: '',
            taxPercentage: '',
            insuranceAmount: '',
            CoPayAmount: '',
            PaidAmount: '',
            DueAmount: '',
            paymentDueDate: '',
            stockedOn: '',
            stockedBy: '',
            deStockedOn: '',
            strength: '',
            route: '',
            doseage_form: '',
            non_proprietary_name: '',
            ExpirationDate: parsedExpirationDate,
            isLoadingTrans: true,
            ConsultRequire: false,
            datefilled:
              rxDetails && rxDetails[0] && rxDetails[0].LastFillDate,
          };
          obj.datefilled = item.datefilled;
          this.generateCodes();
          this.setState({
            EmailID: patientDetails.EmailAddress,
            phone: patientDetails.CellPhone,
          });
          let parsedDob = '';
          var year = patientDetails.DateOfBirth.substring(0, 4);
          var month = patientDetails.DateOfBirth.substring(4, 6);
          var day = patientDetails.DateOfBirth.substring(6, 8);
          parsedDob = month + '/' + day + '/' + year;
          const existingItem = this.state.searchedItems;
          if (
            existingItem &&
            searchedRxItems &&
            searchedRxItems.length > 0
          ) {
            let _searchedRxNumber = '';
            let _firstCharZero = searchedString.charAt(0);
            if (_firstCharZero === 0 || _firstCharZero === '0') {
              if (searchedString.length === 12) {
                _searchedRxNumber = searchedString.slice(
                  0,
                  searchedString.length - 4
                );
              } else {
                _searchedRxNumber = searchedString;
              }
            } else {
              _searchedRxNumber = '0' + searchedString;
            }
            let isexist = searchedRxItems.findIndex(
              (x) => x.rxNo === _searchedRxNumber
            );
            if (existingItem.PatientID === patientDetails.PatientID) {
              if (isexist < 0) {
                searchedRxItems.push(item);
                this.checkADACompatible(
                  patientDetails.PatientID,
                  this.state.EmailID
                );
                let AddressLine1 = '', 
                AddressLine2 = '', 
                City = '', 
                State = '', 
                Zip = '', 
                Country = '',
                boxId = this.state.box_id;
                let locationDetails = boxDetails.filter((x) => x.id === boxId)[0];
                if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
                  AddressLine1 = locationDetails.address_line_1 || "";
                  AddressLine2 = locationDetails.address_line_2 || "";
                  City = locationDetails.city || "";
                  State = locationDetails.state || "";
                  Zip = locationDetails.zip || "";
                  Country = locationDetails.country || "";
                }
                this.setState({
                  searchedItems: {
                    PatientID: patientDetails.PatientID,
                    FirstName: patientDetails.FirstName,
                    LastName: patientDetails.LastName,
                    DateOfBirth: parsedDob,
                    MobileNo: this.state && this.state.phone,
                    EmailID: this.state && this.state.EmailID,
                    orders: [{ items: searchedRxItems }],
                    AddressLine1: AddressLine1,
                    AddressLine2: AddressLine2,
                    City: City,
                    State: State,
                    Zip: Zip,
                    Country: Country,
                  },
                });
              } else {
                toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                this.setState({
                  rxNumber: '',
                });
                this.handleFocus();
              }
            } else {
              toast.error(this.props.t('Toast.Error.WrongPatient'));
              this.setState({
                rxNumber: '',
              });
              this.handleFocus();
            }
          } else {
            searchedRxItems.push(item);
            this.checkADACompatible(
              patientDetails.PatientID,
              this.state && this.state.EmailID
            );
            let AddressLine1 = '', 
            AddressLine2 = '', 
            City = '', 
            State = '', 
            Zip = '', 
            Country = '',
            boxId = this.state.box_id;
            let locationDetails = boxDetails.filter((x) => x.id === boxId)[0];
            if (![undefined, "undefined", null, "null", ""].includes(locationDetails)) {
              AddressLine1 = locationDetails.address_line_1 || "";
              AddressLine2 = locationDetails.address_line_2 || "";
              City = locationDetails.city || "";
              State = locationDetails.state || "";
              Zip = locationDetails.zip || "";
              Country = locationDetails.country || "";
            }
            this.setState({
              searchedItems: {
                PatientID: patientDetails.PatientID,
                FirstName: patientDetails.FirstName,
                LastName: patientDetails.LastName,
                MiddleName: null,
                DateOfBirth: parsedDob,
                MobileNo: this.state && this.state.phone,
                EmailID: this.state && this.state.EmailID,
                orders: [{ items: searchedRxItems }],
                AddressLine1: AddressLine1,
                AddressLine2: AddressLine2,
                City: City,
                State: State,
                Zip: Zip,
                Country: Country,
              },
            });
          }
          this.fetchTransactions(obj);
        }
      })
      .catch((error) => {
        toast.error(
          `${this.props.t('Toast.Error.RxErrorDetail')} ${searchedString}`
        );
        console.error('Error:', error.message);
        this.setState({ loader: false });
        this.setState({
          rxNumber: '',
        });
        this.handleFocus();
      });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { selectedObject } = this.state;
    this.setState(
      { searchObj: { ...this.state.searchObj, pageNo: page } },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handleChangeRowsPerPage = (event) => {
    const { selectedObject } = this.state;
    this.setState(
      {
        searchObj: {
          ...this.state.searchObj,
          pageSize: event.target.value,
          pageNo: 0,
        },
      },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handlePrintReceipt = () => {
    this.setState({
      PrintFirstName:
        this.state &&
        this.state.searchedItems &&
        this.state.searchedItems.FirstName,
      PrintLastName:
        this.state &&
        this.state.searchedItems &&
        this.state.searchedItems.LastName,
      PrintDateOfBirth:
        this.state &&
        this.state.searchedItems &&
        this.state.searchedItems.DateOfBirth,
      PrintisCoolItem:
        this.state &&
        this.state.searchedItems &&
        this.state.searchedItems.isCoolItem,
      printDialogOpen: true,
    });
    const getBranding = this.state.boxDetails.find(
      (ele) => ele.id === this.state.box_id
    );
    if (getBranding) {
      const { brandName, brandPhone } = getBranding;
      this.setState({ BrandingName: brandName, BrandingPhone: brandPhone });
    }
    setTimeout(() => {
      window.print();
      this.setState({ printDialogOpen: false });
      this.getBoxes();
      searchedRxNumbers = [];
      searchedRxItems = [];
      this.setState({
        selectedBinId: '',
        searchedItems: [],
        rxNumber: '',
        isVisibleForPause: false,
        EmailID: '',
        phone: '',
        BrandingName: '',
        BrandingPhone: '',
      });
      this.handleFocus();
    }, 500);
  };

  handleFocus = () => {
    let event = document.querySelector('#outlined-bare');
    if (![undefined, null, 'undefined', 'null'].includes(event)) event.focus();
  };

  confirmBinOkButton = () => {
    this.setState({
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedBinId: '',
    });
  };

  checkIfCodesExists = async (codes) => {
    await fetch(process.env.REACT_APP_BASEURL + 'verify/codes', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(codes),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (res && res.isExist === true) {
          const _stockCode = randomized('A0', 6, { exclude: '0oOiIlL1&zZ' });
          const _pickupCode = randomized('A0', 6, { exclude: '0oOiIlL1&zZ' });
          let codes = {
            stockCode: _stockCode,
            pickupCode: _pickupCode,
          };
          localStorage.setItem('label-codes', JSON.stringify(codes));
          this.setState({ stockCode: _stockCode, pickupCode: _pickupCode });
        } else {
          localStorage.setItem('label-codes', JSON.stringify(codes));
          this.setState({
            stockCode: codes.stockCode,
            pickupCode: codes.pickupCode,
          });
        }
      }).catch(() => {
        this.setState({ loader: false });
        this.checkIfCodesExists(codes);
      });
    return codes;
  };

  saveCustomerMaster = async (type) => {
    const {
      EmailID,
      phone,
      selectedBinId,
      isVerifyingBin,
      courier_tracking,
      default_courier_selected,
      isEpicHasValidRx,
      locationtype_id,
      accountDetails,
      boxTypeId,
      servePresRetryCount
    } = this.state;
    const { t } = this.props;
    this.setState(prevState => ({ servePresFetchCount: prevState.servePresFetchCount + 1 }));
    if (!this.state.box_id) {
      this.setState({ hasError: true, loader: false });
    } else {
      let allowPrescriptionForcefully = false;
      this.setState({ loader: true });
      if ([undefined, 'undefined', null, 'null', ''].includes(selectedBinId) && locationtype_id === LOCATION_TYPE.Kiosk && boxTypeId !== BOX_TYPE.FASTLANE) {
        this.setState({ openMessage: true, loader: false });
      } else {
        if (![CONNECTION_TYPE.PIONEERRX, CONNECTION_TYPE.EPIC, CONNECTION_TYPE.EPIC_WITH_MTLS, CONNECTION_TYPE.DRX_INTEGRATION].includes(accountDetails.connection.id)) {
          await this.checkPrescriptionStatus();
        } else {
          allowPrescriptionForcefully = true;
        }
        if (isEpicHasValidRx || allowPrescriptionForcefully) {
          if ([undefined, 'undefined', null, 'null', ''].includes(EmailID)) {
            toast.error(this.props.t('Toast.Error.EnterEmail'));
            this.setState({ loader: false });
            return;
          }
          if ([undefined, 'undefined', null, 'null', ''].includes(phone)) {
            toast.error(this.props.t('Toast.Error.EnterMobile'));
            this.setState({ loader: false });
            return;
          }
          if (!isVerifyingBin) {
            const serverPrescriptionReqPayload = await this.prepareServerPrescrptionReqPayload();
            fetch(process.env.REACT_APP_BASEURL + 'serve/prescription', {
              method: 'post',
              withCredentials: true,
              headers: {
                Authorization:
                  'Bearer ' +
                  JSON.parse(sessionStorage.getItem('user')).signInUserSession
                    .idToken.jwtToken,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(serverPrescriptionReqPayload),
            }).then((response) => {
              try {
                return response.json();
              } catch (error) {
                return null;
              }
            }).then(async (serverPrescriptionResponse) => {
              // If Location Type is not Kiosk, call different function.
              const { patient } = serverPrescriptionResponse;
              if(patient && patient.id) {
                if (patient.locationtype_id !== LOCATION_TYPE.Kiosk) {
                  await this.servePrescriptionForOtherDeliveryTypes(
                    serverPrescriptionResponse,
                    courier_tracking,
                    default_courier_selected
                  );
                }
              }
              this.setState({ loader: false });
              this.handleFocus();
              if (type === 1) {
                const getBranding = this.state.boxDetails.find(
                  (ele) => ele.id === this.state.box_id
                );
                const { brandName, brandPhone } = getBranding;
                this.setState({
                  PrintFirstName:
                    this.state &&
                    this.state.searchedItems &&
                    this.state.searchedItems.FirstName,
                  PrintLastName:
                    this.state &&
                    this.state.searchedItems &&
                    this.state.searchedItems.LastName,
                  PrintDateOfBirth:
                    this.state &&
                    this.state.searchedItems &&
                    this.state.searchedItems.DateOfBirth,
                  PrintisCoolItem: this.state && this.state.isSelectedFlag,
                  printDialogOpen: true,
                  BrandingName: brandName,
                  BrandingPhone: brandPhone,
                });
                setTimeout(() => {
                  window.print();
                  this.setState({
                    printDialogOpen: false,
                    BrandingName: '',
                    BrandingPhone: '',
                    loader: false,
                    makeFastlaneAPICall: true,
                  });
                  searchedRxNumbers = [];
                  toast.success(this.props.t('Assign.RxAssignedSuccessfully'));
                  this.ClearFields();
                }, 1500);
              } else {
                toast.success(this.props.t('Assign.RxAssignedSuccessfully'));
                this.ClearFields();
              }
              searchedRxItems = [];
              this.setState({
                selectedBinId: '',
                searchedItems: [],
                rxNumber: '',
                EmailID: '',
                phone: '',
                makeFastlaneAPICall: true,
              });
            }).catch((error) => {
              if (servePresRetryCount > 0) {
                this.setState(
                  (prevState) => ({
                    loader: false,
                    servePresRetryCount: prevState.servePresRetryCount - 1,
                  }),
                  () => {
                    setTimeout(() => {
                      this.checkIfBinIsOccupedFromAnotherLocation(type);
                    }, 1000);
                  }
                );
              } else {
                toast.error(
                  t("Toast.Error.DeliverPrescription.ServePrescription") +
                    "" +
                    error && error.message
                );
                this.setState({
                  loader: false,
                  servePresRetryCount: servePresRetryCount - 1,
                });
              }
            });
          }
        }
      }
    }
  };

  prepareServerPrescrptionReqPayload = async () => {
    const {
      accountDetails,
      EmailID,
      phone,
      searchedItems,
      box_id,
      locationtype_id,
      box_position,
      source_location,
      storage_location,
      order_notes,
      orderId,
      default_courier_selected,
      courier_tracking,
      isSelectedFlag,
      FutureRelease,
      FutureReleaseDate,
      alternateAgents,
      is_controlled_substance
    } = this.state;
    let _storageCodes = localStorage.getItem('label-codes');
    let codes = {};
    if (_storageCodes) {
      codes = JSON.parse(_storageCodes);
    }
    return {
      first_name: searchedItems.FirstName,
      middle_name: searchedItems.MiddleName,
      last_name: searchedItems.LastName,
      dob: searchedItems.DateOfBirth,
      phone:
        accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS
          ? '1234567890'
          : phone,
      email:
        accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS
          ? 'na@ilocalbox.com'
          : EmailID,
      parent_box_id: box_id,
      patient_id: searchedItems.PatientID,
      locationtype_id: this.state.locationtype_id,
      address1: searchedItems.AddressLine1,
      address2: searchedItems.AddressLine2,
      city: searchedItems.City,
      state: searchedItems.State,
      zip: searchedItems.Zip,
      country: searchedItems.Country,
      location_notes: searchedItems.location_notes,
      is_future_release: FutureRelease,
      future_release_date: FutureReleaseDate,
      notes: this.state.patientNotes,
      alternateAgents: alternateAgents,
      prescription: {
        bin_id: await this.getSelectedBinsByType(),
        type_id:
          locationtype_id === LOCATION_TYPE.Kiosk
            ? assignmentstatus.ASSIGNED
            : DEVICE_TYPE.Ready,
        stock_code: codes.stockCode,
        pucode: codes.pickupCode,
        box_id: box_id,
        box_position: box_position,
        locationtype_id: locationtype_id,
        source_location: source_location,
        storage_location: storage_location,
        order_notes: order_notes,
        location_notes: searchedItems.location_notes,
        order_id: orderId,
        courier_type: default_courier_selected,
        tracking_number: courier_tracking,
        iscool_item: isSelectedFlag,
        items: await this.prepareReqPayloadForPrescriptionItems(),
        is_controlled_substance: [
          CONNECTION_TYPE.EPIC, 
          CONNECTION_TYPE.EPIC_WITH_MTLS, 
          CONNECTION_TYPE.MCKESSONERX, 
          CONNECTION_TYPE.PIONEERRX
        ].includes(accountDetails.connection.id) ? this.fetchControlledSubstance() : is_controlled_substance
      },
    };
  };

  prepareReqPayloadForPrescriptionItems = async () => {
    const { accountDetails, pickupCode } = this.state;
    this.getCartRxNumbers();
    let _prescriptionItemsList = [];

    if (searchedRxItems.length > 0) {
      for (let item = 0; item < searchedRxItems.length; item++) {
        let _singleItem = searchedRxItems[item];
        let rxNo = '';
        if (accountDetails.connection.id === CONNECTION_TYPE.QS1) {
          let rx = _singleItem.rxNo.substring(0, 1);
          if ((rx === 0 || rx === '0') && _singleItem.rxNo.length > 8) {
            rxNo = _singleItem.rxNo.substring(1, _singleItem.rxNo.length);
          } else {
            rxNo = _singleItem.rxNo;
          }
        } else if (accountDetails.connection.id === CONNECTION_TYPE.THIRD_PARTY) {
          rxNo = _singleItem.id
        } else {
          rxNo = _singleItem.rxNo;
        }
        _prescriptionItemsList.push({
          rx_no: rxNo,
          drug_name: _singleItem.name || _singleItem.drug_name,
          ndc_code: _singleItem.ndcCode,
          price: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.CoPayAmount || _singleItem.amount_due
          )
            ? 0
            : _singleItem.CoPayAmount || _singleItem.amount_due,
          expires_on: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.ExpirationDate
          )
            ? '01/01/2020'
            : _singleItem.ExpirationDate,
          qty: _singleItem.qty || _singleItem.dispensed_qty,
          strength: _singleItem.strength,
          route: _singleItem.route,
          doseage_form: _singleItem.doseage_form,
          non_proprietary_name: _singleItem.non_proprietary_name,
          fillNumber: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.fillNumber || _singleItem.fillnumber
          )
            ? 0
            : _singleItem.fillNumber || _singleItem.fillnumber,
          is_consultrequire: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.ConsultRequire)
            ? false
            : _singleItem.ConsultRequire,
          is_returnable: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.IsReturnable)
            ? false
            : _singleItem.IsReturnable,
          prescriptionnumber: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.prescriptionNumber)
            ? ''
            : _singleItem.prescriptionNumber,
          order_id: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.order_id
          )
            ? ''
            : _singleItem.order_id,
          prescription_txn_id: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.prescription_txn_id)
            ? ''
            : _singleItem.prescription_txn_id,
          pucode: pickupCode,
          SeqNumber: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.SeqNumber
          )
            ? 0
            : _singleItem.SeqNumber,
          dateFilled: [undefined, 'undefined', null, 'null', ''].includes(
            _singleItem.dateFilled
          )
            ? 0
            : _singleItem.dateFilled,
          partialfillseqnum: [
            undefined,
            'undefined',
            null,
            'null',
            '',
          ].includes(_singleItem.partialfillseqnum)
            ? 0
            : _singleItem.partialfillseqnum,
        });
      }
    }
    return _prescriptionItemsList;
  };

  checkPrescriptionStatus = async () => {
    const {
      accountDetails,
      isEpicHasValidRx,
      selectedBinId,
      box_id,
    } = this.state;
    if (![undefined, 'undefined', null, 'null', ''].includes(selectedBinId)) {
      if (searchedRxItems.length > 0) {
        let obj = {
          bin_id: selectedBinId,
          box_id: box_id,
          account_id: accountDetails && accountDetails.id,
        };
        let codes = {
          stockCode: this.state.stockCode,
          pickupCode: this.state.pickupCode,
        };
        await this.checkIfCodesExists(codes);
        fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          },
          body: JSON.stringify(obj),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((res) => {
            if (
              (res && res.statusCode === 200) ||
              (res && res.statusCode === 404)
            ) {
              if (
                accountDetails.connection.id === CONNECTION_TYPE.EPIC &&
                isEpicHasValidRx === false
              ) {
                toast.error(this.props.t('Toast.Error.PrescriptionStatusVerified')
                );
                this.setState({ loader: false });
                return;
              }
              if (
                accountDetails.connection.id === CONNECTION_TYPE.EPIC_WITH_MTLS &&
                isEpicHasValidRx === false
              ) {
                toast.error(this.props.t('Toast.Error.PrescriptionStatusVerified')
                );
                this.setState({ loader: false });
                return;
              }
              if (accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS) {
                let orderIds = [];
                let prescriptionNumbers = [];
                for (let i = 0; i < searchedRxItems.length; i++) {
                  orderIds.push(searchedRxItems[i].order_id);
                  prescriptionNumbers.push(
                    searchedRxItems[i].prescriptionNumber ||
                    searchedRxItems[i].prescriptionnumber ||
                    ''
                  );
                }
                this.setState({
                  orderIds: orderIds,
                  prescriptionIds: prescriptionNumbers,
                });
              }
              if (accountDetails.connection.id === CONNECTION_TYPE.LIBERTY_SOFTWARE &&
                isEpicHasValidRx === false) {
                toast.error(this.props.t('Toast.Error.LibertyStatus'));
                this.setState({ loader: false });
                return;
              }
            } else {
              this.setState({
                isVerifyingBin: true,
                loader: false,
                isVerifyingBinMessage:
                  'This bin is currently unavailable, please select another bin.',
              });
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      }
    }
  };

  handleRxCheck = async (event, pmsType) => {
    if (event.keyCode === 13) {
      const { globalAccountConnection, rxNumber } = this.state;
      let searchedString = event.target.value;
      let originalRxNumber = '';
      let RxTobeValid;
      if (pmsType === 'PIONEERRX') {
        if (searchedString[0].toLowerCase() === 'x') {
          RxTobeValid = searchedString.split('X')[1];
        } else {
          RxTobeValid = searchedString;
        }
        searchedString = RxTobeValid;
        originalRxNumber = rxNumber;
      }
      if (pmsType === 'MCKESSONERX') {
        const rxToValidate = this.parseMcKessonRxNumber(searchedString, globalAccountConnection);
        searchedString = rxToValidate.rxNumber
        originalRxNumber = rxNumber;
      }
      if (pmsType === 'LIBERTYSOFTWARE') {
        searchedString = this.parseLibertyRxNumber(searchedString)._scriptNumber;
        originalRxNumber = rxNumber;
      }
      if(pmsType === 'EPIC' || pmsType === 'Epic With MTLS') {
        searchedString = (await this.parseScannedQrCode(searchedString)).prescriptionNumber;
        searchedString = searchedString[0];
        originalRxNumber = rxNumber;
      }
      if(pmsType === 'DRX') {
        originalRxNumber = rxNumber;
      }
      console.log("searchedString : " , searchedString);
      console.log("originalRxNumber : " , originalRxNumber);
      this.setState({ scannedRxScript: searchedString, originalScannedScript: originalRxNumber})
      if (![undefined, 'undefined', null, 'null', ''].includes(searchedString)) {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + 'checkrxexistornot/' + searchedString, {
          method: 'GET',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
        }).then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        }).then((res) => {
          this.setState({ selectedPMSType: pmsType, loader: false });
          if ([true, "true"].includes(res && res.Rx_Is_Exist)) {
            this.setState({ confirmPMSDialogOpen: true });
          } else {
            this.handlePMSDialogYesEvent();
          }
          return res && res.Rx_Is_Exist;
        }).catch(() => {
          this.setState({ loader: false });
        })
      }
    }
  }

  handlePMSDialogYesEvent = () => {
    const { selectedPMSType } = this.state;
    switch (selectedPMSType) {
      case 'QS1':
        this.handleQS1KeyDown();
        break;
      case 'PIONEERRX':
        this.handlePioneerKeyDown();
        break;
      case 'LIBERTYSOFTWARE':
        this.handleLibertySoftwareKeyDown()
        break;
      case 'MCKESSONERX':
        this.handleMcKessonRxKeyDown()
        break;
      case 'EPIC':
        this.handleEpicKeyDown()
        break;
      case 'Epic With MTLS': 
        this.handleEpicWithmTLSKeyDown()
        break;
      case 'DRX':
        this.handleDRXKeyDown()
        break;
      default:
        break;
    }
  }

  handlePMSDialogNoEvent = () => {
    this.setState({
      rxNumber: '',
      loader: false,
      confirmPMSDialogOpen: false
    });
    this.handleFocus();
  }

  handleLibertySoftwareKeyDown = () => {
    const { originalScannedScript } = this.state;
    let searchedString = originalScannedScript;
    this.setState({ loader: true, isEdit: false, confirmPMSDialogOpen: false });
    fetch(`${process.env.REACT_APP_BASEURL}liberty-software/GetPrescriptionByScriptNumber/${searchedString}`, {
      crossDomain: true,
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken,
      }
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then((res) => {
      console.log(res);
      this.setState({ loader: false, isEdit: false });
      if (res && res !== '') {
        let patientDetails = res.patient;
        let rxDetails = res.prescription;
        this.setState({ loader: false });
        if (
          rxDetails !== undefined &&
          rxDetails !== 'undefined' &&
          rxDetails !== null &&
          rxDetails !== 'null' &&
          rxDetails !== ''
        ) {
          if (['PickedUp', 'Shipped'].includes(rxDetails.StatusCode)) {
            this.setState({
              isEpicHasValidRx: false,
              isEpicHasValidRxMessage: `The status of Rx: ${searchedString} is ${rxDetails.StatusCode}.`,
              rxNumber: '',
            });
          }
        }
        if (rxDetails === undefined || rxDetails === 'undefined') {
          toast.error(res.errorMessage);
          this.setState({
            rxNumber: '',
          });
          return;
        }
        this.setState({
          EmailID: patientDetails.emailAddress,
          phone: patientDetails.primaryPhone,
        });
        const existingItem = this.state.searchedItems;
        if (
          existingItem &&
          searchedRxItems &&
          searchedRxItems.length > 0
        ) {
          let isexist = searchedRxItems.findIndex(
            (x) => x.rxNo === searchedString
          );
          if (existingItem.PatientID === patientDetails.patientID) {
            if (isexist < 0) {
              searchedRxItems.push(rxDetails);
              if (
                patientDetails.email !== '' &&
                patientDetails.email !== undefined &&
                patientDetails.email !== 'undefined' &&
                patientDetails.email !== 'null' &&
                patientDetails.email !== 'null'
              ) {
                this.checkADACompatible(
                  patientDetails.patientID,
                  patientDetails.email
                );
              }
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'LIBERTYSOFTWARE'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
              });
            } else {
              toast.error(this.props.t('Toast.Error.RxAddedToCart'));
              this.setState({
                rxNumber: '',
              });
            }
          } else {
            toast.error(this.props.t('Toast.Error.WrongPatient'));
            this.setState({
              rxNumber: '',
            });
          }
        } else {
          searchedRxItems.push(rxDetails);
          if (
            patientDetails.email !== null &&
            patientDetails.email !== 'null' &&
            patientDetails.email !== undefined &&
            patientDetails.email !== 'undefined' &&
            patientDetails.email !== ''
          ) {
            this.checkADACompatible(
              patientDetails.patientID,
              patientDetails.email
            );
          }
          this.getcustomerLocation(
            patientDetails,
            searchedRxItems,
            'LIBERTYSOFTWARE'
          );
          this.forceUpdate();
          this.setState({
            rxNumber: '',
          });
        }
      }
    }).catch((error) => {
      this.setState({
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: error && error.message + '. Looks like server is unable to featch requested data. Please try again or contact to administrator!',
        rxNumber: '',
        loader: false,
        confirmPMSDialogOpen: false
      });
    });
  }

  handleLibertySoftwareChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  }

  handleThirdPartyRxCheck = async (event, pmsType) => {
    if (event.keyCode === 13) {
      let searchedString = event.target.value;
      this.setState({ scannedRxScript: searchedString, originalScannedScript: event.target.value, loader: true })
      if (![undefined, 'undefined', null, 'null', ''].includes(searchedString)) {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + `api/v1/subscriptions/prescriptionManagement/getPrescriptionByRx?prescription_number=${searchedString}`, {
          method: 'GET',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
        }).then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        }).then((res) => {
          const data = res.data;
          this.setState({ selectedPMSType: pmsType, loader: false });
          if ([true, "true"].includes(res && res.Rx_Is_Exist)) {
            const existingItem = this.state.searchedItems;
            if(Array.isArray(existingItem)) {
              if (existingItem.length === 0) {
                searchedRxItems = data;
                this.setState({
                  EmailID: data[0].email,
                  phone: data[0].sms_phone,
                  searchedItems: {
                    FirstName: data[0].first_name,
                    LastName: data[0].last_name,
                    notes: '',
                    AddressLine1: data[0].address_line_1,
                    AddressLine2: data[0].address_line_2,
                    DateOfBirth: data[0].dob,
                    City: data[0].city,
                    State: data[0].state,
                    Zip: data[0].zip,
                    Country: '',
                    PatientID: data[0].patient_id
                  }
                })
              } else {
                if (existingItem.PatientID === data[0].patient_id) {
                  let sameRx = searchedRxItems.findIndex((x) => x.prescriptionNumber === data[0].prescriptionNumber
                  );
                  if (sameRx < 0) {
                    searchedRxItems.push(data[0]);
                    this.setState({
                      EmailID: data[0].email,
                      phone: data[0].sms_phone,
                      searchedItems: {
                        FirstName: data[0].first_name,
                        LastName: data[0].last_name,
                        notes: '',
                        AddressLine1: data[0].address_line_1,
                        AddressLine2: data[0].address_line_2,
                        DateOfBirth: data[0].dob,
                        City: data[0].city,
                        State: data[0].state,
                        Zip: data[0].zip,
                        Country: '',
                        PatientID: data[0].patient_id
                      },
                      rxNumber: ''
                    })
                  } else {
                    toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                    this.setState({ rxNumber: '' });
                  }
                } else {
                  toast.error(this.props.t('Toast.Error.WrongPatient'));
                  this.setState({ rxNumber: '' });
                }
              }
            } else {
              searchedRxItems = data;
                this.setState({
                  EmailID: data[0].email,
                  phone: data[0].sms_phone,
                  searchedItems: {
                    FirstName: data[0].first_name,
                    LastName: data[0].last_name,
                    notes: '',
                    AddressLine1: data[0].address_line_1,
                    AddressLine2: data[0].address_line_2,
                    DateOfBirth: data[0].dob,
                    City: data[0].city,
                    State: data[0].state,
                    Zip: data[0].zip,
                    Country: '',
                    PatientID: data[0].patient_id
                  }
                })
            }
          } else {
            toast.error(res.message);
            this.setState({ rxNumber: '' });
          }
        }).catch(() => {
          this.setState({ rxNumber: '', loader: false });
        })
      }
    }
  }

  handleThirdPartyChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      }
    );
  }

  parseLibertyRxNumber = (scriptNumber) => {
    let _scriptNumber, _refillNumber;
    const splitRx = scriptNumber.split('-');
    _scriptNumber = splitRx[0].includes('RX') ? splitRx[0].substr((splitRx[0].length <= 9 ? 2 : 3), (splitRx[0].length - 1)) : splitRx[0];
    _refillNumber = splitRx[1];
    return { _scriptNumber, _refillNumber }
  }

  getSelectedBinsByType = async () => {
    const { boxTypeId, locationtype_id, selectedBinId } = this.state;
    let binIds = '';
    if (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) {
      if (selectedBinId === '') {
        binIds = parseInt(localStorage.getItem('fBinIds'), 10);
      } else {
        if (typeof (selectedBinId) === 'string') {
          binIds = locationtype_id === LOCATION_TYPE.Kiosk ? selectedBinId : null;
        } else {
          binIds = parseInt(localStorage.getItem('fBinIds'), 10);
        }
      }
    } else {
      binIds = locationtype_id === LOCATION_TYPE.Kiosk ? selectedBinId : null;
    }
    return binIds;
  }

  getAccountAndPatientIdByPhiType = (typeOfPhi, patient) => {
    let obj;
    if (typeOfPhi === 'Epic') {
      obj = {
        patientID: patient.MedicalRecordNumber,
        accountID: this.state.accountDetails.id,
      }
    } else if (typeOfPhi === 'Epic With MTLS') {
      obj = {
        patientID: patient.MedicalRecordNumber,
        accountID: this.state.accountDetails.id,
      }
    } else if (typeOfPhi === 'MScripts') {
      obj = {
        patientID: patient.PatientID || patient.patient_id || patient.patientID,
        accountID: patient.parent_account_id,
      }
    } else if (typeOfPhi === 'McKesson') {
      obj = {
        patientID: patient && patient.ExternalPatientID,
        accountID: this.state && this.state.globalAccountConnection.id,
      };
    } else {
      obj = {
        patientID: patient.PatientID || patient.patient_id || patient.patientID,
        accountID: this.state.globalAccountConnection.id,
      };
    }
    return obj;
  }

  checkIfFastlaneBinIdIsExistOrNot = (saveMode) => {
    const { box_id } = this.state;
    this.setState({ loader: true });
    this.getSelectedBinsByType().then((res) => {
      fetch(process.env.REACT_APP_BASEURL + 'fastlane/bin/is-exist?bin_id=' + res + '&boxId=' + box_id, {
        method: 'get',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      }).then((checkIfFastlaneBinIdIsExistOrNotResponse) => {
        if (checkIfFastlaneBinIdIsExistOrNotResponse && checkIfFastlaneBinIdIsExistOrNotResponse.statusCode === 200) {
          if (checkIfFastlaneBinIdIsExistOrNotResponse && checkIfFastlaneBinIdIsExistOrNotResponse.data && checkIfFastlaneBinIdIsExistOrNotResponse.data.isExist === true) {
            toast.error('Bin index is already in use.');
            this.setState({ loader: false });
          } else {
            this.setState({ loader: false });
            this.checkIfBinIsOccupedFromAnotherLocation(saveMode);
          }
        } else {
          this.setState({ loader: false });
          toast.error(`Error while checking the bin index is already exist or not`);
        }
      }).catch(() => {
        this.setState({ loader: false });
      })
    });
  }

  handleBinActivationChange = () => {
    let { selectedBinId, deactivatedBins, box_id } = this.state;
    this.setState({ loader: true })
    if (deactivatedBins.includes(selectedBinId)) {
      deactivatedBins = deactivatedBins.filter(item => item !== selectedBinId);
    } else {
      deactivatedBins.push(selectedBinId);
    }
    deactivatedBins = deactivatedBins.filter(item => item !== '');
    this.setState({ deactivatedBins })
    let varname = '';
    varname = deactivatedBins.join(',');
    const obj = {
      disabled_bins: varname,
      id: box_id
    }
    fetch(process.env.REACT_APP_BASEURL + 'boxs', {
      method: 'put',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken
      },
      body: JSON.stringify(obj)
    }).then((res) => {
      try {
        return res.json();
      } catch (error) {
        return null;
      }
    }).then((data) => {
      if (data.message) {
        console.log(data.message);
      }
      this.setState({ loader: false })
    }).catch((error) => {
      console.log(error);
      this.setState({ loader: false })
    })
    this.ClearFields();
  }

  createRowAlterAgent = () => {
    const { classes, t } = this.props;
    let alternateAgents = this.state && this.state.alternateAgents;
    let row =
      alternateAgents &&
      alternateAgents.map((val, idx) => (
        <div className={classes.styleBottom}>
          <React.Fragment>
            <div>
              <Grid container>
                <Grid item xs={2} style={{ maxWidth: '160px' }}>
                  <Button
                    style={{ marginLeft: '4%', marginTop: '5%' }}
                    className={classes.styleBottom1}
                    onClick={() => this.removeAlternetAgentRow(idx)}
                    color='primary'
                    disabled={this.state.readOnly}
                  >
                    {t('Patient.Preference.AlternateContactRemoveButton')}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className={classes.styleBottom1}
                  style={{ marginLeft: '-4rem', maxWidth: '120px' }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={val.isdefault}
                        onChange={this.onChangeAgentActive(idx)}
                        value='default'
                        color='primary'
                        disabled={this.state.readOnly}
                      />
                    }
                    label={
                      <span
                        style={{
                          color: '#000',
                          fontSize: '0.875rem',
                          fontWeight: '400',
                          lineHeight: '1.46429em',
                        }}
                      >
                        {t('Patient.Preference.AlternateContactActiveCheckbox')}
                      </span>
                    }
                    style={{ marginTop: '5px' }}
                  />
                </Grid>
                <Grid item xs={2} style={{ marginRight: '2px' }}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_firstname}
                    id='agent_firstname'
                    label={t('Patient.Preference.AlternateContactFirstName')}
                    placeholder=''
                    onChange={this.onChangeAgentFirstName(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2} style={{ marginRight: '2px' }}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_lastname}
                    id='Last_Name'
                    label={t('Patient.Preference.AlternateContactLastName')}
                    placeholder=''
                    onChange={this.onChangeAgentLastName(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' },
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2} style={{ maxWidth: '190px' }}>
                  <TextField
                    className={classes.halfTextFieldAgents}
                    margin='dense'
                    value={val.agent_email}
                    id='Email'
                    label={t('Patient.Preference.AlternateContactEmail')}
                    placeholder=''
                    onChange={this.onChangeAgentEmail(idx)}
                    fullWidth
                    inputProps={{
                      readOnly: this.state.readOnly,
                      maxLength: 50,
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                    sx={{
                      '&.MuiFormControl-marginDense': { marginTop: '0px' }, width: '250px'
                    }}
                    variant='standard'
                  />
                </Grid>
                <Grid item xs={2} style={{ marginLeft: '4rem' }}>
                  <PhoneInput
                    labelStyle={{ left: '-13px', top: '-17px' }}
                    className={classes.halfTextFieldAgents}
                    id='smsphone'
                    name='phone'
                    onBlur={this.onChangeAgentsmsphone(idx)}
                    defaultValue={val.agent_sms}
                    readOnly={this.state.readOnly}
                    style={{ width: '133px' }}
                  />
                </Grid>
              </Grid>
            </div>
          </React.Fragment>
        </div>
      ));
    return row;
  };

  addAlterAgentRow = () => {
    this.setState({
      alternateAgents:
        this.state &&
        this.state.alternateAgents &&
        this.state.alternateAgents.concat([
          {
            agent_firstname: '',
            agent_lastname: '',
            agent_email: '',
            agent_sms: '',
            isdefault: false,
          },
        ]),
    });
  };

  onChangeAgentFirstName = (idx) => (evt) => {
    const agent_firstname =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: evt.target.value,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agent_firstname });
  };

  onChangeAgentLastName = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: evt.target.value,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentEmail = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: evt.target.value,
          agent_sms: item.agent_sms,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentsmsphone = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: evt.target.value,
          isdefault: item.isdefault,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  onChangeAgentActive = (idx) => (evt) => {
    const agentdata =
      this.state &&
      this.state.alternateAgents.map((item, sidx) => {
        if (idx !== sidx) return item;
        return {
          // customer_id: sidx,
          agent_firstname: item.agent_firstname,
          agent_lastname: item.agent_lastname,
          agent_email: item.agent_email,
          agent_sms: item.agent_sms,
          isdefault: evt.target.checked,
        };
      });
    this.setState({ alternateAgents: agentdata });
  };

  removeAlternetAgentRow = (i) => {
    this.setState({
      alternateAgents: this.state.alternateAgents.filter((s, sidx) => i !== sidx),
    });
  };

  servePrescriptionForOtherDeliveryTypes = async (serverPrescriptionResponse, courier_tracking, default_courier_selected) => {
    const { t } = this.props;
    const { patient, prescription } = serverPrescriptionResponse;
    if (prescription && prescription.id) {
      let data = {
        order_id: prescription.id,
        account_id: patient.parent_account_id,
        location_type_id: patient.locationtype_id,
        courier_tracking: courier_tracking,
        default_courier_selected: default_courier_selected,
      };
      const requestUrl = `${[LOCATION_TYPE.Bedside].includes(data.location_type_id)
        ? 'delivery/bedsidenotification'
        : 'delivery/notifications'
        }`;
      fetch(process.env.REACT_APP_BASEURL + requestUrl, {
        method: 'POST',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user'))
              .signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }).then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      }).then((servePrescriptionForOtherDeliveryTypesResponse) => {
        console.log(JSON.stringify(servePrescriptionForOtherDeliveryTypesResponse, null, 2));
        this.setState({ loader: false });
      }).catch((error) => {
        toast.error(t("Toast.Error.DeliverPrescription.ServePrescription") + " " + error && error.message);
        this.setState({ loader: false });
      });
    }
  }

  removePhantomBin = (e) => {
    const { t } = this.props;
    e && e.preventDefault();
    const { pmid } = this.state;
    console.log(`Order to be removed ${pmid}`);
    this.setState({ loader: true });
    fetch(`${process.env.REACT_APP_BASEURL}release/phantom`, {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user'))
            .signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({prescriptionId: pmid}),
    }).then((response) => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then((pbrr) => {
      console.log(JSON.stringify(pbrr, null, 2));
      if(pbrr && pbrr.data) {
        toast.success(t("Assign.PhantomBin.SuccessMessage"));
        this.ClearFields();
      }
      this.setState({ loader: false, confirmPhantomRemoval: false, doesBinClicked: false });
    }).catch((error) => {
      toast.error(t("Toast.Error.DeliverPrescription.ServePrescription") + " " + error && error.message);
      this.setState({ loader: false, confirmPhantomRemoval: false, doesBinClicked: false });
    });
  }

  setPermission = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if(_checkUserRole === userroles.SUPERADMIN) {
      this.setState({ 
        isManualOverridePermissionEnabled: true, 
        prescriptionUnAssign: true, 
        prescriptionAssign: true, 
        prescriptionView: true,
        prescriptionDirectPickup: true,
        prescriptionRemind: true,
        prescriptionConsult: true,
        prescriptionHoldResume: true,
        prescriptionAcDc: true, });
    } else {
      if (permissions && permissions.length > 0) {
        const manualOverride = permissions.filter((item) => {
          return item.permission_entity_type === "Manual Override"
        });
        const assignPrescriptions = permissions.filter((item) => {
          return item.permission_entity_type === "Assign Prescription"
        });
        if(manualOverride.length > 0) {
          const isOpenBinAllowed = manualOverride.filter((x) => x.name.trim() === 'Open Bin' && x.is_allowed === 1);
          // Open Bin
          if(isOpenBinAllowed.length > 0) {
            this.setState({ isManualOverridePermissionEnabled: true })
          } else {
            this.setState({ isManualOverridePermissionEnabled: false })
          }
        } else {
          this.setState({ isManualOverridePermissionEnabled: false });
        }

        if(assignPrescriptions.length > 0) {
          const isUnAssignAllowed = assignPrescriptions.filter((x) => x.name.trim() === 'UnAssign' && x.is_allowed === 1);
          const isAssignAllowed = assignPrescriptions.filter((x) => x.name.trim() === 'Assign' && x.is_allowed === 1);
          const _isViewPermissionAllowed = assignPrescriptions.filter((x) => x.name.trim() === 'View' && x.is_allowed === 1);

          const _isRemind = assignPrescriptions.filter((x) => x.name.trim() === 'Remind' && x.is_allowed === 1);
          const _isDirect = assignPrescriptions.filter((x) => x.name.trim() === 'Direct Pickup' && x.is_allowed === 1);
          const _isConsult = assignPrescriptions.filter((x) => x.name.trim() === 'Consult' && x.is_allowed === 1);
          const _isAcDc = assignPrescriptions.filter((x) => x.name.trim() === 'Activate/DeActivate' && x.is_allowed === 1);
          const _isHoRu = assignPrescriptions.filter((x) => x.name.trim() === 'Hold/Resume' && x.is_allowed === 1);
          
          // UnAssign
          if(isUnAssignAllowed.length > 0) {
            this.setState({ prescriptionUnAssign: true })
          } else {
            this.setState({ prescriptionUnAssign: false })
          }
          // Assign
          if(isAssignAllowed.length > 0) {
            this.setState({ prescriptionAssign: true })
          } else {
            this.setState({ prescriptionAssign: false })
          }
          // View
          if(_isViewPermissionAllowed.length > 0) {
            this.setState({ prescriptionView: true })
          } else {
            this.setState({ prescriptionView: false })
          }
          // Remind
          if(_isRemind.length > 0) {
            this.setState({ prescriptionRemind: true })
          } else {
            this.setState({ prescriptionRemind: false })
          }
          // Direct Pickup
          if(_isDirect.length > 0) {
            this.setState({ prescriptionDirectPickup: true })
          } else {
            this.setState({ prescriptionDirectPickup: false })
          }
          // Consult
          if(_isConsult.length > 0) {
            this.setState({ prescriptionConsult: true })
          } else {
            this.setState({ prescriptionConsult: false })
          }
          // Activate/DeActivate
          if(_isAcDc.length > 0) {
            this.setState({ prescriptionAcDc: true })
          } else {
            this.setState({ prescriptionAcDc: false })
          }
          // Hold/Resume
          if(_isHoRu.length > 0) {
            this.setState({ prescriptionHoldResume: true })
          } else {
            this.setState({ prescriptionHoldResume: false })
          }
        } else {
          this.setState({ 
            prescriptionUnAssign: false, 
            prescriptionAssign: false, 
            prescriptionView: false,
            prescriptionDirectPickup: false,
            prescriptionRemind: false,
            prescriptionConsult: false,
            prescriptionHoldResume: false,
            prescriptionAcDc: false,
          });
        }
      } else {
        this.setState({ 
          isManualOverridePermissionEnabled: false, 
          prescriptionUnAssign: false, 
          prescriptionAssign: false, 
          prescriptionView: false,
          prescriptionDirectPickup: false,
          prescriptionRemind: false,
          prescriptionConsult: false,
          prescriptionHoldResume: false,
          prescriptionAcDc: false 
        });
      } 
    }
  }

  handleHL7KeyDown = (event) => {
    const { globalAccountConnection } = this.state;
    if (event.keyCode === 13) {
      this.setState({ loader: true, isEdit: false });
      let searchedString = event.target.value;
      let obj = {
        lookupValue: searchedString,
        account_id: globalAccountConnection.id,
      };
      fetch(process.env.REACT_APP_BASEURL + 'hl/orders/lookup', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          let parsedJson = JSON.parse(res);
          if (
            parsedJson &&
            parsedJson.status &&
            parsedJson.status.toLowerCase() === 'failed'
          ) {
            toast.error(parsedJson.error_message);
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          }
          let patientDetails = parsedJson.patient;
          let prescriptionDetails = parsedJson.order_details;
          if (!prescriptionDetails) {
            toast.error(this.props.t('Toast.Error.RxFound'));
            this.setState({
              rxNumber: '',
              loader: false,
            });
            return;
          } else {
            let item = {
              ndcCode: prescriptionDetails.ndc,
              itemId: '',
              binId: '',
              rxNo: prescriptionDetails.rx_num,
              name: prescriptionDetails.name,
              description: '',
              image: '',
              potency: '',
              qty: prescriptionDetails.dispensed_qty,
              schedule: '',
              Amount: prescriptionDetails.amount_due,
              taxPercentage: '',
              insuranceAmount: '',
              CoPayAmount: prescriptionDetails.amount_due,
              PaidAmount: '',
              DueAmount: '',
              paymentDueDate: '',
              stockedOn: '',
              stockedBy: '',
              deStockedOn: '',
              strength: '',
              route: '',
              doseage_form: '',
              non_proprietary_name: '',
              ExpirationDate: prescriptionDetails.expiry_date,
              isLoadingTrans: false,
              fillNumber: null,
              prescriptionNumber: null,
              ConsultRequire: false,
              IsReturnable: false,
              status: '',
              order_id: null,
              prescription_txn_id: null,
              is_controlled_substance: false
            };
            const existingItem = this.state.searchedItems;
            this.setState({ EmailID: patientDetails.EmailAddress, phone: patientDetails.phone });
            if (
              existingItem &&
              searchedRxItems &&
              searchedRxItems.length > 0
            ) {
              let isexist = searchedRxItems.findIndex(
                (x) => x.rxNo === searchedString
              );
              if (existingItem.PatientID === patientDetails.patient_id) {
                if (isexist < 0) {
                  searchedRxItems.push(item);
                  if (
                    patientDetails &&
                    patientDetails.patient_id &&
                    patientDetails.EmailAddress
                  ) {
                    this.checkADACompatible(
                      patientDetails.patient_id,
                      patientDetails.EmailAddress
                    );
                  }
                  this.getcustomerLocation(
                    patientDetails,
                    searchedRxItems,
                    'HL7'
                  );
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                  this.forceUpdate();
                } else {
                  toast.error(this.props.t('Toast.Error.RxAddedToCart'));
                  this.setState({
                    rxNumber: '',
                    loader: false,
                  });
                }
              } else {
                toast.error(this.props.t('Toast.Error.WrongPatient'));
                this.setState({
                  rxNumber: '',
                  loader: false,
                });
              }
            } else {
              searchedRxItems.push(item);
              this.getcustomerLocation(
                patientDetails,
                searchedRxItems,
                'HL7'
              );
              this.forceUpdate();
              this.setState({
                rxNumber: '',
                loader: false,
              });
            }
          }
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  }

  handleHL7OnChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  }

  validateRxFillsForDRX = (items) => {
    let _validRxItemArray = [];
    let _inValidRxItemArray = [];
    let validatedRxFills = {};
    if (items && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(items[i].status)) {
          _validRxItemArray.push(items[i]);
        } else {
          _inValidRxItemArray.push(items[i]);
        }
      }
    }
    validatedRxFills.validRxItems = _validRxItemArray;
    validatedRxFills.inValidRxItems = _inValidRxItemArray;
    return validatedRxFills;
  };

  isRxExistInCartForDRX = async (searchedString, patientDetails, items) => {
    let _existingPrescriptionNumbers = [];
    let existingRxNo = searchedString;
    for (let si = 0; si < searchedRxItems.length; si++) {
      if (
        existingRxNo === searchedRxItems[si].rxNo.toString()
      ) {
        _existingPrescriptionNumbers.push(searchedRxItems[si].rxNo.toString());
      }
    }
    if (_existingPrescriptionNumbers.length > 0) {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The prescription ${_existingPrescriptionNumbers.join(
          ','
        )} is already exist in the cart!`,
      });
      return true;
    } else {
      let itemsdetail;
      let validRxScripts = this.validateRxFillsForDRX(items);
      if (
        validRxScripts &&
        validRxScripts.validRxItems &&
        validRxScripts.validRxItems.length > 0
      ) {
        itemsdetail = validRxScripts.validRxItems;
      } else {
        itemsdetail = validRxScripts.inValidRxItems;
      }
      for (let i = 0; i < itemsdetail.length; i++) {
        searchedRxItems.push(itemsdetail[i]);
      }
      this.checkADACompatible(
        patientDetails.patient_id,
        patientDetails.email
      );
      this.getcustomerLocation(patientDetails, itemsdetail, 'DRX');
      this.forceUpdate();
      this.setState({
        rxNumber: '',
        loader: false,
      });
    }
  };

  isSamePatientForDRX = (patientDetails) => {
    const { searchedItems } = this.state;
    if (searchedItems.PatientID === patientDetails.patient_id) {
      this.setState({
        EmailID: patientDetails.email,
        phone: patientDetails.phone,
      });
      return true;
    } else {
      this.setState({
        loader: false,
        rxNumber: '',
        isEpicHasValidRx: false,
        isEpicHasValidRxMessage: `The scanned or entered prescription has different patient details. Please assign this prescription to any bin first then scan or enter another prescription!`,
      });
      return false;
    }
  };

  checkIfRxExistOrNotForDRX = async (rxTransactionNumber) => {
    let response = {};
    return fetch(
      process.env.REACT_APP_BASEURL +
      'prescription/check/rxno-fillid/' +
      rxTransactionNumber,
      {
        method: 'get',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((checkResponse) => {
        if (checkResponse) {
          let parsedJsonResponse = JSON.parse(checkResponse);
          if (
            parsedJsonResponse &&
            parsedJsonResponse.res &&
            parsedJsonResponse.res.status === 200
          ) {
            response.error = parsedJsonResponse.res.message;
            response.result = true;
            return response;
          } else {
            response.error = '';
            response.result = false;
            return response;
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleDRXChange = (e) => {
    this.setState(
      {
        rxNumber: e.target.value,
        isEdit: false,
        doesPrescriptionScanned: true,
      },
      () => {
        console.log(this.state.doesPrescriptionScanned);
      }
    );
  };

  handleDRXKeyDown = (event) => {
    this.setState({
      loader: true,
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: "",
      isEdit: false,
    });
    const { originalScannedScript } = this.state;
    let searchedString = originalScannedScript;
    let validItems = [];
    let items = [];
    let obj = {
      lookupValue: searchedString,
      accountId: this.state.accountDetails.id,
    };
    fetch(process.env.REACT_APP_BASEURL + "drx/prescription/lookup", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(obj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(async (res) => {
        let parsedJsonResponse = res;
        let parsedJson;
        if (parsedJsonResponse && parsedJsonResponse.status !== 200) {
          this.setState({
            loader: false,
            rxNumber: "",
            isEpicHasValidRx: false,
            isEpicHasValidRxMessage: `${parsedJsonResponse.message}`,
          });
          return;
        }
        parsedJson = parsedJsonResponse.data;
        let patientDetails = parsedJson.prescription.patient;
        let prescriptionDetails = parsedJson.prescription;
        if (prescriptionDetails.length <= 0) {
          toast.error(this.props.t("Toast.Error.Prescription"));
          this.setState({
            rxNumber: "",
            loader: false,
          });
          return;
        }
        if (searchedRxItems && searchedRxItems.length > 0) {
          const _isSamePatient = this.isSamePatientForDRX(patientDetails);
          if (_isSamePatient === true) {
            let _existingPrescriptionNumbers = [];
            let preacriptionNumber =
              prescriptionDetails.prescription_id;
            for (let si = 0; si < searchedRxItems.length; si++) {
              if (
                preacriptionNumber === searchedRxItems[si].prescription_id
              ) {
                _existingPrescriptionNumbers.push(preacriptionNumber);
              }
            }
            if (
              _existingPrescriptionNumbers &&
              _existingPrescriptionNumbers.length &&
              _existingPrescriptionNumbers.length > 0
            ) {
              this.setState({
                loader: false,
                rxNumber: "",
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The prescription(s) ${_existingPrescriptionNumbers} are already exist in the cart!`,
              });
              return true;
            }
          }
        }
        let isconsultrequired = false;
        let isreturnable = false;
        // if (
        //   prescriptionDetails[j] &&
        //   prescriptionDetails[j].IsConsultRequired === true
        // ) {
        //   isconsultrequired = prescriptionDetails[j].IsConsultRequired;
        // } else {
        //   isconsultrequired = false;
        // }
        //check for isreturnable feild in fetched prescriptions
        // if (
        //   prescriptionDetails[j] &&
        //   prescriptionDetails[j].IsReturnable === true
        // ) {
        //   isreturnable = prescriptionDetails[j].IsReturnable;
        // } else {
        //   isreturnable = false;
        // }
        this.setState({
          is_controlled_substance: false
            // prescriptionDetails[j].isControlledSubstances,
        });
        for (let i = 0; i < prescriptionDetails.fills.length; i++) {
          let item = {
            ndcCode: prescriptionDetails.ndc,
            itemId: "",
            binId: "",
            rxNo: prescriptionDetails.prescription_id,
            name: prescriptionDetails.drug_name,
            description: prescriptionDetails.sig,
            image: "",
            potency: "",
            qty: prescriptionDetails.fills[i].dispensed_quantity,
            schedule: "",
            Amount: prescriptionDetails.fills[i].copay,
            taxPercentage: "",
            insuranceAmount: "",
            CoPayAmount: prescriptionDetails.fills[i].copay,
            PaidAmount: "",
            DueAmount: "",
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            strength: "",
            route: "",
            doseage_form: "",
            non_proprietary_name: "",
            ExpirationDate: prescriptionDetails.expiration_date,
            isLoadingTrans: false,
            fillNumber: prescriptionDetails.fills[i].id,
            prescriptionNumber: "",
            ConsultRequire: isconsultrequired,
            IsReturnable: isreturnable,
            status: prescriptionDetails.fills[i].status,
          };
          let rxTransactionNumber = `${prescriptionDetails.prescription_id}-${prescriptionDetails.fills[i].id}`;
          if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(prescriptionDetails.fills[i].status)
          ) {
            let isRxTrasactionNumberExist = false
            setImmediate(async () => {
              isRxTrasactionNumberExist = await this.checkIfRxExistOrNotForDRX(
                rxTransactionNumber
              );
            })
            if (
              isRxTrasactionNumberExist &&
              isRxTrasactionNumberExist.result === true
            ) {
              toast.error(isRxTrasactionNumberExist.error);
              this.setState({
                rxNumber: "",
                loader: false,
                EmailID: "",
                phone: "",
                isEpicHasValidRx: true,
                isEpicHasValidRxMessage: "",
              });
              return;
            } else {
              items.push(item);
              if (['Waiting Bin', 'Verify', 'Scan', 'Pre-Check'].includes(prescriptionDetails.fills[i].status)) {
                validItems.push(prescriptionDetails.fills[i]);
              }
              if (validItems.length > 0) {
                prescriptionDetails.fills[i] = validItems;
              }
            }
          } else {
            items.push(item);
          }
        }
        if (items && items.length === 0) {
          return;
        }
        if (searchedRxItems && searchedRxItems.length > 0) {
          const _isSamePatient = this.isSamePatientForDRX(patientDetails);
          if (_isSamePatient === true) {
            this.isRxExistInCartForDRX(searchedString, patientDetails, items);
          }
        } else {
          this.setState({
            EmailID: patientDetails.email,
            phone: patientDetails.phone,
          });
          let RxItems = this.validateRxFillsForDRX(items);
          if (
            RxItems &&
            RxItems.validRxItems &&
            RxItems.validRxItems.length > 0
          ) {
            searchedRxItems = RxItems.validRxItems;
          } else {
            searchedRxItems = RxItems.inValidRxItems;
            let errorArray = [];
            if (searchedRxItems && searchedRxItems.length > 0) {
              for (let invalid = 0; invalid < searchedRxItems.length; invalid++) {
                errorArray.push({ Status: searchedRxItems[invalid].status });
              }
              this.setState({
                loader: false,
                isEpicHasValidRx: false,
                isEpicHasValidRxMessage: `The status of the prescription
                  should be Waiting Bin, Verify, Scan, Pre-Check but the ${
                    errorArray && errorArray.length > 1
                      ? "statuses are"
                      : "status is"
                  } ${errorArray && errorArray.map((x) => x.Status).join(", ")}`,
              });
            }
          }
          this.checkADACompatible(
            patientDetails.patient_id,
            patientDetails.email
          );
          this.getcustomerLocation(patientDetails, searchedRxItems, "DRX");
          this.forceUpdate();
          this.setState({
            rxNumber: "",
            loader: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loader: false,
          rxNumber: "",
          isEpicHasValidRx: false,
          isEpicHasValidRxMessage: `The scanned or entered prescription has an error. Please contact your administrator for more information.`,
        });
        return;
      });
  };

  fetchControlledSubstance = () => {
    if (searchedRxItems.length > 0) { 
      const _controlledSubstance = searchedRxItems.filter((item) => item.is_controlled_substance === (true || 'true'));
      if(_controlledSubstance.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  checkIfBinIsOccupedFromAnotherLocation = (type) => {
    const { box_id, selectedBinId, binid } = this.state;
    fetch(process.env.REACT_APP_BASEURL + "aio/bin/status", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({
        box_id: box_id,
        bin_id: selectedBinId || binid,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          console.log(`Preflight error while processing request ${error && error.message}`)
          return null;
        }
      })
      .then(async (res) => {
        if (res && res.isOccupied === true) {
          toast.error(res.message);
        } else {
          this.saveCustomerMaster(type);
        }
      })
      .catch((error) => {
        toast.error(`Error while checking status ${error && error.message}`);
      });
  };  

  render() {
    const itemCount = searchedRxItems && searchedRxItems.length;
    const Dateoptions = { year: 'numeric', month: 'numeric', day: 'numeric' }; // Define options for formatting the date
    const {
      searchedItems,
      selectedBinId,
      stockCode,
      pickupCode,
      selected,
      hasError,
      isAlreadyOnHold,
      isAlreadyAssigned,
      locationtype,
      is_stocked,
      order,
      orderBy,
      isManualOverrideOpen,
      locationtype_id,
      selectedBox,
      boxTypeId,
      accountDetails,
      isBinDeactivated,
      doesBinClicked,
      confirmPhantomRemoval,
      isManualOverridePermissionEnabled,
      prescriptionUnAssign,
      prescriptionAssign,
      prescriptionView,
      prescriptionDirectPickup,
      prescriptionRemind,
      prescriptionConsult,
      prescriptionHoldResume,
      prescriptionAcDc
    } = this.state;
    const { classes, t } = this.props;
    const localizer = momentLocalizer(moment);
    const disabledDatesStyle = (date, currentDate) => {
      if (date < currentDate) {
        return {
          className: 'disabled-date',
          style: {
            backgroundColor: '#e6e6e6',
            color: '#99999',
            pointerEvents: 'none',
          },
        };
      }
    };
    const isIlocalUser = localStorage.getItem('isIlocalUser');
    return (
      <Box component='div'>
        <Paper className={classes.paperRoot}>
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <div id='react-no-print'>
            <div id='react-no-print' className={classes.root}>
              <Dialog
                open={this.state.deleteDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle id='alert-dialog-title'>
                  {'Are you sure you want to delete?'}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {t('Assign.AreYouSureToDelete')}
                    <ul>
                      {this.state.forDeletion &&
                        this.state.forDeletion.map(function (a) {
                          return <li>{a.name}</li>;
                        })}
                    </ul>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.deleteConfirmClose}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.CancelButton')}
                  </Button>
                  <Button
                    onClick={this.deleteConfirmed}
                    color='primary'
                    autoFocus
                    className={classes.primaryButton}
                  >
                    {t('Assign.DeleteButton')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.SearchResultDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                fullWidth={true}
                PaperProps={{
                  style: { maxWidth: '1315px' },
                }}
              >
                <DialogContent>
                  {this.state.innerSearchLoader && (
                    <Box component='div' className={classes.spinner}>
                      <Box
                        component='img'
                        className={classes.spinnerImage}
                        src={spinner}
                        alt='loading'
                      />
                    </Box>
                  )}
                  <Table aria-labelledby='tableTitle'>
                    <TableHead>
                      <TableRow sx={{ height: '56px' }}>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.FirstName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.LastName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Email')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Phone')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Bin')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.Status')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.StockCode')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Assign.Search.PUCode')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(this.state.selectedObject) &&
                        this.state.selectedObject.length > 0 ? (
                        this.state &&
                        this.state.selectedObject.map((n) => {
                          return (
                            <TableRow>
                              <TableCell className={classes.tablebody}>
                                {n.first_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.last_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.email}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.phone}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.bin_id}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.status}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id
                                    )
                                  }
                                >
                                  {n.stock_code}
                                </a>
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id
                                    )
                                  }
                                >
                                  {n.pucode}
                                </a>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5}>
                            {t('Assign.NoDataFound')}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <ThemeProvider theme={localeTheme}>
                    <TablePagination
                      component='div'
                      count={this.state.totalSearchRecords || 0}
                      rowsPerPage={this.state.searchObj.pageSize}
                      page={this.state.searchObj.pageNo}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </ThemeProvider>
                </DialogContent>
                <DialogActions style={{ marginTop: '-20px' }}>
                  <Button
                    onClick={(e) => {
                      this.handleSearchClose(e);
                    }}
                    color='primary'
                    className={classes.primaryButton}
                  >
                    {t('Assign.Search.Close')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.showDatePopup || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                PaperProps={{
                  style: { maxWidth: '1315px' },
                }}
              >
                <DialogTitle id='alert-dialog-title'>
                  {'Set Future Release Date'}
                  <IconButton
                    onClick={() => { this.setState({ showDatePopup: false, FutureRelease: false }) }}
                    aria-label="Close"
                    style={{ position: 'absolute', padding: '0px', right: '20px', top: '20px' }}>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Calendar
                    dayPropGetter={(date) => disabledDatesStyle(date, new Date())}
                    localizer={localizer}
                    selectable={true}
                    toolbar={true}
                    events={[]}
                    views={['month']}
                    startAccessor="start"
                    endAccessor="end"
                    onSelectSlot={this.handleFutureDateChange}
                    style={{ height: 500, width: 600 }}
                  />
                </DialogContent>
              </Dialog>
              <div id='react-no-print' className={classes.assignForm}>
                <div className={classes.main}>
                  <Table>
                    <TableBody>
                      {this.state && this.state.isEpicHasValidRx === false ? (
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            style={{ borderBottom: 'none', padding: 0 }}
                          >
                            <p
                              style={{
                                fontSize: '14px',
                                color: 'red',
                                paddingRight: '0px !important',
                              }}
                            >
                              {this.state && this.state.isEpicHasValidRxMessage}
                            </p>
                          </TableCell>
                        </TableRow>
                      ) : null}
                      <TableRow>
                        <TableCell className={classes.layoutBorder}>
                          {this.renderScanRxBasedOnConnectionType(classes)}
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          style={{ width: '60%' }}
                        >
                          <TextField
                            id='PatientNotes'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.PatientNotes')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={this.state.patientNotes}
                            onChange={(e) => !this.state.readOnly && this.setState({ patientNotes: e.target.value })}
                            readOnly={this.state.readOnly}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
                <div>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='firstName'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.FirstName')}
                            fullWidth
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={
                              searchedItems &&
                                searchedItems.FirstName &&
                                searchedItems.FirstName !== null &&
                                searchedItems.FirstName !== 'null'
                                ? searchedItems.FirstName
                                : ''
                            }
                          />
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='lastName'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.LastName')}
                            fullWidth
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={
                              searchedItems &&
                                searchedItems.LastName &&
                                searchedItems.LastName !== null &&
                                searchedItems.LastName !== 'null'
                                ? searchedItems.LastName
                                : ''
                            }
                          />
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <InputLabel
                            htmlFor='location_type_id'
                            style={{ fontSize: '13px' }}
                          >
                            {t('Assign.DeliveryType')}
                          </InputLabel>
                          <Select
                            style={{ marginTop: '5px' }}
                            fullWidth={true}
                            value={this.state.locationtype_id || ''}
                            onChange={this.handletypeChange}
                            inputProps={{
                              name: 'location_type_id',
                              id: 'location_type_ids',
                            }}
                            variant='standard'
                          >
                            {locationtype &&
                              locationtype.map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type.id}
                                  selected
                                  className={classes.locationType}
                                >
                                  {type.label}
                                </MenuItem>
                              ))}
                          </Select>
                          {hasError && (
                            <FormHelperText className={classes.selectLable}>
                              Please select any type
                            </FormHelperText>
                          )}
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <InputLabel
                            htmlFor='box_id'
                            style={{ fontSize: '13px' }}
                          >
                            {t('Assign.Location')}
                          </InputLabel>
                          <Select
                            style={{ marginTop: '5px' }}
                            fullWidth={true}
                            value={this.state.box_id || ''}
                            onChange={this.handleChange}
                            inputProps={{
                              name: 'box_id',
                              id: 'box_ids',
                            }}
                            variant='standard'
                          >
                            {this.state.boxDetails.length > 0 &&
                              this.state.boxDetails.map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type.id}
                                  selected
                                  className={classes.locationType}
                                >
                                  {type.value}
                                </MenuItem>
                              ))}
                          </Select>
                          {hasError && (
                            <FormHelperText className={classes.selectLable}>
                              Please select any box
                            </FormHelperText>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='email'
                            type='text'
                            className={classes.textField}
                            fullWidth
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Email')}
                            name='EmailID'
                            onChange={this.onInputChange}
                            InputLabelProps={{ shrink: true }}
                            value={this.state.EmailID}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            disabled={!prescriptionAssign}
                          />
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='phoneNo'
                            type='text'
                            className={classes.textField}
                            fullWidth
                            margin='normal'
                            variant='standard'
                            label={t('Assign.SMSPhone')}
                            name='phone'
                            onChange={this.onInputChange}
                            InputLabelProps={{ shrink: true, maxLength: 10 }}
                            value={this.state.phone}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            disabled={!prescriptionAssign}
                          />
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='address1'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Address1')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.AddressLine1 &&
                                searchedItems.AddressLine1 !== null &&
                                searchedItems.AddressLine1 !== 'null'
                                ? searchedItems.AddressLine1
                                : ''
                            }
                          />
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='address2'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Address2')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.AddressLine2 &&
                                searchedItems.AddressLine2 !== null &&
                                searchedItems.AddressLine2 !== 'null'
                                ? searchedItems.AddressLine2
                                : ''
                            }
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='dateOfBirth'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.DOB')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.DateOfBirth &&
                                searchedItems.DateOfBirth !== null &&
                                searchedItems.DateOfBirth !== 'null'
                                ? searchedItems.DateOfBirth
                                : ''
                            }
                          />
                        </TableCell>
                        <TableCell style={{ border: 'none' }}>
                          <TextField
                            id='bin'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.BIN')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={selectedBinId}
                            style={{ marginTop: '8.5%', marginLeft: '1%' }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='city'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.City')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.City &&
                                searchedItems.City !== null &&
                                searchedItems.City !== 'null'
                                ? searchedItems.City
                                : ''
                            }
                          />
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='state'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.State')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.State &&
                                searchedItems.State !== null &&
                                searchedItems.State !== 'null'
                                ? searchedItems.State
                                : ''
                            }
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='patient record number'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.PatientRecordNumber')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={this.BindPatientId()}
                          />
                        </TableCell>
                        {this.state.accountDetails.is_future_release ? <TableCell className={classes.layoutBorder}>
                          <InputLabel
                            htmlFor='FutureRelease'
                            style={{ fontSize: '13px' }}
                          >
                            {t('Assign.FutureRelease')}
                            {
                              this.state.FutureReleaseDate &&
                              this.state.FutureRelease &&
                              <span style={{
                                marginLeft: "3px",
                                color: "white",
                                padding: "3px",
                                fontSize: "10px",
                                borderRadius: "5px",
                                backgroundColor: "#00a7e1"
                              }}>
                                {
                                  this.state.FutureReleaseDate.toLocaleDateString('en-US', Dateoptions)
                                }
                              </span>
                            }
                          </InputLabel>
                          <Select
                            disabled={this.state.disableFeild}
                            style={{ marginTop: '5px' }}
                            fullWidth={true}
                            value={this.state.FutureRelease}
                            onChange={this.handleFutureChange}
                            inputProps={{
                              name: 'FutureRelease',
                              id: 'FutureRelease',
                              disabled: !prescriptionAssign
                            }}
                            variant='standard'
                          >
                            {
                              [{ label: "Yes", value: true }, { label: "No", value: false }].map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type.value}
                                  selected
                                  className={classes.locationType}
                                >
                                  {type.label}
                                </MenuItem>
                              ))}
                          </Select>
                          {hasError && (
                            <FormHelperText className={classes.selectLable}>
                              Please select any option
                            </FormHelperText>
                          )}
                        </TableCell> : null}

                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='zip'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Zip')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.Zip &&
                                searchedItems &&
                                searchedItems.Zip !== null &&
                                searchedItems &&
                                searchedItems.Zip !== 'null'
                                ? searchedItems.Zip
                                : ''
                            }
                          />
                        </TableCell>
                        <TableCell className={classes.layoutBorder}>
                          <TextField
                            id='country'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Assign.Country')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={
                              searchedItems &&
                                searchedItems.Country &&
                                searchedItems.Country !== null &&
                                searchedItems.Country !== 'null'
                                ? searchedItems.Country
                                : ''
                            }
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>{t('Assign.AlternateContacts')}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid item xs={12}>
                      <Button
                        style={{ marginLeft: '-1%', marginTop: '1%' }}
                        onClick={this.addAlterAgentRow}
                        color='primary'
                        disabled={this.state.readOnly}
                      >
                        {t(
                          'Patient.Preference.AddAlternateContactButton'
                        )}
                      </Button>
                      {this.createRowAlterAgent()}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <div className={classes.adjustDrugGrid}>
                  <EnhancedTableToolbar
                    numSelected={selected.length}
                    deleteItems={this.deleteItems}
                    confirmDelete={this.confirmDelete}
                  />
                  <div className={classes.handleOverflow}>
                    <Table
                      className={classes.table}
                      aria-labelledby='tableTitle'
                    >
                      <EnhancedTableHead
                        numSelected={selected.length}
                        onSelectAllClick={this.handleSelectAllClick}
                        rowCount={searchedRxItems ? searchedRxItems.length : 0}
                        isVisibleForPause={this.state.isVisibleForPause}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={this.handleRequestSort}
                        className={classes.tableCellLabel}
                      />
                      <TableBody>
                        {searchedRxItems.length === 0 ? (
                          <TableRow>
                            <TableCell
                              className={classes.emptyRowCell}
                              style={{ padding: '10px 0px' }}
                              colSpan='11'
                            >
                              {t('Assign.NoDataFound')}
                            </TableCell>
                          </TableRow>
                        ) : (
                          stableSort(
                            searchedRxItems,
                            getSorting(order, orderBy)
                          ).map((n, index) => {
                            let amount;
                            if (
                              n.price !== undefined &&
                              n.price !== null &&
                              n.price !== 'undefined' &&
                              n.price !== 'null' &&
                              n.price !== ''
                            ) {
                              amount = n.price;
                            } else if (
                              n.CoPayAmount !== undefined &&
                              n.CoPayAmount !== null &&
                              n.CoPayAmount !== 'undefined' &&
                              n.CoPayAmount !== 'null' &&
                              n.CoPayAmount !== ''
                            ) {
                              amount = n.CoPayAmount;
                            } else if (
                              n.amount_due !== undefined &&
                              n.amount_due !== null &&
                              n.amount_due !== 'undefined' &&
                              n.amount_due !== 'null' &&
                              n.amount_due !== ''
                            ) {
                              amount = n.amount_due;
                            } else {
                              amount = 0;
                            }
                            const isSelected = this.isSelected(
                              n.rxNo || n.rx_no
                            );
                            const _seqNumber = n.SeqNumber || n.seqnumber;
                            return (
                              <TableRow
                                hover
                                role='checkbox'
                                aria-checked={isSelected}
                                tabIndex={-1}
                                key={n.rxNo || n.rx_no}
                                selected={isSelected}
                              >
                                {!this.state.isVisibleForPause && (
                                  <TableCell
                                    padding={'none'}
                                    onClick={(event) =>
                                      this.handleClick(event, n.rxNo || n.rx_no)
                                    }
                                  >
                                    <Checkbox checked={isSelected} />
                                  </TableCell>
                                )}
                                <TableCell
                                  className={classes.tableCell}
                                  onClick={(event) =>
                                    this.handleClick(event, n.rxNo || n.rx_no)
                                  }
                                  style={{ fontSize: '0.70rem' }}
                                >
                                  {accountDetails && accountDetails.connection.id === CONNECTION_TYPE.MSCRIPTS ? (n.rxNo || n.rx_no) : (n.rxNo || n.rx_no || n.id)}
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  onClick={(event) =>
                                    this.handleClick(event, n.rxNo || n.rx_no)
                                  }
                                  sx={{ fontSize: '0.70rem' }}
                                >
                                  {n.fillNumber || n.fillnumber}
                                </TableCell>
                                <TableCell
                                  style={{ width: '140px' }}
                                  className={classes.tableCell}
                                  onClick={(event) =>
                                    this.handleClick(event, n.rxNo || n.rx_no)
                                  }
                                  sx={{ fontSize: '0.70rem' }}
                                >
                                  {n.prescriptionNumber ||
                                    n.prescriptionnumber ||
                                    ''}
                                </TableCell>
                                <TableCell
                                  style={{ width: '140px' }}
                                  className={classes.tableCell}
                                  onClick={(event) =>
                                    this.handleClick(event, n.rxNo || n.rx_no)
                                  }
                                  sx={{ fontSize: '0.70rem' }}
                                >
                                  {n.order_id || ''}
                                </TableCell>
                                <TableCell
                                  style={{ width: '140px' }}
                                  className={classes.tableCell}
                                  onClick={(event) =>
                                    this.handleClick(event, n.rxNo || n.rx_no)
                                  }
                                >
                                  {accountDetails && accountDetails.connection.id === CONNECTION_TYPE.QS1 ?
                                    n.isLoadingTrans === true ? (
                                      <img src={cl} alt='loader' width='36' />
                                    ) :
                                      <TextField
                                        sx={{
                                          width: '60px',
                                          mt: '7px',
                                          '.MuiInput-root': {
                                            fontSize: '0.80rem',
                                          },
                                        }}
                                        value={_seqNumber}
                                        variant='standard'
                                        onChange={(e) =>
                                          this.onHandleChangeInputValue(
                                            ![undefined, 'undefined', null, 'null', ''].includes(n.id) ? n.id : n.itemId,
                                            'seqNumber',
                                            e.target.value,
                                            n.rxNo || n.rx_no
                                          )
                                        }
                                        id='seqNumber'
                                      />
                                    : (n.prescription_txn_id || '')}
                                </TableCell>
                                <TableCell
                                  style={{ width: '160px' }}
                                  className={classes.tableCell}
                                  onClick={(event) =>
                                    this.handleClick(event, n.rxNo || n.rx_no)
                                  }
                                  sx={{ fontSize: '0.70rem' }}
                                >
                                  {n.name || n.drug_name}
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  onClick={(event) =>
                                    this.handleClick(event, n.rxNo || n.rx_no)
                                  }
                                  sx={{ fontSize: '0.70rem' }}
                                >
                                  {n.isLoadingTrans === true ? (
                                    <img src={cl} alt='loader' width='36' />
                                  ) : (
                                    n.ndcCode || n.ndc_code
                                  )}
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  onClick={(event) =>
                                    this.handleClick(event, n.rxNo || n.rx_no)
                                  }
                                  sx={{ fontSize: '0.70rem' }}
                                >
                                  {n.isLoadingTrans === true ? (
                                    <img src={cl} alt='loader' width='36' />
                                  ) : (
                                    n.qty
                                  )}
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  sx={{ fontSize: '0.70rem' }}
                                // onClick={event =>
                                //   this.handleClick(event, n.rxNo || n.rx_no)
                                // }
                                >
                                  {n.isLoadingTrans === true ? (
                                    <img src={cl} alt='loader' width='36' />
                                  ) : (
                                    <div>
                                      <TextField
                                        sx={{
                                          width: '60px',
                                          mt: '7px',
                                          '.MuiInput-root': {
                                            fontSize: '0.80rem',
                                          },
                                        }}
                                        value={parseFloat(amount)}
                                        variant='standard'
                                        onChange={(e) =>
                                          this.onHandleChangeInputValue(
                                            ![undefined, 'undefined', null, 'null', ''].includes(n.id) ? n.id : n.itemId,
                                            'price',
                                            e.target.value,
                                            n.rxNo || n.rx_no
                                          )
                                        }
                                        id='price'
                                        InputProps={{
                                          inputComponent: NumberFormatCustom,
                                          autocomplete: 'new-password',
                                          form: {
                                            autocomplete: 'off',
                                          },
                                        }}
                                      />
                                      {this.state.isEdit === true &&
                                        this.state.isAmountPaid === false ? (
                                        this.state.indexNo === index ? (
                                          <React.Fragment>
                                            {/* <TextField
                                              sx={{
                                                width: '60px',
                                                mt: '7px',
                                                '.MuiInput-root': {
                                                  fontSize: '0.80rem',
                                                },
                                              }}
                                              value={parseFloat(amount)}
                                              variant='standard'
                                              onChange={(e) =>
                                                this.onHandleChangeInputValue(
                                                  n.id,
                                                  'price',
                                                  e.target.value
                                                )
                                              }
                                              id='price'
                                              InputProps={{
                                                inputComponent: NumberFormatCustom,
                                                autocomplete: 'new-password',
                                                form: {
                                                  autocomplete: 'off',
                                                },
                                              }}
                                            /> */}
                                            <Tooltip
                                              title={t('Assign.SaveTooltip')}
                                            >
                                              <IconButton
                                                onClick={() =>
                                                  this.handleCloseDueAmountEditInput(
                                                    index,
                                                    n.id
                                                  )
                                                }
                                                className={
                                                  classes.onAmoutDueEditPrimaryButton
                                                }
                                              >
                                                <SaveIcon />
                                              </IconButton>
                                            </Tooltip>
                                          </React.Fragment>
                                        ) : (
                                          <Tooltip
                                            title={t('Assign.EditTooltip')}
                                          >
                                            <IconButton
                                              className={
                                                classes.onAmoutDueEditPrimaryButton
                                              }
                                              onClick={() =>
                                                this.handleOpenDueAmountEditInput(
                                                  index
                                                )
                                              }
                                              sx={{ ml: '6%' }}
                                            >
                                              <EditIcon />
                                            </IconButton>
                                          </Tooltip>
                                        )
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  )}
                                </TableCell>
                                {this.state.accountDetails.bypass_consult ? (
                                  <TableCell
                                    className={classes.TableCell}
                                  ></TableCell>
                                ) : (
                                  <TableCell
                                    className={classes.tableCell}
                                    sx={{ fontSize: '0.70rem' }}
                                  >
                                    {' '}
                                    {n &&
                                      n.is_order_released &&
                                      n.is_order_released === true ? (
                                      <div>
                                        <img
                                          src={checked}
                                          alt={n.rx_no}
                                          height={24}
                                          width={24}
                                        />
                                      </div>
                                    ) : (
                                      <div>
                                        {n.isLoadingTrans === true ? (
                                          <img
                                            src={cl}
                                            alt='loader'
                                            width='36'
                                          />
                                        ) : (
                                          <Checkbox
                                            checked={
                                              n.ConsultRequire ||
                                              n.is_consultrequire
                                            }
                                            onChange={() =>
                                              this.handleConsultrequire(index)
                                            }
                                            value={
                                              n.ConsultRequire ||
                                              n.is_consultrequire
                                            }
                                            color='primary'
                                          />
                                        )}
                                      </div>
                                    )}
                                  </TableCell>
                                )}
                                <TableCell className={classes.tableCell} sx={{ fontSize: "0.70rem" }}>
                                  {" "}
                                  {n && n.is_order_released && n.is_order_released === true ? (
                                    <div>
                                      <img src={checked} alt={n.rx_no} height={24} width={24} />
                                    </div>
                                  ) : (
                                    <div>
                                      {n.isLoadingTrans === true ? (
                                        <img src={cl} alt="loader" width="36" />
                                      ) : (
                                        <Checkbox
                                          onChange={() => this.handleIsReturnable(index)}
                                          value={n.is_returnable || n.IsReturnable}
                                          checked={
                                            n.IsReturnable ||
                                            n.is_returnable
                                          }
                                          color="primary"
                                        />
                                      )}
                                    </div>
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                  </div>
                  {this.state.isVisibleForPause ? (
                    <Table
                      aria-labelledby='tableTitle'
                      style={{ marginTop: '2%' }}
                    >
                      <TableRow style={{ height: 40 }}>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          {t('Assign.Paid')}
                        </TableCell>
                        <TableCell style={{ textAlign: 'left' }}>
                          {this.state && this.state.isAmountPaid === true
                            ? this.getDueAmount()
                            : `$${(0).toFixed(2)}`}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ height: 40 }}>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          &nbsp;
                        </TableCell>
                        <TableCell className={classes.padiGridCell}>
                          {t('Assign.AmountDue')}
                        </TableCell>
                        <TableCell style={{ textAlign: 'left' }}>
                          {this.state && this.state.isAmountPaid === false
                            ? this.getDueAmount()
                            : `$${(0).toFixed(2)}`}
                        </TableCell>
                      </TableRow>
                    </Table>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className={classes.buttonContainer}>
                  {prescriptionAcDc ? (
                    <Button
                      type='button'
                      color='primary'
                      variant='contained'
                      className={classes.primaryButton}
                      onClick={this.handleBinActivationChange}
                      disabled={!Boolean(selectedBinId)}
                    >
                      {isBinDeactivated ? t('Assign.Activate') : t('Assign.Deactivate')}
                    </Button>
                  ) : null}
                  {is_stocked && itemCount !== 0 ? (
                    <div>
                      &nbsp;
                      {prescriptionRemind ? (
                        <Button
                          type='button'
                          color='primary'
                          variant='contained'
                          className={classes.primaryButton}
                          onClick={() => this.reminderHandler()}
                        >
                          {t('Assign.RemindButton')}
                        </Button>
                      ) : null}
                      &nbsp;
                      {prescriptionConsult ? (
                        <Button
                          type='button'
                          color='primary'
                          variant='contained'
                          className={classes.primaryButton}
                          onClick={() => this.handleConsultClick()}
                        >
                          {t('Assign.ConsultButton')}
                        </Button>
                      ) : null}
                    </div>
                  ) : (
                    ''
                  )}
                  &nbsp;
                  {locationtype_id === LOCATION_TYPE.Kiosk &&
                    isManualOverridePermissionEnabled && (
                      <React.Fragment>
                        <Button
                          type='button'
                          color='primary'
                          variant='contained'
                          className={classes.primaryButton}
                          onClick={() =>
                            this.setState({ isManualOverrideOpen: true })
                          }
                        >
                          {t('Assign.OpenBinButton')}
                        </Button>
                        &nbsp;
                      </React.Fragment>
                    )}
                  <Button
                    type='button'
                    color='primary'
                    variant='contained'
                    className={classes.primaryButton}
                    disabled={
                      (itemCount === 0 ? true : false) ||
                      (this.state && this.state.isLoadingTrans === true)
                    }
                    onClick={() => this.ClearFields()}
                  >
                    {t('Assign.ClearButton')}
                  </Button>
                  &nbsp;
                  {[true, "true"].includes(isIlocalUser) ? (
                    <Button
                      type='button'
                      color='primary'
                      variant='contained'
                      className={classes.primaryButton}
                      disabled={!doesBinClicked}
                      onClick={() => this.setState({ confirmPhantomRemoval: true })}
                    >
                      {t('Assign.PhantomBin.Button')}
                    </Button>
                  ) : null}
                  &nbsp;
                  {!this.state.isVisibleForPause ? (
                    <div>
                      {prescriptionDirectPickup ? (
                        <Button
                          type='button'
                          color='primary'
                          variant='contained'
                          className={classes.primaryButton}
                          disabled={
                            (itemCount === 0 ? true : false) ||
                            (this.state && this.state.isLoadingTrans === true)
                          }
                          onClick={() => this.ManualPickupNotification(0)}
                        >
                          {t('Assign.DirectPickupButton')}
                        </Button>
                      ) : null}
                      &nbsp;
                      {prescriptionAssign === true ? (
                        <React.Fragment>
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            disabled={
                              (itemCount === 0 ? true : false) ||
                              (this.state && this.state.isLoadingTrans === true)
                            }
                            onClick={() => (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) ? this.checkIfFastlaneBinIdIsExistOrNot(0) : this.checkIfBinIsOccupedFromAnotherLocation(0)}
                          >
                            {t('Assign.SaveButton')}
                          </Button>
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            disabled={
                              (itemCount === 0 ? true : false) ||
                              (this.state && this.state.isLoadingTrans === true)
                            }
                            onClick={() => (boxTypeId === BOX_TYPE.FASTLANE && locationtype_id === LOCATION_TYPE.Kiosk) ? this.checkIfFastlaneBinIdIsExistOrNot(1) : this.checkIfBinIsOccupedFromAnotherLocation(1)}
                          >
                            {t('Assign.SavePrintButton')}
                          </Button>
                        </React.Fragment>
                      ) : null}
                      
                    </div>
                  ) : (
                    <div>
                      {!isAlreadyOnHold ? (
                        <div>
                          {isAlreadyAssigned && (
                            <React.Fragment>
                              {prescriptionDirectPickup ? (
                                <Button
                                  type='button'
                                  color='primary'
                                  variant='contained'
                                  className={classes.primaryButton}
                                  disabled={
                                    (itemCount === 0 ? true : false) ||
                                    (this.state &&
                                      this.state.isLoadingTrans === true)
                                  }
                                  onClick={() => this.ManualPickupNotification(1)}
                                >
                                  {t('Assign.DirectPickupButton')}
                                </Button>
                              ) : null}
                              &nbsp;
                              {prescriptionUnAssign === true ? (
                                <Button
                                  type='button'
                                  color='primary'
                                  variant='contained'
                                  className={classes.primaryButton}
                                  onClick={() => this.changeOrderStatus('remove')}
                                  disabled={isAlreadyOnHold ? true : false}
                                >
                                  <i
                                    className={classes.pauseButton}
                                    style={{ margin: '2px' }}
                                  >
                                    remove
                                  </i>
                                </Button>
                              ) : null}
                            </React.Fragment>
                          )}
                          {prescriptionDirectPickup ? (
                            <React.Fragment>
                              {!isAlreadyAssigned && (
                                <Button
                                  type='button'
                                  color='primary'
                                  variant='contained'
                                  className={classes.primaryButton}
                                  disabled={
                                    (itemCount === 0 ? true : false) ||
                                    (this.state &&
                                      this.state.isLoadingTrans === true)
                                  }
                                  onClick={() => this.ManualPickupNotification(2)}
                                >
                                  {t('Assign.DirectPickupButton')}
                                </Button>
                              )}
                            </React.Fragment>
                          ) : null }
                          &nbsp;
                          {prescriptionHoldResume ? (
                            <Button
                              type='button'
                              color='primary'
                              variant='contained'
                              className={classes.primaryButton}
                              onClick={() => this.changeOrderStatus('pause')}
                              disabled={
                                isAlreadyOnHold || isAlreadyAssigned
                                  ? true
                                  : false
                              }
                            >
                              <i
                                className={classes.pauseButton}
                                style={{ margin: '2px' }}
                              >
                                pause
                              </i>
                            </Button>
                          ) : null}
                          
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.handlePrintReceipt()}
                          >
                            {t('Assign.PrintLabel')}
                          </Button>
                          &nbsp;
                        </div>
                      ) : (
                        <div>
                          {prescriptionDirectPickup ? (
                            <Button
                              type='button'
                              color='primary'
                              variant='contained'
                              className={classes.primaryButton}
                              disabled={
                                (itemCount === 0 ? true : false) ||
                                (this.state && this.state.isLoadingTrans === true)
                              }
                              onClick={() => this.ManualPickupNotification(3)}
                            >
                              {t('Assign.DirectPickupButton')}
                            </Button>
                          ) : null}
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.changeOrderStatus('play')}
                            disabled={!isAlreadyOnHold ? true : false}
                          >
                            <PlayArrow
                              className={classes.pauseButton}
                              style={{ margin: '2px' }}
                            />
                          </Button>
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.handlePrintReceipt()}
                          >
                            {t('Assign.PrintLabel')}
                          </Button>
                          &nbsp;
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div id='react-no-print' key='BoxLayout'>
                <Box
                  component='div'
                  id='react-no-print'
                  sx={{ position: 'absolute', top: '60px', right: '20px' }}
                >
                  <TextField
                    id='idsearchtxt'
                    type='text'
                    margin='normal'
                    variant='standard'
                    value={this.state.searchObj.searchTxt}
                    label={t('Assign.Search')}
                    InputProps={{
                      inputProps: { autocomplete: 'off' },
                      form: {
                        autocomplete: 'off',
                      },
                      startAdornment: (
                        <InputAdornment position='start'>
                          <MagnifyIcon />
                        </InputAdornment>
                      ),
                    }}
                    onChange={this.onSearchChange}
                    sx={{ width: '8cm' }}
                  />
                </Box>

                {this.state.locationtype_id === LOCATION_TYPE.Kiosk ? (
                  <React.Fragment>
                    <Grid container sx={{ m: '0px', mt: '2%' }}>
                      <Grid item xs={12}>
                        <Boxlayout
                          BinStatus={this.state.BinStatus}
                          deactivatedBins={this.state.deactivatedBins}
                          selectedBinId={this.state.selectedBinId}
                          expansionUnits={this.state.expansionUnits} //Added by Naresh | DI-329
                          getPrescriptionDetails={this.getPrescriptionDetails}
                          getSelectedBin={this.getSelectedBin}
                          getSelectedUnitName={this.getSelectedUnitName}
                          currentTabIndex={this.state.expansionUnits.findIndex(
                            (x) => x.pos === 'M' || x.pos === 'M22' || x.pos === 'FASTLANE' || x.pos === 'M24'
                          )}
                          isADACompatible={this.state.isADACompatible}
                          ADAData={this.state.ADAData}
                          PatientID={
                            this.state &&
                            this.state.searchedItems &&
                            this.state.searchedItems.PatientID
                          }
                          boxTypeId={this.state.boxTypeId}
                          t={t}
                          allowMultiBinsPickup={this.state.allow_multi_bins_pickup}
                          BoxID={this.state && this.state.box_id}
                          makeFastlaneAPICall={this.state.makeFastlaneAPICall}
                          selectedBox={selectedBox}
                          isViewPermissionAllowed={prescriptionView}
                        />
                      </Grid>
                    </Grid>
                    {!(boxTypeId === BOX_TYPE.FASTLANE) && <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <List sx={{ display: 'flex', flexDirection: 'row' }}>
                        {legend.map((value) => {
                          return (
                            <ListItem disablePadding sx={{ cursor: 'pointer', margin: '0 10px' }}>
                              <ListItemIcon>
                                <span style={{ background: value.color, height: '20px', width: '20px', border: '1px solid #888', borderRadius: '50%' }}>&nbsp;</span>
                              </ListItemIcon>
                              <ListItemText primary={value.label} />
                            </ListItem>
                          );
                        })}
                      </List>
                    </div>}
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12}>
                        <Table>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                ) : this.state.locationtype_id === LOCATION_TYPE.Home ? (
                  <Box
                    component='div'
                    sx={{ height: '100%', width: '100%', textAlign: 'center' }}
                  >
                    <HomeIcon
                      style={{ height: '100%', width: '50%', color: '#0a5d66' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Work ? (
                  <Box
                    component='div'
                    sx={{ height: '100%', width: '100%', textAlign: 'center' }}
                  >
                    <WorkIcon
                      style={{ height: '100%', width: '50%', color: '#0a5d66' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Courier ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <img
                      src={courierIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}
                    >
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.Courier')}
                        </label>
                        {this.state.courier_type &&
                          this.state.courier_type.length > 0
                          ? this.state.courier_type.map((val) => {
                            return (
                              <div>
                                <FormControlLabel
                                  label={
                                    <span style={{ color: '#000' }}>
                                      {val}
                                    </span>
                                  }
                                  control={
                                    <Checkbox
                                      value={val}
                                      color='primary'
                                      checked={
                                        this.state
                                          .default_courier_selected === val
                                      }
                                      onClick={() =>
                                        this.checkBoxHandler(val)
                                      }
                                    />
                                  }
                                />
                              </div>
                            );
                          })
                          : ''}
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Courier.TrackingNumber')}
                        </label>
                        <br />
                        <input
                          type='text'
                          style={{
                            width: '100%',
                            borderRadius: '5px',
                            padding: '5px',
                            height: '45px',
                            fontSize: '15px',
                          }}
                          value={this.state.courier_tracking}
                          onChange={(evt) => this.courierTrackingHandler(evt)}
                          placeholder='Scan or Enter Tracking Number'
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ mt: '5%', mb: '2%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Other ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <OtherIcon
                      style={{ height: '100%', width: '50%', color: '#0a5d66' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Counter ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <img
                      src={counterIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Counter.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Counter.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Counter.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.Counter.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ mt: '5%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Curbside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <img
                      src={curbsideIcon}
                      style={{
                        height: '35%',
                        width: '50%',
                        color: '#0a5d66',
                        marginBottom: '-10%',
                      }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.CurbSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ mt: '5%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Bedside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}
                  >
                    <img
                      src={inpatientIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Assign.BedSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}
                        >
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  ''
                )}
              </div>
              <div>
                <Dialog
                  maxWidth={'sm'}
                  open={this.state.openMessage}
                  keepMounted
                  onClose={this.handleClose}
                  aria-labelledby='alert-dialog-slide-title'
                  aria-describedby='alert-dialog-slide-description'
                >
                  <div className={classes.dialogBackground}>
                    <DialogTitle id='alert-dialog-title'>
                      <span className={classes.dialogTitleColor}>
                        {t('Assign.MessageText')}
                      </span>
                    </DialogTitle>
                    <DialogContent className={classes.dialogContentColor}>
                      {t('Assign.SelectBinToContinue')}
                    </DialogContent>
                    <DialogActions className={classes.alignButton}>
                      <Button
                        onClick={this.handleClose}
                        className={classes.buttonColor}
                      >
                        {t('Assign.OkButton')}
                      </Button>
                    </DialogActions>
                  </div>
                </Dialog>
              </div>
              {this.state.detailDialogOpen ? (
                <Manualconsultation
                  detailDialogOpen={this.state.detailDialogOpen}
                  selectedObject={this.state.searchedItems}
                  stockCode={stockCode}
                  pickupCode={pickupCode}
                  boxId={this.state.box_id}
                  accountDetails={this.state.accountDetails}
                  pharmacyDetails={this.state.pharmacyDetails}
                  onPopupClose={this.handleConsultClose}
                  searchedRxItems={searchedRxItems}
                />
              ) : null}
              {isManualOverrideOpen && (
                <PatientManulOverride
                  detailDialogOpen={isManualOverrideOpen}
                  selectedObject={{
                    binid: selectedBinId,
                    kiosk_box_id: selectedBox.kiosk_box_id,
                    pmid: this.state.pmid,
                    boxid: this.state.box_id,
                    pucode: this.state.pickupCode,
                  }}
                  onPopupClose={() =>
                    this.setState({ isManualOverrideOpen: false })
                  }
                  isPatientDetailsVisible={false}
                  isBoxDetailsVisible={false}
                  isManualOverrideVisible={true}
                  isManualConsultVisible={false}
                />
              )}
            </div>
          </div>
        </Paper>

        {/* Print Label Functionality  */}
        <Box component='div' id='Print_AssingPrescription_Label'>
          <PrintTemplate>
            <Dialog
              open={this.state.printDialogOpen || false}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
              PaperProps={{
                sx: { borderRadius: '0px', width: '255px', height: '500px' },
              }}
            >
              <DialogContent sx={{ p: '10px' }}>
                <LabelTemplate
                  style={{ display: 'none' }}
                  stockCode={stockCode || ''}
                  pickupCode={pickupCode || ''}
                  rxNumbers={searchedRxNumbers || ''}
                  boxId={this.state.box_id || ''}
                  ref={(el) => (this.componentRef = el)}
                  accountDetails={this.state.accountDetails || ''}
                  pharmacyDetails={this.state.pharmacyDetails || ''}
                  firstName={this.state.PrintFirstName || ''}
                  lastName={this.state.PrintLastName || ''}
                  dateOfBirth={this.state.PrintDateOfBirth || ''}
                  isCoolItem={this.state.PrintisCoolItem || ''}
                  locationTypeID={this.state.locationtype_id || ''}
                  brandingName={this.state.BrandingName || ''}
                  brandingPhone={this.state.BrandingPhone || ''}
                  boxDetails={this.state.boxDetails}
                  connectionType={0}
                  t={t}
                  bin_id={this.state.binid}
                />
              </DialogContent>
            </Dialog>
          </PrintTemplate>
        </Box>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={this.state.isVerifyingBin || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.BinStatus')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {this.state && this.state.isVerifyingBinMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.confirmBinOkButton}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.OkayButton')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={this.state.confirmPMSDialogOpen || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.DoYouWantToContinue')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {t('Assign.DoYouWantToContinueText')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => this.handlePMSDialogYesEvent(e)}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.ManualConsult.Yes')}
              </Button>
              <Button
                onClick={this.handlePMSDialogNoEvent}
                color='primary'
                className={classes.primaryButton}
              >
                {t('Assign.ManualConsult.No')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div id='react-no-print' className={classes.root}>
          <Dialog
            open={confirmPhantomRemoval || false}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {t('Assign.DoYouWantToContinue')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                {t('Assign.PhantomBin.Confirmation')}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => this.removePhantomBin(e)}
                color='primary'
                className={classes.primaryButton}
                disabled={this.state.loader}
              >
                {t('Assign.ManualConsult.Yes')}
              </Button>
              <Button
                onClick={(e) => this.setState({ confirmPhantomRemoval: false })}
                color='primary'
                className={classes.primaryButton}
                disabled={this.state.loader}
              >
                {t('Assign.ManualConsult.No')}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Box>
    );
  }
}

export default withStyles(styles)(withTranslation()(AssignPrescriptions));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/index.js